var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignInspirationAnimate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-design-inspiration:not(.animated) .animable {opacity: 0;}svg#freepik_stories-design-inspiration.animated #freepik--background-complete--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-design-inspiration.animated #freepik--Floor--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-design-inspiration.animated #freepik--Character--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-design-inspiration.animated #freepik--speech-bubble--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-design-inspiration.animated #freepik--Screen--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-design-inspiration.animated #freepik--Video--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-design-inspiration.animated #freepik--Device--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-design-inspiration.animated #freepik--Note--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-design-inspiration.animated #freepik--Photos--inject-18 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}            @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "238.82px 255.45px"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "animable",
    points: "390.61 142.38 446.02 142.38 446.02 59.44 303.96 59.44 303.96 142.38 381.03 142.38",
    fill: "#ebebeb",
    style: {
      transformOrigin: "374.99px 100.91px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 303.96,
    y: 59.44,
    width: 142.07,
    height: 6.13,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "374.995px 62.505px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "animable",
    points: "380.58 152.64 436 152.64 436 69.69 293.93 69.69 293.93 152.64 371 152.64",
    fill: "#fafafa",
    style: {
      transformOrigin: "364.965px 111.165px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 293.93,
    y: 69.69,
    width: 142.07,
    height: 6.13,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "364.965px 72.755px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 135.35,
    y: 415.32,
    width: 13.85,
    height: 16.47,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "142.275px 423.555px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 73.22,
    y: 414.25,
    width: 62.6,
    height: 18.58,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "104.52px 423.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M149.62,415.81H134.15v-1.56h15.47a.78.78,0,0,1,.78.78h0A.78.78,0,0,1,149.62,415.81Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.275px 415.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M149.62,432.83H134.15v-1.56h15.47a.78.78,0,0,1,.78.78h0A.78.78,0,0,1,149.62,432.83Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.275px 432.05px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 123.51,
    y: 414.25,
    width: 7.4,
    height: 18.58,
    fill: "#ebebeb",
    style: {
      transformOrigin: "127.21px 423.54px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 78.78,
    y: 414.25,
    width: 7.4,
    height: 18.58,
    fill: "#ebebeb",
    style: {
      transformOrigin: "82.48px 423.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M149.2,418.05s-3,.08-6.69.08-6.7,0-6.7-.08,3-.08,6.7-.08S149.2,418,149.2,418.05Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.505px 418.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m149.2 420.52s-3 0.08-6.69 0.08-6.7 0-6.7-0.08 3-0.08 6.7-0.08 6.69 0.03 6.69 0.08z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.505px 420.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m149.2 423.56s-3 0.08-6.69 0.08-6.7 0-6.7-0.08 3-0.08 6.7-0.08 6.69 0.03 6.69 0.08z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.505px 423.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M149.2,426.6s-3,.08-6.69.08-6.7,0-6.7-.08,3-.08,6.7-.08S149.2,426.55,149.2,426.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.505px 426.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M149.2,429.64c0,.05-3,.08-6.69.08s-6.7,0-6.7-.08,3-.08,6.7-.08S149.2,429.59,149.2,429.64Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.505px 429.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 91.37,
    y: 421.89,
    width: 28.16,
    height: 3.35,
    fill: "#ebebeb",
    style: {
      transformOrigin: "105.45px 423.565px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 135,
    y: 433.19,
    width: 14.06,
    height: 10.03,
    fill: "#fafafa",
    style: {
      transformOrigin: "142.03px 438.205px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 75.3,
    y: 432.83,
    width: 59.86,
    height: 10.76,
    fill: "#ebebeb",
    style: {
      transformOrigin: "105.23px 438.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134.72,433.56h15.12a.37.37,0,0,0,.36-.37h0a.36.36,0,0,0-.36-.36H134.72Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "142.46px 433.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m134.72 442.86h15.12a0.36 0.36 0 0 1 0.36 0.36 0.36 0.36 0 0 1-0.36 0.36h-15.12v-0.73a0 0 0 0 1 0 0.01z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "142.46px 443.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m149.06 435.1s-3.11 0.08-6.95 0.08-7 0-7-0.08 3.12-0.08 7-0.08 6.95 0.03 6.95 0.08z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.085px 435.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M149.06,437s-3.11.08-6.95.08-7,0-7-.08,3.12-.09,7-.09S149.06,437,149.06,437Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.085px 436.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m149.06 438.9s-3.11 0.08-6.95 0.08-7 0-7-0.08 3.12-0.09 7-0.09 6.95 0.04 6.95 0.09z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.085px 438.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m149.06 440.79s-3.11 0.09-6.95 0.09-7 0-7-0.09 3.12-0.08 7-0.08 6.95 0.04 6.95 0.08z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "142.085px 440.795px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 136.84,
    y: 444.55,
    width: 14.36,
    height: 27.2,
    fill: "#ebebeb",
    style: {
      transformOrigin: "144.02px 458.15px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 69.45,
    y: 443.59,
    width: 67.39,
    height: 29.49,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "103.145px 458.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m152.32 473.08h-17.32v-1.91h17.32a1 1 0 0 1 1 1 1 1 0 0 1-1 0.91z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.16px 472.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m135 443.59h17.34a0.94 0.94 0 0 1 0.94 0.94 0.94 0.94 0 0 1-0.94 0.94h-17.34v-1.91z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.14px 444.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.2,448.19c0,.05-3.22.09-7.18.09s-7.18,0-7.18-.09,3.21-.08,7.18-.08S151.2,448.15,151.2,448.19Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.02px 448.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.2,451.68c0,.05-3.22.08-7.18.08s-7.18,0-7.18-.08,3.21-.08,7.18-.08S151.2,451.64,151.2,451.68Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.02px 451.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.2,455.17c0,.05-3.22.08-7.18.08s-7.18,0-7.18-.08,3.21-.08,7.18-.08S151.2,455.13,151.2,455.17Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.02px 455.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.2,458.66s-3.22.08-7.18.08-7.18,0-7.18-.08,3.21-.08,7.18-.08S151.2,458.61,151.2,458.66Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.02px 458.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.2,462.15s-3.22.08-7.18.08-7.18,0-7.18-.08,3.21-.08,7.18-.08S151.2,462.1,151.2,462.15Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.02px 462.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.2,465.64s-3.22.08-7.18.08-7.18,0-7.18-.08,3.21-.08,7.18-.08S151.2,465.59,151.2,465.64Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.02px 465.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.2,469.13s-3.22.08-7.18.08-7.18,0-7.18-.08,3.21-.09,7.18-.09S151.2,469.08,151.2,469.13Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.02px 469.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M92.51,460v1.64c0,2-1,3.11-2.89,3.11s-2.9-1.13-2.9-3.11v-6.42c0-2,1-3.11,2.9-3.11s2.89,1.13,2.89,3.11v1.2H90.68v-1.32c0-.89-.39-1.22-1-1.22s-1,.33-1,1.22v6.67c0,.88.39,1.2,1,1.2s1-.32,1-1.2V460Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "89.615px 458.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.53,455.17c0-2,1-3.11,3-3.11s3,1.13,3,3.11v6.42c0,2-1,3.11-3,3.11s-3-1.13-3-3.11Zm1.94,6.55c0,.88.39,1.21,1,1.21s1-.33,1-1.21v-6.67c0-.89-.39-1.22-1-1.22s-1,.33-1,1.22Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "96.53px 458.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m100.68 452.2h1.94v10.59h3.19v1.77h-5.13z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "103.245px 458.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106.5,455.17c0-2,1-3.11,3-3.11s2.94,1.13,2.94,3.11v6.42c0,2-1,3.11-2.94,3.11s-3-1.13-3-3.11Zm1.94,6.55c0,.88.39,1.21,1,1.21s1-.33,1-1.21v-6.67c0-.89-.39-1.22-1-1.22s-1,.33-1,1.22Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "109.47px 458.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.5,452.2v9.53c0,.89.39,1.2,1,1.2s1-.31,1-1.2V452.2h1.83v9.41c0,2-1,3.11-2.89,3.11s-2.89-1.13-2.89-3.11V452.2Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "116.44px 458.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.73,464.56a3.7,3.7,0,0,1-.18-1.52V461.1c0-1.15-.39-1.57-1.27-1.57h-.67v5h-1.94V452.2h2.93c2,0,2.87.94,2.87,2.85v1a2.44,2.44,0,0,1-1.27,2.5c1,.41,1.29,1.34,1.29,2.63v1.91a3.71,3.71,0,0,0,.21,1.5ZM122.61,454v3.79h.76c.72,0,1.16-.31,1.16-1.3v-1.22c0-.88-.3-1.27-1-1.27Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "123.685px 458.395px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M92.09,437.07H90.68l.07-.37H94l-.08.37H92.51l-.73,3.64h-.42Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "92.34px 438.705px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M96.73,437.7l-2.21,3.4c-.37.57-.65.75-1.08.75a1,1,0,0,1-.72-.27l.22-.3a.68.68,0,0,0,.53.22c.26,0,.46-.12.69-.48l.22-.33-.75-3H94l.62,2.56,1.65-2.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "94.725px 439.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.08,439a1.7,1.7,0,0,1-1.71,1.79,1.13,1.13,0,0,1-1.15-.66l-.34,1.74h-.41l.82-4.12h.39l-.1.48a1.54,1.54,0,0,1,1.18-.51A1.23,1.23,0,0,1,100.08,439Zm-.42,0a.88.88,0,0,0-1-.94,1.31,1.31,0,0,0-1.3,1.41.88.88,0,0,0,1,.94A1.31,1.31,0,0,0,99.66,439Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "98.2762px 439.793px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.55,439.46a1.72,1.72,0,0,1,1.74-1.79,1.24,1.24,0,0,1,1.37,1.28,1.71,1.71,0,0,1-1.74,1.79A1.24,1.24,0,0,1,100.55,439.46Zm2.7-.49a.88.88,0,0,0-1-.94,1.32,1.32,0,0,0-1.3,1.41.88.88,0,0,0,1,.94A1.31,1.31,0,0,0,103.25,439Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.105px 439.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.56,437.7l-.53,2.64a1.6,1.6,0,0,1-1.75,1.51,1.92,1.92,0,0,1-1.34-.45l.24-.31a1.56,1.56,0,0,0,1.13.4,1.19,1.19,0,0,0,1.31-1.08l.06-.33a1.55,1.55,0,0,1-1.2.52,1.2,1.2,0,0,1-1.33-1.22,1.67,1.67,0,0,1,1.72-1.71,1.17,1.17,0,0,1,1.18.69l.12-.66Zm-.69,1.21c0-.55-.37-.88-1-.88a1.28,1.28,0,0,0-1.32,1.33c0,.55.37.88,1,.88A1.28,1.28,0,0,0,106.87,438.91Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "105.75px 439.761px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M110.22,437.67l-.08.4H110a1.2,1.2,0,0,0-1.22,1.12l-.3,1.53h-.41l.59-3h.39l-.1.55A1.36,1.36,0,0,1,110.22,437.67Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "109.145px 439.192px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M113.67,437.7l-.6,3h-.39l.1-.47a1.57,1.57,0,0,1-1.18.5,1.22,1.22,0,0,1-1.31-1.28,1.7,1.7,0,0,1,1.7-1.79,1.13,1.13,0,0,1,1.15.66l.13-.63ZM113,439a.88.88,0,0,0-1-.94,1.32,1.32,0,0,0-1.31,1.41.88.88,0,0,0,1,.94A1.32,1.32,0,0,0,113,439Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "111.979px 439.194px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M117.58,439a1.7,1.7,0,0,1-1.7,1.79,1.12,1.12,0,0,1-1.15-.66l-.34,1.74H114l.82-4.12h.39l-.1.48a1.54,1.54,0,0,1,1.18-.51A1.22,1.22,0,0,1,117.58,439Zm-.41,0a.88.88,0,0,0-1-.94,1.31,1.31,0,0,0-1.3,1.41.88.88,0,0,0,1,.94A1.31,1.31,0,0,0,117.17,439Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "115.791px 439.794px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121.23,438.65a2.16,2.16,0,0,1,0,.35l-.35,1.71h-.4l.34-1.72a1.39,1.39,0,0,0,0-.27c0-.43-.26-.68-.78-.68a1.18,1.18,0,0,0-1.23,1.06l-.32,1.61h-.4l.84-4.25h.41l-.34,1.69a1.47,1.47,0,0,1,1.16-.48A.94.94,0,0,1,121.23,438.65Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "119.664px 438.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125,437.7l-2.2,3.4c-.37.57-.65.75-1.09.75a1,1,0,0,1-.71-.27l.21-.3a.72.72,0,0,0,.54.22c.25,0,.45-.12.69-.48l.21-.33-.75-3h.41l.63,2.56,1.64-2.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "123px 439.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.7,227.94q.51,2.42,1,4.74l4.64-1c-.32-1.54-.65-3.11-1-4.72Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "399.52px 229.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.83,230c.34,1.65.67,3.25,1,4.82l4.54-1c-.33-1.55-.66-3.14-1-4.77Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "389.6px 231.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m442.52 228.28 1.7-0.35-0.88-4.45-1.73 0.37c0.31 1.52 0.62 2.99 0.91 4.43z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "442.915px 225.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M436.8,224.87c.31,1.5.61,3,.91,4.4l4.47-.92c-.3-1.43-.61-2.91-.93-4.42Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "439.49px 226.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M406.57,225.9c.33,1.6.66,3.17,1,4.71l4.75-1c-.33-1.53-.65-3.1-1-4.69Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "409.445px 227.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.65,222.76c.33,1.6.65,3.17,1,4.7l4.3-.89c-.32-1.53-.65-3.1-1-4.7Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "424.3px 224.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401.71,226.91c.33,1.6.66,3.18,1,4.72l4.5-.95c-.32-1.53-.65-3.1-1-4.7Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "404.46px 228.805px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M416.44,223.85c.33,1.6.65,3.16,1,4.69l.17,0,4.68-1c-.32-1.54-.65-3.1-1-4.7Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "419.365px 225.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432.15,225.85c.31,1.49.62,3,.91,4.37l4.31-.88c-.31-1.43-.61-2.89-.93-4.4Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "434.76px 227.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411.68,224.84c.33,1.6.66,3.17,1,4.7l4.4-.92c-.32-1.53-.64-3.09-1-4.69Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "414.38px 226.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M387.88,235l.93,4.47,4.55-1-.93-4.43Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "390.62px 236.755px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.78,234c.32,1.51.62,3,.92,4.43l4.62-1c-.3-1.42-.61-2.89-.92-4.4Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "395.55px 235.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M426.3,221.79c.33,1.6.66,3.17,1,4.71l4.44-.92c-.32-1.54-.65-3.12-1-4.72Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "429.02px 223.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m443.58 233.42 1.66-0.34-1-4.87-1.7 0.36c0.39 1.68 0.72 3.3 1.04 4.85z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "443.89px 230.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M437.78,229.59c.34,1.67.67,3.28,1,4.82l4.49-.92c-.32-1.55-.66-3.17-1-4.84Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "440.525px 231.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M397.75,233c.31,1.5.62,3,.91,4.4l4.66-1c-.3-1.42-.6-2.88-.92-4.38Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "400.535px 234.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M412.73,229.9c.31,1.49.61,2.95.9,4.36l4.42-.92c-.3-1.41-.61-2.86-.92-4.35Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "415.39px 231.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.66,228.88l-.17,0c.31,1.49.61,3,.9,4.36l4.87-1c-.3-1.41-.61-2.86-.92-4.35Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "420.375px 230.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M422.7,227.83l.9,4.35,4.31-.89c-.29-1.41-.6-2.87-.91-4.36Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "425.305px 229.555px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407.62,231c.31,1.49.61,2.95.9,4.37l4.77-1c-.3-1.41-.6-2.86-.92-4.35Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "410.455px 232.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M402.76,232l.9,4.38,4.52-.95c-.29-1.41-.6-2.87-.91-4.36Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "405.47px 233.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427.35,226.85c.31,1.5.61,3,.9,4.37l4.47-.92c-.3-1.42-.61-2.88-.92-4.38Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "430.035px 228.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M391.73,229q.51,2.43,1,4.77l4.61-1c-.32-1.54-.66-3.12-1-4.74Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "394.535px 230.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M430.1,216c.32,1.51.63,3,.93,4.46l4.28-.88c-.3-1.47-.62-3-.93-4.48Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "432.705px 217.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M399.3,217.2l-4.64,1c.26,1.24.52,2.49.79,3.75.06.31.12.61.19.91l4.63-1c-.06-.25-.11-.5-.16-.75C399.84,219.77,399.57,218.48,399.3,217.2Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "397.465px 220.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.33,219.25l-4.54.92c.26,1.25.53,2.51.79,3.79.07.32.13.63.2.95l4.52-1-.18-.87C389.85,221.78,389.59,220.5,389.33,219.25Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "387.545px 222.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m440.49 218.49 1.79-0.36-0.89-4.53-1.83 0.39c0.31 1.52 0.63 3.01 0.93 4.5z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "440.92px 216.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M404.16,216.19l-4.49.93c.27,1.28.54,2.58.81,3.89,0,.25.1.5.16.75l4.49-.94c-.06-.3-.13-.6-.19-.9C404.68,218.66,404.42,217.42,404.16,216.19Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "402.4px 218.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434.75,215c.31,1.52.62,3,.93,4.48l4.45-.91-.94-4.51Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "437.44px 216.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m394.29 218.23-4.6 0.94c0.27 1.26 0.53 2.53 0.8 3.82l0.18 0.87 4.6-1-0.19-0.91c-0.27-1.24-0.53-2.49-0.79-3.72z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "392.48px 221.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433.13,230.57q.51,2.49,1,4.8l4.33-.89c-.33-1.55-.67-3.15-1-4.82Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "435.795px 232.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M423.89,212.08l-4.28.9c.28,1.34.56,2.7.85,4.08,0,.18.07.36.11.54l4.29-.89c-.07-.3-.13-.6-.19-.9C424.41,214.55,424.15,213.31,423.89,212.08Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "422.235px 214.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M414,214.14l-4.39.92.83,4c0,.22.09.43.13.64l4.39-.91c-.06-.3-.12-.6-.19-.89C414.54,216.61,414.28,215.37,414,214.14Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "412.285px 216.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m419.24 213.06-4.84 1q0.38 1.83 0.78 3.72l0.18 0.89h0.17l4.67-1-0.11-0.54c-0.29-1.37-0.57-2.73-0.85-4.07z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "417.3px 215.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M409.27,215.13l-4.74,1c.26,1.23.52,2.48.78,3.74.06.3.13.59.19.89l4.73-1c0-.21-.09-.42-.13-.64C409.82,217.77,409.54,216.44,409.27,215.13Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "407.38px 217.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M410.68,220l.92,4.43,4.39-.91c-.3-1.46-.61-2.93-.92-4.43Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "413.335px 221.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M395.7,223.13l.94,4.48,4.63-1c-.31-1.46-.62-2.95-.93-4.46Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "398.485px 224.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M425.3,217q.46,2.25.93,4.44l4.43-.92c-.3-1.46-.61-2.94-.93-4.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "427.98px 218.755px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M385.83,225.15l.95,4.55,4.53-1c-.31-1.48-.63-3-.95-4.51Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "388.57px 226.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m441.55 223.56 1.74-0.36-1-4.79-1.78 0.38q0.54 2.43 1.04 4.77z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "441.9px 220.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M435.75,219.8c.33,1.62.66,3.2,1,4.74l4.46-.91c-.33-1.55-.66-3.14-1-4.77Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "438.48px 221.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M390.73,224.15c.32,1.53.64,3,.94,4.51l4.6-1-.94-4.48Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "393.5px 225.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.71,222.1c.31,1.51.62,3,.93,4.46l4.49-.94c-.3-1.46-.61-2.94-.93-4.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "403.42px 223.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.6,219l-.16,0,.92,4.43,4.84-1-.92-4.43Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "418.32px 220.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.65,218c.31,1.5.62,3,.92,4.44l4.29-.89c-.31-1.46-.61-2.94-.93-4.44Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "423.255px 219.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431.1,220.78c.34,1.61.66,3.18,1,4.72l4.29-.88q-.48-2.33-1-4.74Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "433.745px 222.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.57,221.1c.32,1.5.62,3,.93,4.44l4.74-1c-.31-1.46-.62-2.93-.93-4.43Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "408.405px 222.825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M399.79,242.87c.31,1.51.61,2.95.89,4.32l4.71-1c-.29-1.36-.59-2.8-.91-4.3Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "402.59px 244.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m390.87 249.53 1 5 4.65-1-1.05-4.93z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "393.695px 251.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M395.77,248.53c.37,1.79.71,3.44,1,4.94l4.72-1c-.32-1.49-.66-3.13-1-4.9Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "398.63px 250.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m446.62 248.35 1.58-0.32-0.94-4.78-1.6 0.34c0.34 1.81 0.69 3.41 0.96 4.76z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "446.93px 245.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M436.21,245.59l1,4.71,4.47-.93c-.29-1.33-.63-2.92-1-4.71Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "438.945px 247.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M440.86,244.61l.95,4.73,4.63-1-1-4.75Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "443.65px 246.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.14,243.5l-4.42.92q.54,2.63,1,4.86l4.52-.94c-.32-1.48-.66-3.1-1-4.85Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "418.48px 246.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431.41,246.6c.36,1.81.68,3.38.94,4.69l4.63-1c-.29-1.32-.63-2.9-1-4.69Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "434.195px 248.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.48,243.43c.36,1.75.69,3.38,1,4.86l.22,0,4.75-1c-.32-1.48-.67-3.1-1-4.85Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "423.465px 245.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.74,247.51c.37,1.78.7,3.42,1,4.91l4.76-1c-.32-1.49-.66-3.12-1-4.88Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "403.62px 249.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428.33,231.58c.34,1.65.67,3.25,1,4.78l4.49-.92c-.32-1.54-.66-3.14-1-4.8Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "431.075px 233.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.75,246.48l1,4.89,4.62-1c-.31-1.48-.66-3.11-1-4.86Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "408.56px 248.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411.68,250.7c.36,1.82.68,3.39.94,4.7l4.93-1c-.28-1.32-.62-2.89-1-4.68Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "414.615px 252.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M391.94,254.76c.37,1.86.7,3.47,1,4.81l4.73-1c-.29-1.32-.63-2.92-1-4.75Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "394.805px 256.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433.89,175.73l-1.37.27a3.6,3.6,0,0,1,.86,1.72,3.5,3.5,0,0,1-.32,2.31l1.62-.33Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "433.6px 177.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.84,253.76l1,4.77,4.79-1c-.29-1.32-.63-2.9-1-4.72Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "399.735px 255.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M374.77,189.32a3.65,3.65,0,0,1,.14-1.92l-2.6.52.92,4.64,3.42-.74A3.62,3.62,0,0,1,374.77,189.32Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "374.48px 189.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M426.75,247.57c.37,1.79.68,3.36.95,4.69l4.48-.93-1-4.69Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "429.465px 249.45px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428.69,211.07l-4.43.93c.26,1.23.52,2.47.78,3.73.06.3.12.6.19.9l4.43-.92-.09-.45C429.27,213.85,429,212.45,428.69,211.07Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "426.96px 213.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M416.78,249.65c.37,1.79.68,3.36,1,4.68l4.59-1c-.29-1.31-.63-2.87-1-4.68Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "419.575px 251.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401.81,252.74c.37,1.83.69,3.41.95,4.74l4.83-1c-.29-1.32-.63-2.89-1-4.7Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "404.7px 254.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.77,248.61l-.23,0c.37,1.8.68,3.37.94,4.68l.63-.13,4.41-.92c-.28-1.32-.62-2.89-1-4.67Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "424.53px 250.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M425.69,242.34c.36,1.75.69,3.38,1,4.86l4.41-.91c-.31-1.48-.66-3.11-1-4.86Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "428.395px 244.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M406.81,251.71c.37,1.81.69,3.39.95,4.71l4.69-1-1-4.69Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "409.63px 253.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M410.61,245.48c.36,1.76.69,3.38,1,4.87l4.87-1c-.32-1.48-.66-3.1-1-4.85Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "413.545px 247.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393.76,238.74c.35,1.68.68,3.31,1,4.86l4.65-1c-.33-1.54-.67-3.15-1-4.82Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "396.585px 240.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M388.86,239.74c.35,1.7.69,3.33,1,4.9l4.57-1c-.32-1.55-.67-3.17-1-4.85Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "391.645px 241.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.73,237.72c.34,1.67.68,3.29,1,4.83l4.69-1c-.33-1.53-.67-3.14-1-4.8Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "401.575px 239.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M438.84,234.74c.31,1.5.6,2.95.88,4.32l4.53-.93c-.3-1.38-.6-2.83-.92-4.34Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "441.545px 236.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m444.54 238.07 1.62-0.33-0.86-4.37-1.65 0.35c0.35 1.52 0.61 2.97 0.89 4.35z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "444.905px 235.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434.19,235.72c.31,1.5.6,2.93.88,4.29l4.36-.89-.91-4.32Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "436.81px 237.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M418.46,233.64c.35,1.65.67,3.25,1,4.77l.19,0,4.7-1c-.32-1.53-.66-3.13-1-4.78Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "421.405px 235.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.74,236.69c.34,1.66.67,3.27,1,4.8l4.55-1c-.33-1.53-.66-3.13-1-4.78Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "406.515px 238.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M423.67,232.55c.35,1.65.67,3.25,1,4.78l4.34-.9c-.33-1.53-.66-3.13-1-4.78Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "426.34px 234.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M413.71,234.63c.34,1.65.67,3.24,1,4.78l4.44-.93c-.32-1.53-.66-3.12-1-4.77Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "416.43px 236.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M408.6,235.69c.34,1.65.67,3.25,1,4.78l4.78-1c-.32-1.53-.66-3.12-1-4.77Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "411.49px 237.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M430.34,241.37c.36,1.76.69,3.38,1,4.87l4.57-1c-.32-1.49-.67-3.12-1-4.87Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "433.125px 243.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m445.6 243.3 1.6-0.33-1-4.95-1.62 0.34c0.42 1.78 0.72 3.43 1.02 4.94z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "445.89px 240.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.82,243.89c.31,1.52.61,3,.89,4.35l4.68-1c-.29-1.37-.6-2.81-.91-4.32Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "397.605px 245.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.92,244.89c.31,1.53.62,3,.9,4.39l4.61-1-.92-4.35Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "392.675px 246.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M435.14,240.36c.36,1.76.7,3.39,1,4.88l4.4-.91c-.32-1.49-.67-3.13-1-4.89Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "437.84px 242.34px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M439.79,239.38c.36,1.76.69,3.4,1,4.9l4.57-.93-1.05-4.93Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "442.575px 241.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M419.71,238.74l-.19,0,.88,4.28,4.92-1c-.28-1.35-.59-2.78-.9-4.27Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "422.42px 240.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M404.8,241.84c.3,1.5.6,2.93.88,4.3l4.57-1c-.29-1.36-.59-2.79-.91-4.28Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "407.525px 243.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.73,237.7c.31,1.49.6,2.92.88,4.27l4.37-.9c-.29-1.36-.59-2.79-.91-4.28Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "427.355px 239.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.39,236.72c.31,1.5.6,2.93.88,4.29l4.51-.94-.91-4.29Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "432.085px 238.395px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M409.66,240.83c.31,1.5.6,2.93.88,4.29l4.82-1c-.29-1.36-.59-2.78-.91-4.27Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "412.51px 242.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M414.77,239.77c.3,1.5.6,2.92.87,4.28l4.42-.92h.05c-.28-1.35-.58-2.78-.9-4.27Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "417.44px 241.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M379.6,195.57c.32,1.48.66,3.09,1,4.79l4.6-1c-.35-1.69-.67-3.28-1-4.75Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "382.4px 197.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.88,187.78l.39-.12a5,5,0,0,1,1.21-.14,5.79,5.79,0,0,1,3-.33c-.09-.41-.17-.81-.25-1.2a3.74,3.74,0,0,1-.72-.29l-3.9.81C403.69,186.92,403.79,187.35,403.88,187.78Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "406.045px 186.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M406.54,200.32c.31,1.47.64,3,1,4.59l4.41-.92c-.32-1.59-.64-3.12-.95-4.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "409.245px 202.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411.6,188.59l2.49-.52c-.27-1.3-.51-2.5-.73-3.59l-1.29.27a3.64,3.64,0,0,1-3.59,1.32c.08.37.17.76.25,1.15A6.14,6.14,0,0,1,411.6,188.59Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "411.285px 186.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407.05,185.41a3.59,3.59,0,0,1-1.4-2.2,3.65,3.65,0,0,1,.14-1.92l-3.18.63.92,4.23Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "404.83px 183.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401.44,201.37c.31,1.49.63,3,1,4.6l4.75-1c-.32-1.58-.64-3.12-.94-4.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "404.315px 203.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.6,204.43c.32,1.5.64,3.06,1,4.67l4.62-1-1-4.64Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "389.41px 206.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M399.93,188.77a2.8,2.8,0,0,1,1.92.2l.16,0a4.67,4.67,0,0,1,1.65-1.13c-.09-.45-.18-.89-.27-1.31l-1.72.35a3.55,3.55,0,0,1-2,1.2,3.45,3.45,0,0,1-1,0c.08.37.16.75.24,1.15A2.79,2.79,0,0,1,399.93,188.77Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "401.165px 187.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M391.57,203.41c.31,1.49.64,3,1,4.64l4.65-1c-.33-1.59-.65-3.14-.95-4.62Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "394.395px 205.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.57,202.38c.32,1.49.64,3,1,4.61l4.52-.94c-.33-1.59-.65-3.12-.95-4.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "399.33px 204.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m414.34 188 4.4-0.92c-0.24-1.17-0.46-2.28-0.67-3.29l-0.41-0.23-4.09 0.86c0.24 1.11 0.49 2.3 0.77 3.58z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "416.155px 185.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.17,197.27c.31,1.48.63,3,1,4.59l4.45-.92c-.33-1.59-.64-3.13-.95-4.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "423.895px 199.095px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427.4,181.19l0-.06a3.59,3.59,0,0,1-1.14-2,3.52,3.52,0,0,1,.14-1.91l-4.15.82a3.61,3.61,0,0,1,.66,3.78l.06.29Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "424.825px 179.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M423.55,186.11c-.27-1.31-.51-2.51-.73-3.61l-.34.07a3.65,3.65,0,0,1-2.26,1.47,3.58,3.58,0,0,1-1.9-.15l.68,3.16Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "420.935px 184.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m422.74 182.12z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "422.74px 182.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m412.46 180-0.52 0.1a3.59 3.59 0 0 1 0.43 4.23l0.92-0.19c-0.29-1.68-0.61-3.07-0.83-4.14z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "412.615px 182.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M381.7,205.43q.48,2.26,1,4.71l4.55-1c-.34-1.61-.66-3.17-1-4.67Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "384.475px 207.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411.49,199.29l-.19,0c.31,1.47.64,3,1,4.58h0l4.83-1c-.32-1.58-.64-3.12-.95-4.59Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "414.215px 201.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.24,183.29a3.6,3.6,0,0,1-1.16-4l-3.48.69c.24,1.09.54,2.48.89,4.13Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "414.92px 181.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M416.51,198.24c.31,1.48.64,3,1,4.59l4.31-.89c-.33-1.59-.65-3.12-1-4.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "419.165px 200.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.56,203.2c.31,1.47.62,3,.95,4.53l4.29-.89c-.32-1.55-.63-3.07-.94-4.54Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "420.18px 205.015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M384.19,194.34c-.27-1.33-.52-2.55-.74-3.67l-2.53.52a3.67,3.67,0,0,1-1.87,1h-.17c.21,1,.44,2,.67,3.13Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "381.535px 192.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M412.38,204.28h0c.31,1.48.62,3,.95,4.54l.17,0,4.68-1c-.32-1.55-.64-3.07-.94-4.54Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "415.28px 206.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m382.49 185.9-1.43 0.29a3.61 3.61 0 0 1 0.86 1.71 3.65 3.65 0 0 1-0.72 2.95l2.19-0.47c-0.39-1.8-0.67-3.31-0.9-4.48z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "382.225px 188.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407.59,205.27c.31,1.47.63,3,1,4.54l4.4-.92c-.32-1.55-.64-3.06-.94-4.53Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "410.29px 207.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M402.48,206.33c.31,1.48.63,3,1,4.55l4.74-1c-.32-1.54-.64-3.06-.94-4.53Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "405.35px 208.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m391.7 254.81-5.91 1.19 1 4.91 6-1.3c-0.35-1.34-0.69-2.95-1.09-4.8z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "389.29px 257.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.74,189.67a3.62,3.62,0,0,1-1.68-2.39,3.66,3.66,0,0,1,.14-1.92l-2.57.51c.26,1.17.58,2.67,1,4.47Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "384.685px 187.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.15,192.23c-.26-1.3-.51-2.51-.73-3.61l-2.13.44a3.64,3.64,0,0,1-2,1.09,2.84,2.84,0,0,1-.58,0c.2,1,.42,2,.65,3Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "391.43px 190.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M422.21,202.22c.31,1.48.63,3,1,4.55l4.45-.92c-.32-1.56-.64-3.08-.95-4.56Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "424.935px 204.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.87,187.54a3.6,3.6,0,0,1-1.51-2.3,3.52,3.52,0,0,1,.14-1.91l-2.88.57c.25,1.13.57,2.59.94,4.33Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "394.745px 185.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427,201.22c.31,1.47.63,3,1,4.55l4.29-.88c-.33-1.57-.64-3.09-.95-4.58Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "429.645px 203.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m394.41 192.18 3.41-0.72a2.84 2.84 0 0 1 0.84-2c-0.09-0.47-0.19-0.92-0.27-1.36a4.05 4.05 0 0 1-1-0.32l-3.71 0.77c0.19 1.13 0.45 2.33 0.73 3.63z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "396.17px 189.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431.66,200.24l1,4.58,4.45-.92c-.32-1.57-.64-3.11-.95-4.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "434.385px 202.055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m384.45 194.28 4.7-1c-0.22-1.1-0.43-2.12-0.62-3.08a3.69 3.69 0 0 1-1.36-0.3l-3.51 0.72c0.24 1.12 0.5 2.38 0.79 3.66z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "386.405px 192.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m437.43 203.83 1.94-0.4-0.91-4.63-2 0.42c0.32 1.5 0.64 3.03 0.97 4.61z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "437.915px 201.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.48,183.92l-1.13.23a3.62,3.62,0,0,1,.28,4.49l1.72-.36Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "392.35px 186.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.8,254.7c.07.35.14.68.2,1l4.62-.92-.22-1Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "420.21px 254.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M437.23,250.64c.08.43.16.83.23,1.2l4.51-.9c-.08-.38-.17-.79-.27-1.24Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "439.6px 250.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M397.89,192.19a2.23,2.23,0,0,1-.05-.36l-3.36.69c.31,1.46.65,3,1,4.7l4.56-1-.43-2.14A2.83,2.83,0,0,1,397.89,192.19Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "397.26px 194.525px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432.42,251.65c.08.41.16.79.23,1.14l4.67-.92-.26-1.19Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "434.87px 251.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M441.87,249.66c.09.45.18.87.25,1.26l4.68-.93c-.09-.4-.19-.84-.29-1.3Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "444.335px 249.805px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427.77,252.62l.22,1.09,4.52-.89c-.08-.35-.16-.73-.25-1.13Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "430.14px 252.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M423.18,253.58l-.62.13c.07.37.14.71.2,1l5.08-1c-.07-.33-.15-.7-.24-1.08Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "425.2px 253.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M390.55,198.59l.95,4.5,4.67-1c-.32-1.57-.62-3.06-.92-4.49Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "393.36px 200.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M413.53,193.44l1.59-.33-1-4.67-2.22.46a5.37,5.37,0,0,1,.44.51A6,6,0,0,1,413.53,193.44Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "413.51px 190.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M395.55,197.56c.31,1.42.62,2.92.95,4.48l4.53-1c-.32-1.55-.62-3-.91-4.46Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "398.29px 199.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M384.51,194.57c.31,1.47.65,3.06,1,4.75l4.66-1c-.34-1.68-.66-3.26-1-4.72Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "387.34px 196.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434,189.21c-.34-1.7-.67-3.28-1-4.75l-4.55,1c.31,1.46.64,3,1,4.71Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "431.225px 187.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.48,193.55c.31,1.46.64,3,1,4.72l4.7-1c-.34-1.68-.66-3.25-1-4.7Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "392.33px 195.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428.2,185.15c-.27-1.31-.52-2.53-.74-3.63l-4.43.94c.23,1.09.49,2.29.77,3.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "425.615px 183.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M446.68,248.65c.1.47.18.91.26,1.31l1.58-.31-.26-1.34Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "447.6px 249.135px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M397.62,207.34c.31,1.48.63,3,.95,4.56l4.5-1c-.32-1.55-.63-3.07-.94-4.55Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "400.345px 209.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M419.77,192.15l-1-4.69-4.39.92c.31,1.45.64,3,1,4.67Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "417.075px 190.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.58,191.15c-.35-1.67-.67-3.24-1-4.7l-4.54,1c.3,1.45.64,3,1,4.67Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "421.81px 189.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.23,190.19c-.35-1.68-.67-3.26-1-4.71l-4.39.92c.31,1.45.65,3,1,4.69Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "426.535px 188.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M380.68,200.61c.3,1.45.63,3,1,4.57l4.57-1c-.32-1.58-.63-3.1-.93-4.54Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "383.465px 202.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M412.69,255.76c.07.33.13.65.19.94l5-1-.22-1Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "415.285px 255.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M430.61,195.28c.32,1.49.64,3,1,4.63l4.47-.91c-.33-1.61-.66-3.17-1-4.67Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "433.345px 197.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.59,190.46l1,4.49L435,194c-.32-1.57-.63-3.09-.93-4.53Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "432.295px 192.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M425,191.44l.94,4.47,4.33-.89q-.48-2.36-.93-4.5Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "427.635px 193.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m435.36 194 2.06-0.42-0.9-4.56-2.12 0.45q0.45 2.13 0.96 4.53z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "435.91px 191.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M426,196.26c.31,1.48.63,3,1,4.61l4.3-.89c-.33-1.59-.65-3.14-.95-4.63Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "428.65px 198.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M435.46,183.66l-.73-3.68-1.85.4a4.35,4.35,0,0,1-.33.42c.22,1,.46,2.12.71,3.31Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "434.005px 182.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m434.34 189.15 2.12-0.44-0.94-4.77-2.19 0.47c0.31 1.46 0.67 3.04 1.01 4.74z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "434.895px 186.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.15,192.44l.94,4.47,4.48-.93-.92-4.48Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "422.86px 194.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.35,198.4a7.15,7.15,0,0,1-2.8-2.29l-2.13.44.94,4.47,4.78-1-.3-1.46A4.66,4.66,0,0,1,405.35,198.4Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "403.28px 198.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m401.22 194.29h-0.18a2.64 2.64 0 0 1-1.12-0.06l0.42 2 2-0.41-0.13-0.18a4.48 4.48 0 0 1-0.99-1.35z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "401.13px 195.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M385.58,199.61q.45,2.16,1,4.53l4.63-1c-.32-1.57-.63-3.07-.92-4.51Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "388.395px 201.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m406.2 198.68 0.27 1.27 4.43-0.93-0.21-1a6.18 6.18 0 0 1-4.49 0.66z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "408.55px 198.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m436.4 198.93 2-0.41-0.93-4.69-2.05 0.43c0.32 1.5 0.65 3.06 0.98 4.67z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "436.91px 196.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.49,193.42c.3,1.41.62,2.9.94,4.45l4.33-.9c-.32-1.55-.62-3-.91-4.46Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "418.125px 195.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m428.45 185.1 4.56-0.94c-0.23-1.13-0.44-2.18-0.64-3.15a3.56 3.56 0 0 1-1.85 1 3.62 3.62 0 0 1-2.74-0.55h-0.11c0.24 1.12 0.5 2.33 0.78 3.64z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "430.34px 183.055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M413.49,193.84a5.8,5.8,0,0,1-1.15,2.78,5.6,5.6,0,0,1-1.35,1.22c.08.37.16.74.23,1.12l.2,0,4.69-1c-.32-1.55-.63-3-.92-4.46Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "413.55px 196.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m402.47 182-0.83 0.16a3.62 3.62 0 0 1 0.37 4.35l1.31-0.27c-0.32-1.75-0.63-3.17-0.85-4.24z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "402.48px 184.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M397.86,258.81c.05.29.11.57.16.83l4.83-.95c-.06-.27-.12-.56-.19-.86Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "400.355px 258.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.77,215.29c.32,1.51.64,3.06,1,4.63l4.53-1c-.33-1.56-.65-3.09-1-4.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "386.535px 217.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407.83,256.76c.06.32.12.62.18.91l4.73-.94c-.07-.29-.14-.61-.21-.94Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "410.285px 256.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m438.45 208.71 1.89-0.39-0.91-4.61-1.94 0.41q0.51 2.25 0.96 4.59z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "438.915px 206.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428,206.12c.31,1.48.63,3,.95,4.53l4.28-.88c-.32-1.55-.64-3.07-.94-4.55Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "430.615px 207.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m381.37 205.49-5.37 1.08 0.95 4.8 5.38-1.16c-0.33-1.62-0.65-3.21-0.96-4.72z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "379.165px 208.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m378.65 192.22a3.61 3.61 0 0 1-1.65-0.22l-3.71 0.74 0.75 3.79 5.27-1.14c-0.24-1.13-0.46-2.19-0.66-3.17z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "376.3px 194.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m439.41 213.31 0.09 0.38 1.83-0.37-0.93-4.72-1.88 0.4c0.29 1.42 0.59 2.85 0.89 4.31z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "439.925px 211.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M382.74,210.39c.32,1.51.64,3.06,1,4.65l4.53-1c-.32-1.58-.64-3.12-.95-4.62Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "385.505px 212.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M423.24,207.13c.31,1.47.63,3,.95,4.52l4.43-.92-.94-4.54Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "425.93px 208.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432.69,205.14c.31,1.49.63,3,.95,4.56l4.45-.92c-.33-1.55-.64-3.08-1-4.58Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "435.39px 206.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m389.6 245-5.77 1.16 0.89 4.48 5.81-1.25c-0.29-1.39-0.6-2.9-0.93-4.39z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "387.18px 247.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m388.52 239.81-5.71 1.19 1 5 5.75-1.24c-0.34-1.62-0.69-3.25-1.04-4.95z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "386.185px 242.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393.64,213.27q.47,2.23,1,4.56l4.63-1c-.32-1.54-.64-3-.94-4.53Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "396.455px 215.065px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393,259.81c.06.28.11.55.16.8l4.76-.94c-.06-.26-.12-.53-.18-.82Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "395.46px 259.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.65,212.24c.31,1.48.62,3,1,4.54l4.49-.95c-.32-1.53-.63-3-.94-4.52Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "401.395px 214.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M388.67,214.29q.48,2.25,1,4.59l4.6-1c-.32-1.55-.64-3.07-1-4.56Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "391.47px 216.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.79,261.05l.15.79,6-1.2c0-.25-.11-.52-.17-.8Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "389.865px 260.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m390.59 249.59-5.84 1.18 1 5.06 5.9-1.27q-0.49-2.26-1.06-4.97z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "388.2px 252.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M438.15,209.08l-4.44.94c.3,1.43.6,2.87.9,4.34l.07.32,4.44-.91c0-.13-.05-.26-.08-.39Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "436.415px 211.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M408.62,210.18c.31,1.47.62,3,.94,4.51l4.39-.92c-.32-1.53-.63-3-.93-4.51Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "411.285px 211.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M418.59,208.1c.3,1.47.62,3,.94,4.51l4.29-.89c-.32-1.53-.63-3-.94-4.52Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "421.205px 209.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m385.21 224c-0.26-1.28-0.53-2.55-0.79-3.8l-5.49 1.11 0.95 4.83 5.53-1.2c-0.07-0.27-0.13-0.59-0.2-0.94z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "382.17px 223.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M385.46,225.23l-5.54,1.11.92,4.64,5.57-1.2Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "383.165px 228.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.51,211.24c.31,1.47.63,3,.95,4.52l4.73-1c-.31-1.53-.63-3-.93-4.51Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "406.35px 213.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m382.39 210.46-5.4 1.08 0.94 4.75 5.43-1.17c-0.36-1.59-0.66-3.12-0.97-4.66z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "380.175px 213.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M413.55,209.15l-.17,0c.31,1.47.62,3,.94,4.51l4.84-1c-.32-1.53-.63-3-.94-4.52Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "416.27px 210.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.61,208.37c.32,1.49.64,3,1,4.58l4.64-1c-.32-1.55-.63-3.08-.94-4.56Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "395.43px 210.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433.34,210.1l-4.28.9c.29,1.37.58,2.77.88,4.18l.09.46,4.28-.89-.07-.31C433.94,213,433.64,211.52,433.34,210.1Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "431.685px 212.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m383.41 215.36-5.45 1.1 0.94 4.72 5.47-1.18c-0.37-1.58-0.65-3.12-0.96-4.64z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "381.165px 218.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M387.64,209.39c.32,1.49.64,3,1,4.61l4.6-1c-.32-1.57-.64-3.1-.95-4.59Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "390.44px 211.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m380.38 200.67-5.33 1.07 0.92 4.66 5.35-1.15c-0.32-1.6-0.65-3.12-0.94-4.58z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "378.185px 203.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M402.82,257.79c.06.31.12.6.17.87l4.87-1c-.06-.29-.13-.59-.2-.9Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "405.34px 257.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m386.46 230-5.59 1.13 1 4.9 5.63-1.21c-0.36-1.54-0.69-3.15-1.04-4.82z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "384.185px 233.015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m387.53 235.09-5.66 1.14 0.91 4.56 5.69-1.23c-0.31-1.44-0.62-2.94-0.94-4.47z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "385.17px 237.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m379.34 195.62-5.29 1.07 1 4.88 5.32-1.15c-0.37-1.7-0.72-3.31-1.03-4.8z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "377.21px 198.595px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M384.79,220.17l-.37.07c.26,1.25.53,2.52.79,3.8.07.31.13.63.2.94l.37-.07c-.07-.32-.13-.63-.2-.95C385.32,222.68,385.05,221.42,384.79,220.17Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "385.1px 222.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M390.59,249.59q.57,2.7,1.06,5l.24-.05-1-5Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "391.24px 252.065px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M379.34,195.62c.31,1.49.64,3.1,1,4.8l.29-.06c-.36-1.7-.7-3.31-1-4.79Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "379.985px 197.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.41,215.36c.31,1.52.63,3.06,1,4.64l.37-.08c-.33-1.57-.65-3.12-1-4.63Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "384.095px 217.645px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M380.38,200.67c.29,1.46.61,3,.94,4.58l.32-.07c-.33-1.59-.66-3.12-1-4.57Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "381.01px 202.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M387.53,235.09c.32,1.53.63,3,.94,4.47l.34-.07-.93-4.47Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "388.17px 237.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M388.52,239.81c.35,1.7.7,3.33,1,4.9l.32-.07c-.32-1.57-.66-3.2-1-4.9Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "389.18px 242.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M391.7,254.81c.4,1.85.74,3.46,1,4.79l.16,0c-.26-1.34-.59-2.95-1-4.81Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "392.28px 257.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.46,230c.35,1.64.68,3.25,1,4.82l.36-.08c-.33-1.57-.66-3.17-1-4.82Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "387.14px 232.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393,259.81l-.16,0c.06.28.12.55.17.8l.15,0C393.06,260.36,393,260.09,393,259.81Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "393px 260.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M382.39,210.46c.31,1.51.64,3.07,1,4.66l.36-.08c-.34-1.59-.66-3.14-1-4.65Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "383.07px 212.755px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M385.46,225.23l1,4.55.37-.08-.95-4.55Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "386.145px 227.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.6,245c.33,1.54.64,3,.93,4.39l.29-.06c-.28-1.39-.59-2.86-.9-4.39Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "390.21px 247.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M381.37,205.49c.31,1.52.64,3.1,1,4.72l.35-.07q-.51-2.44-1-4.71Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "382.045px 207.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M379.55,195.33c-.23-1.12-.46-2.16-.67-3.13l-.23,0c.2,1,.42,2,.64,3.16Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "379.1px 193.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.27,204.5c.31,1.5.63,3.06,1,4.67l.34-.07c-.34-1.61-.66-3.17-1-4.67Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "386.94px 206.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M384.25,194.63c.3,1.47.62,3.06,1,4.75l.3-.06c-.36-1.69-.7-3.28-1-4.75Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "384.9px 196.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M391.37,229c.34,1.63.67,3.22,1,4.77l.35-.07q-.48-2.34-1-4.77Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "392.045px 231.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393.42,238.81c.35,1.68.7,3.3,1,4.85l.32-.06c-.32-1.55-.65-3.18-1-4.86Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "394.08px 241.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m383.39 190.38h0.21c-0.39-1.8-0.71-3.3-1-4.47h-0.14c0.26 1.16 0.54 2.67 0.93 4.47z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "383.03px 188.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M387.3,209.46c.31,1.5.63,3,.95,4.62l.36-.08c-.33-1.57-.65-3.12-1-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "387.955px 211.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.43,234.09l.93,4.43.34-.07c-.3-1.44-.6-2.92-.92-4.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "393.065px 236.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.69,219.17l-.36.08c.26,1.25.52,2.53.79,3.82l.18.87.37-.08-.18-.87C390.22,221.7,390,220.43,389.69,219.17Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "390px 221.555px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.45,190.67c.22,1.12.47,2.34.74,3.67l.26-.06c-.29-1.32-.55-2.54-.79-3.65Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "383.95px 192.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M388.31,214.36c.31,1.51.63,3,1,4.6l.36-.08q-.48-2.34-1-4.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "388.99px 216.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M395.49,248.59l1.05,4.93.24-.05c-.3-1.5-.64-3.15-1-4.94Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "396.135px 251.025px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M390.36,224.23c.32,1.53.64,3,.95,4.51l.36-.08c-.3-1.48-.62-3-.94-4.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "391.015px 226.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.6,253.81c.4,1.83.74,3.43,1,4.75l.17,0-1-4.77Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "397.185px 256.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M397.86,258.81l-.17,0c.06.29.12.56.18.82l.15,0C398,259.38,397.91,259.1,397.86,258.81Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "397.855px 259.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.51,244l.92,4.35.28-.06c-.28-1.38-.58-2.83-.89-4.35Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "395.11px 246.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M385.28,199.67c.3,1.44.61,3,.93,4.54l.33-.07q-.51-2.37-1-4.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "385.91px 201.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M406.58,251.76c.38,1.81.72,3.38,1,4.7l.17,0c-.26-1.32-.58-2.9-.95-4.71Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "407.165px 254.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M395.25,197.62c.3,1.43.6,2.92.92,4.49l.33-.07c-.33-1.56-.64-3.06-.95-4.48Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "395.875px 199.835px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.29,212.32c.3,1.48.62,3,.94,4.53l.37-.07c-.33-1.54-.64-3.06-1-4.54Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "398.945px 214.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.34,222.18c.31,1.51.62,3,.93,4.46l.37-.08c-.31-1.46-.62-2.95-.93-4.46Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "400.99px 224.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.25,202.45c.3,1.48.62,3,.95,4.62l.34-.08c-.33-1.59-.65-3.12-1-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "396.895px 204.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M404.48,241.9c.32,1.5.62,2.94.91,4.3l.29-.06c-.28-1.37-.58-2.8-.88-4.3Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "405.08px 244.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.22,192.58c.3,1.45.62,3,1,4.7l.3-.06c-.35-1.68-.69-3.24-1-4.7Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "394.87px 194.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.46,246.54c.38,1.76.72,3.39,1,4.88l.24,0-1-4.89Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "406.08px 248.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M399.67,217.12l-.37.08c.27,1.28.54,2.57.81,3.89.05.25.1.5.16.75l.37-.08c-.06-.25-.11-.5-.16-.75C400.21,219.7,399.94,218.4,399.67,217.12Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "399.97px 219.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m407.83 256.76h-0.17c0.07 0.31 0.14 0.61 0.2 0.9h0.15c-0.01-0.28-0.12-0.58-0.18-0.9z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "407.835px 257.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.39,236.76c.35,1.66.69,3.27,1,4.8l.31-.07c-.31-1.53-.64-3.14-1-4.8Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "404.045px 239.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M402.4,232c.32,1.5.62,3,.92,4.38l.34-.07-.9-4.38Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "403.03px 234.155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393.35,188.28l.21-.05c-.37-1.74-.69-3.2-.94-4.33l-.14,0Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "393.02px 186.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M397.27,207.41c.31,1.48.62,3,.94,4.56l.36-.07c-.32-1.56-.64-3.08-.95-4.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "397.92px 209.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393.42,188.62c.22,1.1.47,2.31.73,3.61l.26,0c-.28-1.3-.54-2.5-.77-3.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "393.915px 190.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401.34,227c.34,1.61.67,3.18,1,4.72l.36-.07c-.32-1.54-.65-3.12-1-4.72Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "402.02px 229.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M416.55,249.69c.38,1.79.72,3.36,1,4.68l.18,0c-.27-1.32-.58-2.89-1-4.68Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "417.14px 252.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m403.32 186.19h0.21l-0.92-4.23h-0.14c0.22 1.11 0.53 2.53 0.85 4.23z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "403px 184.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411.31,224.92c.34,1.59.66,3.16,1,4.69l.35-.07c-.31-1.53-.64-3.1-1-4.7Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "411.985px 227.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M414.45,239.84c.32,1.49.62,2.91.91,4.27l.28-.06c-.27-1.36-.57-2.78-.87-4.28Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "415.045px 241.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M410.31,220.12c.31,1.5.62,3,.93,4.43l.36-.08-.92-4.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "410.955px 222.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M408.26,210.25c.3,1.48.62,3,.93,4.51l.37-.07c-.32-1.53-.63-3-.94-4.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "408.91px 212.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M406.22,200.38c.3,1.48.62,3,.94,4.6l.35-.07c-.33-1.58-.66-3.12-1-4.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "406.865px 202.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M413.37,234.7c.34,1.65.68,3.24,1,4.77l.32-.06c-.31-1.54-.64-3.13-1-4.78Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "414.03px 237.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.43,244.48c.38,1.75.72,3.37,1,4.85l.24-.05q-.45-2.24-1-4.86Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "416.05px 246.875px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.84,198.56l.3,1.46.33-.07-.27-1.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "406.155px 199.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.61,186.51l-.22.05c.09.42.18.86.27,1.31l.22-.09C403.79,187.35,403.69,186.92,403.61,186.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "403.635px 187.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M412.37,230c.32,1.49.62,2.94.92,4.35l.34-.07c-.29-1.41-.59-2.87-.9-4.36Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "413px 232.135px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M409.64,215.06l-.37.07c.27,1.31.55,2.64.83,4,0,.22.09.43.13.64l.37-.08c0-.21-.09-.42-.13-.64Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "409.935px 217.415px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m417.8 254.7h-0.17l0.22 1h0.15c-0.06-0.32-0.13-0.65-0.2-1z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "417.815px 255.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407.24,205.35c.3,1.47.62,3,.94,4.53l.36-.07c-.32-1.55-.64-3.07-1-4.54Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "407.89px 207.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.19,193.48c.29,1.42.6,2.91.92,4.46l.32-.07c-.32-1.55-.64-3-.94-4.45Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "415.81px 195.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.42,237.76c.31,1.49.62,2.92.9,4.27l.29-.06c-.28-1.35-.57-2.78-.88-4.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.015px 239.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M416.18,198.31c.31,1.47.63,3,.95,4.59l.35-.07c-.33-1.58-.66-3.11-1-4.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "416.83px 200.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427.77,252.62l-.17,0c.09.38.17.75.24,1.08l.15,0Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "427.795px 253.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m413.29 184.11h0.2c-0.35-1.65-0.65-3-0.89-4.13h-0.14c0.22 1.09 0.54 2.48 0.83 4.13z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "412.975px 182.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.21,203.27c.3,1.47.62,3,.94,4.54l.36-.08c-.33-1.55-.64-3.06-.95-4.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "417.86px 205.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M422.34,227.9c.31,1.49.62,2.94.92,4.35l.34-.07-.9-4.35Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "422.97px 230.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M418.22,208.17c.31,1.48.62,3,.94,4.52l.37-.08c-.32-1.53-.64-3-.94-4.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "418.875px 210.395px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m413.57 184.44h-0.21c0.22 1.09 0.46 2.29 0.73 3.59h0.25c-0.28-1.31-0.53-2.5-0.77-3.59z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "413.85px 186.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M423.33,232.62c.35,1.65.69,3.25,1,4.78l.32-.07c-.32-1.53-.64-3.13-1-4.78Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "423.99px 234.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.41,193.05c-.35-1.66-.68-3.22-1-4.67l-.26.06,1,4.67Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "414.78px 190.745px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.28,222.84c.33,1.6.66,3.16,1,4.7l.36-.08c-.32-1.53-.64-3.1-1-4.7Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "421.96px 225.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M426.51,247.62c.39,1.78.73,3.35,1,4.67l.18,0c-.27-1.33-.58-2.9-.95-4.69Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "427.1px 249.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M425.4,242.4c.37,1.75.72,3.37,1,4.85l.24-.05c-.3-1.48-.63-3.11-1-4.86Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "426.02px 244.795px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M419.61,213l-.37.08c.28,1.34.56,2.7.85,4.07l.11.54.37-.07c0-.18-.07-.36-.11-.54C420.17,215.68,419.89,214.32,419.61,213Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "419.905px 215.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.28,218l.92,4.43.37-.07c-.3-1.46-.61-2.94-.92-4.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "420.925px 220.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M436,245.64c.38,1.79.72,3.37,1,4.69l.18,0-1-4.71Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "436.59px 247.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433.87,235.78l.91,4.29.29-.06c-.28-1.36-.57-2.79-.88-4.29Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "434.47px 237.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427.68,206.19l.94,4.54.37-.08c-.32-1.54-.64-3.05-.95-4.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "428.335px 208.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.06,211l-.37.07c.29,1.38.58,2.78.88,4.19l.09.45.37-.07-.09-.46C429.64,213.77,429.35,212.37,429.06,211Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "429.36px 213.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M425.64,196.33c.31,1.48.62,3,.95,4.61l.35-.07c-.34-1.59-.66-3.13-1-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "426.29px 198.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m437.23 250.64h-0.17l0.26 1.19h0.14c-0.07-0.36-0.15-0.76-0.23-1.19z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "437.26px 251.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.65,191.5l.92,4.48.32-.07-.94-4.47Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.27px 193.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.73,216.06c.32,1.51.63,3,.93,4.45l.37-.07c-.3-1.46-.61-2.95-.93-4.46Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "430.38px 218.245px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M430.74,220.86c.33,1.6.66,3.18,1,4.72l.36-.08c-.32-1.54-.64-3.11-1-4.72Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "431.42px 223.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m423 182.46h-0.21c0.22 1.1 0.46 2.3 0.73 3.61l0.25-0.05c-0.25-1.27-0.51-2.47-0.77-3.56z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "423.28px 184.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M423,182.11l-.06-.29a2.8,2.8,0,0,1-.15.3v0Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "422.895px 181.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434.86,240.42c.37,1.75.72,3.38,1,4.87l.24,0c-.3-1.49-.64-3.12-1-4.88Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "435.48px 242.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.87,191.09c-.35-1.67-.69-3.24-1-4.69l-.25,0c.29,1.46.61,3,1,4.7Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "424.245px 188.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432.79,230.64c.35,1.66.69,3.26,1,4.8l.32-.07q-.48-2.31-1-4.8Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "433.45px 233.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431.8,225.92c.31,1.5.62,3,.92,4.38l.34-.08c-.29-1.42-.6-2.88-.91-4.37Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "432.43px 228.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M426.66,201.29c.31,1.48.63,3,.95,4.56l.36-.08c-.33-1.55-.65-3.08-1-4.55Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "427.315px 203.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M440.19,218.86c.34,1.63.67,3.22,1,4.77l.36-.07q-.49-2.34-1-4.77Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "440.87px 221.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M439.19,214.06l.94,4.51.36-.08c-.3-1.48-.62-3-.93-4.5Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "439.84px 216.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M436.12,199.29c.31,1.5.63,3,.95,4.61l.36-.07c-.33-1.58-.65-3.11-1-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "436.775px 201.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M445.42,243.64l1,4.75.18,0c-.27-1.35-.59-2.95-1-4.76Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "446.01px 246.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433.26,184.11c-.25-1.19-.49-2.3-.71-3.31a1.81,1.81,0,0,1-.18.21c.2,1,.41,2,.64,3.15Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "432.815px 182.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m446.68 248.65h-0.17c0.1 0.46 0.2 0.9 0.29 1.3h0.14c-0.08-0.39-0.16-0.83-0.26-1.3z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "446.725px 249.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M441.25,223.93c.32,1.51.63,3,.93,4.42l.34-.07c-.29-1.44-.6-2.91-.91-4.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "441.885px 226.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M444.31,238.42l1.05,4.93.24,0c-.3-1.51-.64-3.16-1-4.94Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "444.955px 240.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M437.13,204.2c.32,1.5.63,3,1,4.58l.36-.07q-.48-2.34-1-4.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "437.81px 206.45px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M443.33,233.79c.32,1.51.62,3,.92,4.34l.29-.06c-.28-1.38-.58-2.83-.89-4.35Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "443.935px 235.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M442.24,228.65c.36,1.67.7,3.29,1,4.84l.32-.07c-.32-1.55-.65-3.17-1-4.85Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "442.9px 231.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434.34,189.15c-.36-1.7-.7-3.28-1-4.74l-.26.05c.3,1.47.63,3,1,4.75Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "433.71px 186.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434.1,189.5c.3,1.44.61,3,.93,4.53l.33-.06q-.51-2.37-1-4.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "434.73px 191.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M435.1,194.33c.3,1.5.63,3.06,1,4.67l.34-.07c-.33-1.61-.66-3.17-1-4.67Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "435.77px 196.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M438.52,209l-.37.08.89,4.3c0,.13.06.26.08.39l.38-.08-.09-.38C439.11,211.85,438.81,210.42,438.52,209Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "438.825px 211.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.22,193.61c.3,1.46.62,3,1,4.72l.3-.06c-.36-1.68-.69-3.26-1-4.72Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "389.87px 195.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401.57,252.79c.39,1.82.73,3.4,1,4.72l.17,0c-.26-1.33-.58-2.91-.95-4.74Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "402.155px 255.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M399.48,242.93c.31,1.51.62,2.95.91,4.32l.29-.06c-.28-1.37-.58-2.81-.89-4.32Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "400.08px 245.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.34,228c.33,1.62.67,3.2,1,4.74l.36-.07q-.48-2.33-1-4.74Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "397.02px 230.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M391.24,203.48l1,4.64.35-.07c-.34-1.6-.67-3.15-1-4.64Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "391.915px 205.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.39,237.79c.35,1.67.69,3.28,1,4.82l.31-.06c-.31-1.54-.65-3.16-1-4.83Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "399.045px 240.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M390.25,198.65c.29,1.44.6,2.94.92,4.51l.33-.07-.95-4.5Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "390.875px 200.875px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m402.82 257.79h-0.16c0.07 0.3 0.13 0.59 0.19 0.86h0.14c-0.05-0.26-0.11-0.55-0.17-0.86z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "402.825px 258.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.66,218.15l-.37.08c.26,1.23.52,2.48.79,3.75l.19.91.37-.08c-.07-.3-.13-.6-.19-.91C395.18,220.64,394.92,219.39,394.66,218.15Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "394.965px 220.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M397.4,233.07c.31,1.51.62,3,.92,4.4l.34-.07c-.29-1.42-.6-2.9-.91-4.4Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "398.03px 235.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393.28,213.35c.31,1.49.63,3,1,4.56l.37-.08q-.5-2.33-1-4.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "393.965px 215.59px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M395.33,223.21l.94,4.48.37-.08-.94-4.48Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "395.985px 225.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.26,208.44c.31,1.49.63,3,.95,4.59l.36-.08c-.32-1.56-.64-3.09-1-4.58Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "392.915px 210.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.41,193.23c-.23-1.07-.45-2.08-.65-3h-.23c.19,1,.4,2,.62,3.08Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "388.97px 191.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.46,247.57c.38,1.77.72,3.41,1,4.9l.24-.05c-.3-1.49-.63-3.13-1-4.91Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "401.08px 249.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M402.13,206.4c.31,1.48.62,3,.94,4.55l.37-.07c-.33-1.55-.65-3.07-1-4.55Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "402.785px 208.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M408.26,235.76c.35,1.65.68,3.25,1,4.78l.32-.07c-.32-1.53-.65-3.13-1-4.78Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "408.92px 238.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M410.33,245.54c.37,1.75.72,3.38,1,4.86l.24-.05c-.3-1.49-.63-3.11-1-4.87Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "410.95px 247.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m412.69 255.76h-0.16c0.07 0.33 0.14 0.65 0.21 0.94h0.14c-0.06-0.29-0.12-0.61-0.19-0.94z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "412.705px 256.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.12,196.62c.29,1.42.59,2.91.91,4.46l.33-.06-.94-4.47Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "400.74px 198.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M406.21,226c.33,1.6.66,3.17,1,4.7l.36-.07c-.32-1.54-.65-3.11-1-4.71Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "406.89px 228.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.2,221.17c.32,1.51.63,3,.93,4.45l.37-.08c-.31-1.46-.61-2.94-.93-4.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "405.85px 223.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401.11,201.44c.3,1.49.62,3,.95,4.61l.35-.08c-.34-1.58-.66-3.11-1-4.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "401.76px 203.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411.44,250.75l1,4.69.17,0c-.26-1.31-.58-2.88-.94-4.7Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "412.025px 253.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M404.53,216.11l-.37.08c.26,1.23.52,2.47.78,3.73.06.3.13.6.19.9l.37-.08c-.06-.3-.13-.59-.19-.89C405.05,218.59,404.79,217.34,404.53,216.11Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "404.83px 218.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407.27,231c.31,1.49.62,3,.91,4.36l.34-.07c-.29-1.42-.59-2.88-.9-4.37Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "407.895px 233.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.87,189.3c-.08-.4-.16-.78-.24-1.15l-.24,0c.08.44.18.89.27,1.36Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "398.63px 188.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.15,211.31c.31,1.48.62,3,.94,4.52l.37-.07c-.32-1.54-.64-3-.95-4.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "403.805px 213.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M409.34,240.9c.32,1.49.62,2.92.91,4.28l.29-.06c-.28-1.36-.57-2.79-.88-4.29Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "409.94px 243.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M399.61,194.12l.43,2.14.3-.07-.42-2A1.58,1.58,0,0,1,399.61,194.12Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "399.975px 195.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m422.56 253.71h-0.16l0.22 1h0.14c-0.06-0.29-0.13-0.63-0.2-1z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "422.58px 254.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.13,229c.31,1.49.62,2.94.92,4.35l.07,0,.27,0c-.29-1.41-.59-2.87-.9-4.36Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "417.76px 231.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M412,204.36c.3,1.47.62,3,.94,4.53l.36-.07c-.33-1.55-.64-3.06-.95-4.54Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "412.65px 206.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.07,219.13c.31,1.5.62,3,.92,4.43l.19,0,.18,0-.92-4.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "415.715px 221.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M410.69,198l.21,1,.32-.06c-.07-.38-.15-.75-.23-1.12Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "410.955px 198.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M413,209.26c.3,1.48.61,3,.93,4.51l.29-.06h.08c-.32-1.54-.63-3-.94-4.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "413.65px 211.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M408.73,187.22c-.08-.39-.17-.78-.25-1.15l-.25-.08c.08.39.16.79.25,1.2Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "408.48px 186.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411,199.39c.31,1.48.63,3,.95,4.6l.35-.08c-.33-1.58-.66-3.11-1-4.58Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "411.65px 201.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M416.26,223.89l-.19,0c.34,1.6.66,3.16,1,4.69l.36-.08c-.32-1.53-.64-3.09-1-4.69Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "416.75px 226.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M418.2,233.69l-.08,0c.35,1.65.69,3.24,1,4.77l.32-.07c-.32-1.52-.64-3.12-1-4.77Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "418.78px 236.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M414.4,214.07h-.08l-.29.06c.25,1.23.51,2.47.77,3.73.07.29.13.59.19.89l.37-.08-.18-.89Q414.78,215.9,414.4,214.07Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "414.695px 216.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.31,248.7c.38,1.81.72,3.37,1,4.68l.16,0c-.26-1.31-.57-2.88-.94-4.68Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "421.89px 251.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.19,243.49c.38,1.75.72,3.37,1,4.85l.24-.05c-.3-1.48-.63-3.11-1-4.86Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "420.81px 245.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M419.21,238.85c.32,1.49.62,2.92.9,4.27l.29-.06-.88-4.28Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "419.805px 240.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.26,212l-.37.08c.26,1.23.52,2.47.78,3.73.06.3.12.6.19.9l.37-.08c-.07-.3-.13-.6-.19-.9C424.78,214.47,424.52,213.23,424.26,212Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "424.56px 214.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M419.85,192.51c.29,1.42.59,2.91.91,4.46l.33-.06-.94-4.47Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "420.47px 194.705px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.84,197.33c.3,1.49.62,3,1,4.61l.35-.08c-.34-1.58-.66-3.11-1-4.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "421.515px 199.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M425.93,221.87c.34,1.6.67,3.17,1,4.7l.36-.07c-.32-1.54-.65-3.11-1-4.71Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "426.61px 224.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.93,217.07c.32,1.5.62,3,.93,4.44l.37-.08q-.47-2.19-.93-4.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.58px 219.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428,231.65c.35,1.65.68,3.25,1,4.78l.31-.07c-.31-1.53-.64-3.13-1-4.78Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "428.655px 234.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.86,202.3c.31,1.47.62,3,.94,4.54l.36-.07c-.32-1.55-.64-3.07-1-4.55Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "422.51px 204.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m432.42 251.65h-0.16c0.09 0.4 0.17 0.78 0.25 1.13h0.14c-0.07-0.34-0.15-0.72-0.23-1.13z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "432.455px 252.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431.17,246.64l1,4.69.17,0c-.26-1.31-.58-2.88-.94-4.69Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "431.755px 248.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.07,236.79c.32,1.49.62,2.92.91,4.28l.29-.06c-.28-1.36-.57-2.79-.88-4.29Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "429.67px 238.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M422.88,207.2c.31,1.48.62,3,.94,4.52l.37-.07c-.32-1.54-.64-3.05-.95-4.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "423.535px 209.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427,226.93c.31,1.49.62,2.95.91,4.36l.34-.07c-.29-1.42-.59-2.87-.9-4.37Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "427.625px 229.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.07,192.08c-.35-1.66-.69-3.22-1-4.67l-.27.05,1,4.69Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "419.435px 189.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M419,187.05l-.68-3.16-.25-.08c.21,1,.43,2.12.67,3.29Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "418.535px 185.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M430.06,241.43c.37,1.75.72,3.38,1,4.86l.24,0c-.3-1.49-.63-3.11-1-4.87Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "430.68px 243.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M440.61,244.66c.39,1.79.73,3.38,1,4.71l.18,0-.95-4.73Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "441.2px 247.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434.38,215.08c.31,1.52.63,3,.93,4.48l.37-.08c-.31-1.47-.62-3-.93-4.48Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "435.03px 217.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m427.45 181.18-0.07-0.05v0.06z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "427.415px 181.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M439.5,239.44c.37,1.76.72,3.4,1,4.89l.25-.05c-.31-1.5-.64-3.14-1-4.9Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "440.125px 241.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M430.29,195.35c.3,1.49.62,3,.95,4.63l.35-.07c-.34-1.59-.66-3.14-1-4.63Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "430.94px 197.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.29,190.52q.45,2.14.93,4.5l.32-.07-1-4.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "429.915px 192.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433.71,210l-.37.08c.3,1.42.6,2.87.9,4.34l.07.31.37-.07-.07-.32C434.31,212.89,434,211.45,433.71,210Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "434.01px 212.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M437.43,229.66c.35,1.67.69,3.27,1,4.82l.32-.07c-.32-1.54-.65-3.15-1-4.82Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "438.09px 232.035px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431.31,200.31c.31,1.49.62,3,.95,4.58l.36-.07-1-4.58Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "431.965px 202.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432.33,205.22c.3,1.48.62,3,.94,4.55l.37-.07c-.32-1.55-.64-3.07-.95-4.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "432.985px 207.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M436.44,224.94c.32,1.51.62,3,.93,4.4l.34-.07c-.3-1.43-.6-2.9-.91-4.4Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "437.075px 227.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M441.7,249.7c.1.45.19.86.27,1.24l.15,0c-.07-.39-.16-.81-.25-1.26Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "441.91px 250.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429.52,190.13c-.36-1.68-.69-3.25-1-4.71l-.26.06c.3,1.45.62,3,1,4.71Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "428.89px 187.805px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428.45,185.1c-.28-1.31-.54-2.52-.78-3.62l-.21,0c.22,1.1.47,2.32.74,3.63Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "427.955px 183.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M435.38,219.88q.51,2.42,1,4.74l.36-.08c-.32-1.54-.65-3.12-1-4.74Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "436.06px 222.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M438.52,234.8l.91,4.32.29-.06c-.28-1.37-.57-2.82-.88-4.32Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "439.12px 236.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M391.94,254.76l4.66-.95.24-.05,4.73-1,.24,0,4.77-1,.23,0,4.63-1,.24-.05,4.87-1,.23,0,4.53-1,.23,0,.23,0,4.74-1,.24-.05,4.42-.93.24,0,4.56-1,.24,0,4.4-.93.25,0,4.56-1,.24,0,1.6-.34-.06-.28-1.6.33-.24,0-4.57.93-.25.05-4.4.91-.24,0-4.57,1-.24,0-4.41.91-.24.05-4.75,1-.22,0-.24.05-4.52.94-.24.05-4.87,1-.24.05-4.62,1-.24,0-4.76,1-.24.05-4.72,1-.24.05-4.65,1-.24.05-5.9,1.27,0,.16,5.91-1.18Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "416.505px 249.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.79,259.84l.16,0,4.74-1,.17,0,4.8-1,.16,0,4.84-1,.17,0,4.7-1,.16,0,4.94-1,.17,0,4.6-1,.16,0,.62-.13,4.42-.92.17,0,4.49-.93.16,0,4.64-1,.17,0,4.47-.94.17,0,4.64-1,.17,0,1.58-.34-.06-.28-1.58.32-.18,0-4.63,1-.18,0-4.47.93-.18,0-4.63,1-.17,0-4.48.93-.18,0-4.41.92-.63.13-.16,0-4.59,1-.18,0-4.93,1-.17,0-4.69,1-.17,0-4.83,1-.17,0-4.79,1-.17,0-4.73,1-.16,0-6,1.3,0,.15Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "417.5px 254.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.92,244.89l4.59-.94.31-.06,4.66-1,.31-.06,4.69-1,.32-.06,4.54-.94.32-.07,4.79-1,.32-.07,4.44-.92.31-.07.19,0,4.71-1,.31-.06,4.34-.91.32-.07,4.48-.94.32-.06,4.33-.92.32-.06,4.49-1,.32-.07,1.65-.35-.06-.29-1.66.34-.32.07-4.49.92-.32.07-4.33.89-.32.07-4.49.92-.31.07-4.34.9-.32.07-4.7,1-.19,0-.32.07-4.44.93-.32.06-4.78,1-.32.07-4.55,1-.31.07-4.69,1-.31.06-4.65,1-.32.06-4.57,1-.32.07L383.8,246l0,.16L389.6,245Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "414.55px 239.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M387.88,235l4.55-.93.35-.07,4.62-1,.35-.07,4.65-1,.36-.07,4.51-.93.35-.08,4.75-1,.36-.08,4.4-.91.36-.08.17,0,4.68-1,.36-.07,4.3-.9.35-.08,4.45-.93.35-.07,4.29-.91.36-.07,4.45-.94.36-.08,1.73-.37,0-.28-1.74.36-.36.07-4.46.91-.36.08-4.29.88-.36.08-4.44.92-.36.07-4.3.89-.36.08-4.68,1-.17,0-.36.08-4.4.92-.35.07-4.75,1-.36.07-4.5.95-.36.07-4.64,1-.36.07-4.61,1-.35.07-4.54,1-.36.08-5.63,1.21,0,.17,5.66-1.14Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "412.615px 229.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M385.83,225.15l4.53-.92.37-.08,4.6-.94.37-.08,4.64-.95.37-.08,4.49-.93.37-.07,4.74-1,.37-.08,4.39-.91.37-.08.16,0,4.68-1,.37-.08,4.28-.89.37-.08,4.43-.93.37-.08,4.28-.9.37-.08,4.44-.94.37-.07,1.83-.39-.06-.28-1.83.37-.38.08-4.44.91-.37.07-4.28.89-.37.07-4.43.92-.37.08-4.29.89-.37.07-4.67,1-.17,0-.37.08-4.39.91-.37.08-4.73,1-.37.08-4.49.94-.37.08-4.63,1-.37.08-4.6,1-.37.08-4.52,1-.37.07-5.53,1.2,0,.16,5.54-1.11Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "410.635px 219.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.77,215.29l4.54-.93.36-.07,4.61-.94.36-.08,4.65-1,.36-.08,4.5-.93.36-.07,4.75-1,.36-.07,4.4-.92.36-.07.17,0,4.67-1,.37-.07,4.29-.9.36-.07,4.44-.94.36-.07,4.29-.9.36-.08,4.44-.94.36-.08,1.94-.41-.06-.28-1.94.4-.36.07-4.45.92-.36.07-4.29.88-.36.08-4.45.92-.36.07-4.29.89-.36.08-4.68,1-.17,0-.36.07-4.4.92-.36.07-4.74,1-.37.07-4.5,1-.36.07-4.64,1-.36.08-4.6,1-.36.08-4.53,1-.36.08-5.43,1.17,0,.17,5.45-1.1Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "408.68px 209.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M381.7,205.43l4.57-.93.33-.07,4.64-1,.33-.07,4.68-1,.32-.07,4.54-.94.33-.07,4.78-1,.32-.06,4.43-.93.33-.06.19,0,4.69-1,.33-.07,4.33-.91.33-.06,4.47-.94.33-.07,4.32-.91.32-.07,4.49-.95.32-.07,2.05-.43-.05-.28-2.06.42L435,194l-4.49.92-.32.07-4.33.89-.32.07-4.48.93-.33.06-4.33.9-.32.07-4.69,1-.2,0-.32.06-4.43.93-.33.07-4.78,1-.33.06-4.53,1-.33.07-4.67,1-.33.07-4.63,1-.33.07-4.57,1-.32.07L376,206.4l0,.17,5.36-1.08Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "406.735px 200.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M379.6,195.57l4.65-.94.26-.06,4.71-1,.26-.06,4.74-1,.26-.06,3.36-.69a2.23,2.23,0,0,1,0-.37l-3.41.72-.26,0-4.74,1-.26.06-4.7,1-.26.06-4.64,1-.26,0L374,196.52l0,.17,5.29-1.07Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "385.92px 194.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433,184.16l-4.56.94-.25.05-4.4.91-.25.05-4.55.94-.26,0-4.4.92-.25,0-2.49.52.34.31,2.22-.46.26-.06,4.39-.92.27-.05,4.54-1,.25,0,4.39-.92.26-.06,4.55-1,.26-.05,2.19-.47-.06-.28-2.2.45Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "423.55px 186.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m376.65 191.82-3.42 0.74v0.17l3.77-0.73a3.41 3.41 0 0 1-0.35-0.18z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "375.115px 192.275px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434.68,179.7l-1.62.33a2.31,2.31,0,0,1-.18.35l1.85-.4Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "433.805px 180.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.66,190.63l3.51-.72a3.62,3.62,0,0,1-.43-.24l-3.14.67-.21,0-2.19.47a4.19,4.19,0,0,1-.28.34l2.53-.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "384.045px 190.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393.64,188.58l3.71-.77a4.53,4.53,0,0,1-.48-.27l-3.31.69-.21.05-1.72.36a3.47,3.47,0,0,1-.34.42l2.13-.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "394.32px 188.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M403.61,186.51l3.9-.81a4.43,4.43,0,0,1-.46-.29l-3.52.74-.21,0-1.31.27a3,3,0,0,1-.34.45l1.72-.35Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "404.59px 186.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M413.57,184.44l4.09-.86a2.86,2.86,0,0,1-.42-.29l-3.75.78-.2,0-.92.19a3.52,3.52,0,0,1-.3.45l1.29-.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "414.865px 184px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M423,182.46l4.43-.94.21,0,.11,0a2.06,2.06,0,0,1-.33-.27h-.05l-4.45.92-.2,0h0a3.38,3.38,0,0,1-.24.41l.34-.07Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.115px 181.915px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M380.68,200.61l4.6-.94.3-.06,4.67-1,.3-.06,4.7-1,.3-.06,4.57-.94.3-.07,2.13-.44-.24-.33-2,.41-.3.07-4.56,1-.3.06-4.7,1-.3.06-4.66,1-.3.06-4.6,1-.29.06L375,201.57l0,.17,5.33-1.07Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "388.775px 198.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434,189.21l-4.52.92-.29.06-4.36.9-.29.06-4.51.93-.3.07-4.36.9-.29.06-1.59.33c0,.13,0,.26,0,.4l1.7-.36.3-.06,4.36-.91.3-.07,4.5-.94.3-.06,4.34-.92.3-.06,4.51-1,.3-.06,2.12-.45-.06-.28-2.12.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.005px 191.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M382.74,210.39l4.56-.93.34-.07,4.62-.95.35-.07,4.66-1,.35-.07,4.51-.94.35-.07,4.76-1,.35-.08,4.41-.91.35-.08h0l4.83-1,.35-.07,4.3-.9.35-.08,4.45-.93.35-.07,4.3-.91.35-.07,4.46-1,.34-.07,2-.42-.06-.28-2,.41-.34.07-4.47.91-.35.07-4.3.89-.35.07-4.45.92-.35.08-4.31.89-.35.07-4.83,1h0l-.35.08-4.41.92-.35.07-4.75,1-.35.08-4.52.94-.34.08-4.65,1-.35.07-4.62,1-.34.07-4.55,1-.35.07L377,211.37l0,.17,5.4-1.08Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "407.715px 204.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M384.79,220.17l4.54-.92.36-.08,4.6-.94.37-.08,4.64-1,.37-.08,4.49-.93.37-.08,4.74-1,.37-.07,4.39-.92.29-.06h.08l4.84-1,.37-.08,4.28-.9.37-.08,4.43-.93.37-.07,4.28-.9.37-.08,4.44-.94.37-.08,1.88-.4-.06-.28-1.89.39-.36.07-4.45.92-.37.07-4.28.88-.37.08-4.43.92-.37.07-4.29.89-.37.08-4.84,1h-.08l-.29.06-4.39.92-.37.07-4.73,1-.37.07-4.49.95-.37.07-4.63,1-.37.08-4.6,1-.36.08-4.53,1-.37.08-5.47,1.18,0,.17,5.49-1.11Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "409.65px 214.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.83,230l4.54-.92.36-.07,4.61-1,.36-.07,4.64-1,.37-.07,4.5-.93.36-.08,4.74-1,.37-.08,4.39-.91.19,0,.18,0,4.84-1,.37-.08,4.28-.89.37-.08,4.44-.93.36-.08,4.28-.9.37-.08,4.44-.94.37-.07,1.78-.38-.06-.28-1.79.36-.36.08-4.45.91-.37.08-4.28.88-.37.07-4.43.92-.37.08-4.29.89-.37.07-4.84,1-.18,0-.19,0-4.39.91-.36.08-4.74,1-.37.08-4.49.94-.37.08-4.63,1-.37.08-4.6,1-.36.08-4.53,1-.37.08-5.57,1.2,0,.18,5.59-1.13Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "411.59px 224.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M388.86,239.74l4.56-.93.34-.07,4.63-1,.34-.07,4.66-1,.35-.07,4.52-.93.34-.07,4.77-1,.34-.07,4.41-.92.08,0,.26-.05,4.87-1,.34-.07,4.32-.9.34-.07,4.46-.94.34-.07,4.3-.91.35-.07,4.46-.94.34-.08,1.7-.36-.06-.28-1.7.35-.34.07-4.47.92-.34.07-4.31.88-.34.08-4.47.92-.34.07-4.31.89-.34.07-4.87,1-.27,0-.07,0-4.42.92-.34.07-4.77,1-.34.07-4.52.95-.34.07-4.66,1-.34.07-4.62,1-.34.07-4.55,1-.34.07-5.69,1.23,0,.17,5.71-1.15Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "413.53px 234.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M390.87,249.53l4.62-.94.28-.06,4.69-1,.28-.06,4.72-1,.29-.06,4.58-.94.28-.06,4.82-1,.29-.06,4.42-.92h.05l.29-.06,4.92-1,.29-.06,4.37-.91.28-.06,4.52-1,.28-.06,4.36-.92.29-.06,4.52-1,.29-.06,1.62-.34-.06-.28-1.62.33-.29.06-4.53.93-.29.06-4.36.89-.29.06-4.51.94-.29.06-4.37.9-.29.06-4.92,1-.29.06h-.05l-4.42.92-.28.06-4.82,1-.29.06-4.57,1-.29.06-4.71,1-.29.06-4.68,1-.28.06-4.61,1-.29.06-5.81,1.25,0,.18,5.84-1.18Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "415.47px 244.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.35,198.4a4.66,4.66,0,0,0,.49.16l.36.12a6.18,6.18,0,0,0,4.49-.66l.3-.18a5.6,5.6,0,0,0,1.35-1.22,5.8,5.8,0,0,0,1.15-2.78c0-.14,0-.27,0-.4a6,6,0,0,0-1.15-4,5.37,5.37,0,0,0-.44-.51l-.34-.31a6.14,6.14,0,0,0-2.87-1.37l-.25,0a5.79,5.79,0,0,0-3,.33,4.7,4.7,0,1,1-3.3,8.08l.13.18.24.33A7.15,7.15,0,0,0,405.35,198.4Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "407.823px 193.012px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M402.64,189.34a3.33,3.33,0,0,0,1.39-.25c.81-.37,1.2-1.06,1.29-1s0,.22-.16.5a2.28,2.28,0,0,1-2.21,1,2.92,2.92,0,0,1,.79,2.39,2.77,2.77,0,0,1-1.54,2.06,2.71,2.71,0,0,1,1.19.4,2.67,2.67,0,0,1,1,1.16c.16.36.16.61.12.62s-.4-.88-1.33-1.46a3.8,3.8,0,0,0-1.68-.51,1.62,1.62,0,0,1-.29,0,4.48,4.48,0,0,0,1,1.31,4.69,4.69,0,1,0,3.3-8.08,5,5,0,0,0-1.21.14l-.39.12-.22.09A4.67,4.67,0,0,0,402,189,2.09,2.09,0,0,1,402.64,189.34Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "405.675px 192.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M399.61,194.12a1.58,1.58,0,0,0,.31.09,2.64,2.64,0,0,0,1.12.06l-.07,0c0-.07.43-.06,1-.36a2.7,2.7,0,0,0,1.4-1.93,2.89,2.89,0,0,0-.74-2.28c-.44-.49-.84-.64-.81-.7h0a2.79,2.79,0,0,0-3,.33l-.21.19a2.84,2.84,0,0,0-.84,2,4.37,4.37,0,0,0,.07.73A2.83,2.83,0,0,0,399.61,194.12Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "400.579px 191.506px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M402.63,189.67a2.89,2.89,0,0,1,.74,2.28,2.7,2.7,0,0,1-1.4,1.93c-.57.3-1,.29-1,.36l.07,0,.18,0a1.62,1.62,0,0,0,.29,0c-.13,0-.21,0-.21-.05s.21-.15.61-.17h.29a2.77,2.77,0,0,0,1.54-2.06,2.92,2.92,0,0,0-.79-2.39h0c-.33-.06-.51-.17-.49-.22s.09,0,.22,0A2.09,2.09,0,0,0,402,189l-.16,0h0C401.79,189,402.19,189.18,402.63,189.67Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "402.367px 191.623px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M404.18,189.43a2.26,2.26,0,0,0,1-.84c.17-.28.2-.49.16-.5s-.48.63-1.29,1a3.33,3.33,0,0,1-1.39.25c-.13,0-.21,0-.22,0s.16.16.49.22h0A2.28,2.28,0,0,0,404.18,189.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "403.898px 188.842px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M404.52,196.24s0-.26-.12-.62a2.67,2.67,0,0,0-1-1.16,2.71,2.71,0,0,0-1.19-.4h-.29c-.4,0-.62.12-.61.17s.08,0,.21.05a3.8,3.8,0,0,1,1.68.51C404.12,195.36,404.41,196.28,404.52,196.24Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "402.915px 195.151px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.18,92.51c.46,1.59.92,3.13,1.36,4.65l4.55-1.35c-.45-1.51-.9-3-1.37-4.62Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "97.135px 94.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84.5,95.32,85.88,100l4.45-1.33L89,94Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "87.415px 97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m139.88 89.16 1.66-0.48-1.23-4.37-1.7 0.51c0.39 1.48 0.85 2.93 1.27 4.34z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "140.075px 86.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M133.89,86.22c.44,1.48.86,2.91,1.27,4.31l4.38-1.27c-.42-1.41-.85-2.85-1.28-4.34Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "136.715px 87.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M103.85,89.69l1.35,4.61,4.65-1.37c-.44-1.5-.89-3-1.36-4.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "106.85px 91.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118.62,85.34,120,90l4.22-1.24c-.45-1.5-.9-3-1.37-4.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "121.42px 87.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.08,91.08q.7,2.37,1.36,4.63l4.41-1.31c-.44-1.5-.9-3-1.36-4.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "101.965px 92.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M113.52,86.85l1.35,4.6.16,0,4.59-1.35c-.44-1.5-.89-3-1.36-4.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "116.57px 88.475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M129.34,87.57l1.26,4.29,4.22-1.23c-.41-1.4-.84-2.83-1.27-4.3Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "132.08px 89.095px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M108.85,88.22l1.35,4.6,4.32-1.27c-.45-1.5-.9-3-1.36-4.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "111.685px 89.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M86,100.28c.43,1.5.86,3,1.28,4.39l4.46-1.34c-.42-1.4-.85-2.85-1.29-4.34Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "88.87px 101.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M90.76,98.89c.44,1.49.86,2.94,1.27,4.34l4.53-1.34c-.41-1.4-.84-2.84-1.28-4.31Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "93.66px 100.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M123.18,84c.46,1.57.91,3.11,1.36,4.61l4.35-1.27c-.44-1.51-.9-3-1.36-4.63Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "126.035px 85.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m141.35 94.2 1.62-0.47-1.35-4.73-1.66 0.5c0.48 1.59 0.94 3.18 1.39 4.7z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "141.465px 91.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M135.25,90.85c.48,1.63.94,3.21,1.38,4.72l4.4-1.28q-.67-2.28-1.4-4.74Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "138.14px 92.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M95.63,97.48c.43,1.47.86,2.91,1.26,4.31l4.57-1.36c-.41-1.39-.84-2.82-1.27-4.28Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "98.545px 98.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M110.31,93.18c.43,1.46.84,2.89,1.25,4.27l4.33-1.27c-.41-1.38-.83-2.81-1.27-4.27Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "113.1px 94.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.14,91.76l-.17,0c.43,1.46.85,2.89,1.25,4.27l4.77-1.4-1.26-4.27Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "117.98px 93.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.08,90.31c.43,1.46.84,2.88,1.25,4.27l4.23-1.24c-.41-1.39-.84-2.81-1.27-4.27Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "122.82px 91.825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m105.3 94.65 1.26 4.28 4.66-1.38-1.22-4.27z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "108.26px 96.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.54,96c.43,1.47.85,2.9,1.25,4.29L106.22,99,105,94.75Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "103.38px 97.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.64,89c.43,1.46.84,2.89,1.25,4.28L130.26,92c-.41-1.39-.83-2.82-1.27-4.29Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "127.45px 90.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89.31,93.93q.69,2.38,1.37,4.68l4.51-1.35c-.45-1.51-.9-3.06-1.37-4.64Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "92.25px 95.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126.5,77.9c.44,1.48.87,2.94,1.29,4.37l4.2-1.22c-.43-1.44-.86-2.91-1.3-4.39Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "129.245px 79.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M95.9,81.6l-4.54,1.32c.35,1.21.71,2.44,1.08,3.68l.26.89,4.54-1.34c-.07-.25-.15-.49-.22-.74C96.64,84.13,96.27,82.85,95.9,81.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "94.3px 84.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M86.12,84.45l-4.44,1.28,1.09,3.72c.09.31.18.61.28.92l4.43-1.32-.26-.86C86.85,86.93,86.49,85.68,86.12,84.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "84.58px 87.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m137.06 79.57 1.76-0.51-1.26-4.44-1.79 0.53c0.44 1.5 0.87 2.97 1.29 4.42z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "137.295px 77.095px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.67,80.2l-4.41,1.29c.37,1.26.75,2.53,1.12,3.82.08.24.15.48.22.73l4.4-1.3c-.09-.3-.17-.59-.26-.88C101.38,82.63,101,81.41,100.67,80.2Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "99.13px 83.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.06,76.55c.43,1.49.86,3,1.29,4.39l4.35-1.27c-.42-1.45-.86-2.92-1.3-4.41Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "133.88px 78.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91,83l-4.51,1.31c.37,1.23.74,2.48,1.11,3.74.08.29.17.57.25.86l4.5-1.34c-.09-.3-.18-.59-.26-.89Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "89.42px 85.955px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M130.7,92.2q.7,2.44,1.37,4.7l4.24-1.23q-.66-2.28-1.4-4.72Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "133.505px 93.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120,74.52l-4.2,1.24,1.18,4,.15.53,4.2-1.23-.26-.88Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "118.565px 77.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M110.33,77.37,106,78.63l1.15,3.9.18.62,4.31-1.26c-.09-.29-.18-.58-.26-.88C111.05,79.78,110.69,78.57,110.33,77.37Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "108.82px 80.26px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.44,75.86l-4.74,1.4,1.07,3.65c.09.29.17.58.26.87l.16,0,4.58-1.34-.15-.53Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "113.735px 78.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M105.67,78.74,101,80.1l1.07,3.65c.09.3.18.59.26.88L107,83.26l-.18-.62Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "104px 81.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.47,83.51l1.28,4.35,4.3-1.27c-.42-1.42-.85-2.87-1.28-4.34Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "110.26px 85.055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M92.79,87.81c.44,1.48.87,3,1.29,4.39l4.54-1.35c-.42-1.43-.85-2.89-1.28-4.37Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "95.705px 89.34px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121.8,79.29c.43,1.48.86,2.93,1.28,4.36l4.35-1.27c-.42-1.44-.85-2.89-1.29-4.37Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "124.615px 80.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.12,90.61l1.31,4.47,4.43-1.33c-.42-1.45-.86-2.93-1.3-4.42Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "85.99px 92.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m138.52 84.53 1.71-0.5-1.33-4.7-1.75 0.53c0.47 1.59 0.92 3.14 1.37 4.67z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "138.69px 81.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M132.44,81.26c.46,1.58.92,3.13,1.36,4.64l4.37-1.27L136.79,80Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "135.305px 82.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.92,89.22c.44,1.5.88,3,1.3,4.42l4.51-1.34c-.43-1.44-.86-2.9-1.3-4.39Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "90.825px 90.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97.7,86.38,99,90.74l4.41-1.3q-.63-2.14-1.29-4.35Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "100.555px 87.915px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M112.3,82.1l-.17,0c.44,1.47.86,2.92,1.28,4.35l4.75-1.4c-.42-1.42-.85-2.87-1.28-4.34Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "115.145px 83.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m117.24 80.64 1.28 4.36 4.2-1.24-1.28-4.35z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "119.98px 82.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.89,82.61l1.35,4.62L133.45,86c-.45-1.52-.9-3.07-1.37-4.65Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "130.67px 84.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M102.47,85l1.28,4.35L108.39,88c-.42-1.42-.85-2.87-1.28-4.34Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "105.43px 86.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m98.46 107.15 1.23 4.23 4.62-1.37-1.26-4.2z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "101.385px 108.595px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m90.11 114.51 1.41 4.88 4.56-1.39-1.45-4.83z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "93.095px 116.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.91,113.12q.77,2.63,1.4,4.84l4.63-1.38-1.44-4.8Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "97.925px 114.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M145.58,108.83l1.55-.45-1.33-4.68-1.56.47Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "145.685px 106.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M135,106.92c.51,1.76,1,3.31,1.32,4.62l4.39-1.28c-.4-1.31-.87-2.86-1.4-4.62Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "137.855px 108.59px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139.53,105.57c.51,1.76,1,3.32,1.33,4.64l4.55-1.33c-.4-1.31-.87-2.87-1.4-4.64Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "142.47px 107.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118.79,106.13l-4.33,1.28,1.38,4.76,4.43-1.3c-.44-1.45-.91-3-1.43-4.75Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "117.365px 109.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m130.27 108.31 1.32 4.61 4.54-1.33-1.39-4.6z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "133.2px 109.955px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M119.12,106l1.38,4.76.22-.07,4.65-1.36c-.44-1.46-.91-3-1.42-4.76Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "122.245px 107.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.78,111.7c.51,1.74,1,3.35,1.39,4.81l4.67-1.38q-.66-2.19-1.43-4.78Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "102.81px 113.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126,93.59c.48,1.62.93,3.19,1.37,4.69l4.4-1.28c-.45-1.51-.91-3.08-1.4-4.7Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "128.885px 95.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M104.69,110.27l1.38,4.79,4.53-1.34c-.43-1.45-.91-3-1.42-4.76Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "107.645px 112.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m110.94 114 1.32 4.6 4.83-1.42-1.38-4.58z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "114.015px 115.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.59,119.63c.52,1.83,1,3.41,1.35,4.72L97.57,123q-.6-2-1.41-4.65Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "94.58px 121.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127,37.48l-1.35.38a3.58,3.58,0,0,1,.87,4l1.58-.46Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "126.875px 39.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M96.4,118.24c.52,1.8,1,3.37,1.34,4.67l4.69-1.39-1.4-4.63Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "99.415px 119.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M69.2,55.79a3.58,3.58,0,0,1,0-1.92l-2.55.72,1.29,4.55,3.35-1A3.61,3.61,0,0,1,69.2,55.79Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "68.97px 56.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125.71,109.66c.51,1.75,1,3.3,1.32,4.59l4.4-1.29c-.39-1.28-.86-2.81-1.39-4.58Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "128.57px 111.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.7,73.13l-4.34,1.28c.36,1.2.71,2.42,1.08,3.65.08.3.17.59.26.88L126,77.67c0-.15-.09-.29-.13-.44C125.5,75.84,125.1,74.47,124.7,73.13Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "123.18px 76.035px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.94,112.53c.51,1.76,1,3.3,1.32,4.6l4.5-1.33c-.39-1.28-.85-2.81-1.38-4.57Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "118.85px 114.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.27,116.82c.51,1.8,1,3.35,1.33,4.65l4.73-1.41c-.39-1.29-.86-2.83-1.39-4.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "104.3px 118.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.83,111.1l-.22.06c.51,1.77,1,3.31,1.31,4.59l.61-.17,4.33-1.28c-.39-1.29-.86-2.83-1.38-4.57Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "123.735px 112.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.23,104.53l1.38,4.77,4.33-1.27q-.66-2.18-1.43-4.76Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "127.085px 106.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106.17,115.39,107.5,120l4.59-1.36c-.39-1.28-.85-2.81-1.38-4.58Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "109.13px 117.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M109.45,108.87q.76,2.59,1.39,4.78l4.76-1.41c-.43-1.45-.91-3-1.42-4.75Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "112.525px 110.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M92.12,103.52q.72,2.48,1.39,4.76l4.55-1.36-1.41-4.72Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "95.09px 105.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.31,104.91c.49,1.66,1,3.27,1.4,4.8l4.48-1.34c-.45-1.52-.92-3.11-1.41-4.75Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "90.25px 106.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97,102.1l1.38,4.73,4.58-1.36c-.44-1.5-.91-3.07-1.39-4.7Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "99.98px 103.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M136.72,95.89l1.23,4.24,4.44-1.29c-.4-1.35-.83-2.77-1.27-4.26Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "139.555px 97.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m142.67 98.76 1.6-0.47-1.22-4.29-1.62 0.48c0.44 1.52 0.85 2.92 1.24 4.28z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "142.85px 96.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m132.17 97.24 1.23 4.22 4.27-1.25-1.26-4.21z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "134.92px 98.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.33,96.44c.47,1.62.93,3.18,1.36,4.68l.19-.05,4.61-1.36q-.67-2.25-1.39-4.68Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "119.41px 98.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.89,100.67l1.38,4.71,4.45-1.32q-.68-2.25-1.39-4.68Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "104.805px 102.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121.43,94.94c.48,1.62.93,3.18,1.37,4.68l4.25-1.25-1.39-4.68Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "124.24px 96.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M111.66,97.81c.48,1.62.93,3.18,1.37,4.68l4.35-1.28c-.44-1.49-.91-3-1.39-4.67Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "114.52px 99.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106.66,99.28c.47,1.62.93,3.19,1.37,4.69l4.69-1.38q-.68-2.25-1.39-4.68Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "109.69px 100.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.79,103.19l1.38,4.77,4.47-1.31c-.44-1.46-.91-3.05-1.43-4.77Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "131.715px 104.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m144.16 103.88 1.56-0.46-1.37-4.85-1.59 0.47c0.5 1.74 0.97 3.36 1.4 4.84z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "144.24px 101.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m93.59 108.56 1.24 4.27 4.58-1.36-1.26-4.23z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "96.5px 110.035px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.78,110c.44,1.51.86,3,1.25,4.31l4.52-1.35c-.4-1.34-.83-2.77-1.27-4.26Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "91.665px 111.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M133.49,101.79q.76,2.59,1.39,4.79l4.32-1.26-1.44-4.79Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "136.345px 103.555px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.05,100.44c.5,1.73,1,3.34,1.39,4.81l4.48-1.3-1.45-4.82Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "140.985px 102.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118,101.43l-.18,0c.43,1.47.83,2.87,1.22,4.19l4.82-1.41c-.4-1.33-.81-2.73-1.25-4.19Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "120.84px 102.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M103.36,105.72l1.23,4.21,4.48-1.33c-.39-1.32-.81-2.72-1.25-4.19Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "106.215px 107.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.9,100c.43,1.46.84,2.86,1.22,4.19l4.29-1.25c-.4-1.33-.82-2.73-1.25-4.19Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "125.655px 101.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.46,98.63l1.23,4.21,4.42-1.3c-.4-1.33-.81-2.74-1.25-4.21Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "130.285px 100.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M108.13,104.32c.43,1.47.84,2.87,1.22,4.2l4.72-1.39c-.39-1.33-.81-2.72-1.24-4.18Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "111.1px 105.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M113.14,102.85c.42,1.47.83,2.87,1.22,4.2l4.33-1.28h0c-.4-1.33-.81-2.73-1.25-4.19Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "115.915px 104.315px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M74.52,61.63c.44,1.45.91,3,1.41,4.69L80.43,65c-.48-1.66-.94-3.22-1.35-4.67Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "77.475px 63.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M98.09,51.91l.38-.15a5.13,5.13,0,0,1,1.19-.24,5.86,5.86,0,0,1,3-.57l-.34-1.18a3,3,0,0,1-.74-.23l-3.83,1.13Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "100.205px 50.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.76,64.19l1.33,4.5,4.33-1.28q-.69-2.32-1.32-4.5Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "104.59px 65.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M105.85,52.09l2.44-.72c-.37-1.27-.71-2.44-1-3.51l-1.27.37a3.66,3.66,0,0,1-2,1.49,3.6,3.6,0,0,1-1.45.11c.11.37.23.75.34,1.13A6.11,6.11,0,0,1,105.85,52.09Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "105.43px 49.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.06,49.29a3.62,3.62,0,0,1-1.59-4l-3.12.88c.34,1.09.76,2.48,1.26,4.14Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "98.705px 47.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m96.75 65.66 1.34 4.5 4.66-1.37-1.31-4.51z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "99.75px 67.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M82.21,69.9l1.36,4.57,4.52-1.35c-.46-1.56-.9-3.08-1.33-4.55Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "85.15px 71.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.23,53.21a2.84,2.84,0,0,1,1.93,0,.41.41,0,0,1,.17,0A4.56,4.56,0,0,1,97.88,52l-.37-1.29-1.69.49a3.61,3.61,0,0,1-1.93,1.36,3.46,3.46,0,0,1-1,.12c.1.37.22.74.33,1.12A2.88,2.88,0,0,1,94.23,53.21Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "95.385px 52.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.08,68.48c.44,1.46.89,3,1.35,4.54L93,71.67q-.69-2.34-1.32-4.53Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "90.04px 70.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M92,67.05l1.34,4.52,4.42-1.31c-.45-1.55-.89-3.06-1.32-4.51Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "94.88px 68.66px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m108.54 51.3 4.31-1.3c-0.33-1.15-0.65-2.23-0.93-3.23a3.3 3.3 0 0 1-0.43-0.19l-4 1.18c0.32 1.1 0.67 2.24 1.05 3.54z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "110.17px 48.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.09,60l1.33,4.5,4.37-1.27q-.67-2.34-1.32-4.53Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "118.94px 61.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121,43.45l0-.07a3.61,3.61,0,0,1-1.32-3.81l-4.06,1.15a3.63,3.63,0,0,1,1,3.72l.09.28Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "118.31px 42.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M117.56,48.66l-1-3.54-.33.1a3.6,3.6,0,0,1-4,1.65c.29,1,.6,2,.93,3.09Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "114.895px 47.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m116.44 44.75z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "116.44px 44.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106,43.43l-.51.15a3.59,3.59,0,0,1,.78,4.18l.89-.27Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "106.325px 45.595px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M77.4,71.29c.45,1.48.9,3,1.37,4.61l4.46-1.33c-.46-1.58-.91-3.1-1.34-4.58Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "80.315px 72.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m106.61 62.76-0.19 0.06 1.34 4.49 4.73-1.39-1.31-4.5z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "109.455px 64.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M111.05,46.36a3.58,3.58,0,0,1-1.48-3.93l-3.42,1c.33,1.07.74,2.43,1.23,4Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "108.6px 44.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M111.53,61.31l1.33,4.5,4.22-1.24c-.45-1.55-.89-3-1.31-4.51Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "114.305px 62.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M113,66.17c.42,1.44.86,2.93,1.31,4.45l4.21-1.24c-.44-1.52-.88-3-1.3-4.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "115.76px 67.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M79,60l-1-3.59-2.48.71A3.54,3.54,0,0,1,73.7,58.3l-.17,0c.29,1,.6,2,.92,3.06Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "76.265px 58.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.89,67.67h0l1.32,4.45.17-.05,4.58-1.35c-.45-1.52-.88-3-1.3-4.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "110.925px 69.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m76.62 51.76-1.4 0.4a3.62 3.62 0 0 1 0.51 4.64l2.15-0.64c-0.51-1.77-0.88-3.25-1.26-4.4z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "76.55px 54.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M103.2,69.05c.43,1.44.87,2.92,1.31,4.44l4.31-1.27c-.44-1.52-.88-3-1.3-4.44Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "106.01px 70.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M98.19,70.51,99.51,75l4.65-1.38-1.3-4.44Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "101.175px 72.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m91.36 119.7-5.8 1.66 1.36 4.81c1.52-0.47 3.5-1.06 5.86-1.77-0.4-1.31-0.88-2.88-1.42-4.7z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "89.17px 122.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.16,55.18A3.64,3.64,0,0,1,79.28,51l-2.52.71c.35,1.14.79,2.61,1.33,4.37Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "78.96px 53.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.76,57.13c-.37-1.28-.72-2.46-1-3.54l-2.08.61a3.56,3.56,0,0,1-1.86,1.24,2.84,2.84,0,0,1-.57.1c.27.93.57,1.92.89,3Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "86.005px 56.065px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M117.53,64.83l1.32,4.45L123.2,68c-.45-1.52-.88-3-1.31-4.47Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "120.365px 66.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.09,52.23a3.61,3.61,0,0,1-1.7-2.16,3.68,3.68,0,0,1,0-1.92l-2.83.8c.35,1.11.78,2.54,1.29,4.24Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "88.825px 50.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m122.23 63.43 1.32 4.47 4.21-1.23-1.32-4.48z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "124.995px 65.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89,57.06l3.34-1A2.8,2.8,0,0,1,93,54c-.13-.46-.26-.9-.39-1.33a3.81,3.81,0,0,1-1-.24L88,53.53C88.27,54.6,88.62,55.78,89,57.06Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "90.5px 54.745px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126.78,62.08c.43,1.46.88,3,1.33,4.49l4.37-1.27c-.46-1.54-.9-3-1.33-4.52Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "129.63px 63.675px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M79.25,60l4.61-1.37-.87-3a3.75,3.75,0,0,1-1.38-.19l-3.44,1Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "81.015px 57.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m132.83 65.2 1.9-0.55-1.28-4.55-2 0.58c0.48 1.47 0.92 2.97 1.38 4.52z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "133.09px 62.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M86.42,49l-1.11.32A3.6,3.6,0,0,1,86,53.75l1.69-.5Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "86.5px 51.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M117.37,117.49c.09.34.18.66.27,1l4.54-1.29c-.1-.31-.2-.65-.31-1Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "119.775px 117.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M136.4,111.88c.12.41.23.81.33,1.17l4.42-1.25c-.11-.38-.23-.79-.37-1.22Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "138.775px 111.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M92.48,56.79a2.33,2.33,0,0,1-.08-.36l-3.29,1c.42,1.43.88,3,1.37,4.6L95,60.67l-.61-2.1A2.82,2.82,0,0,1,92.48,56.79Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "92.055px 59.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.69,113.27c.12.4.22.77.32,1.12l4.58-1.3-.36-1.16Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "134.14px 113.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M141,110.53c.13.44.24.84.35,1.22l4.58-1.3c-.12-.39-.25-.81-.38-1.27Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "143.465px 110.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.13,114.61c.11.38.21.74.31,1.07l4.43-1.25c-.1-.35-.21-.71-.34-1.11Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "129.5px 114.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.64,115.94l-.61.18c.1.36.19.7.28,1l5-1.41c-.1-.33-.21-.68-.32-1.06Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "124.67px 115.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M85.68,63.76c.41,1.4.85,2.87,1.31,4.41l4.58-1.36c-.45-1.53-.88-3-1.28-4.4Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "88.625px 65.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M108.17,56.77l1.55-.45c-.47-1.64-.92-3.17-1.33-4.59l-2.18.65a4.34,4.34,0,0,1,.49.47A5.92,5.92,0,0,1,108.17,56.77Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "107.965px 54.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M90.58,62.33c.42,1.39.85,2.86,1.31,4.38l4.44-1.31c-.45-1.53-.87-3-1.28-4.38Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "93.455px 63.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M79.33,60.24c.43,1.44.9,3,1.39,4.65l4.57-1.36c-.48-1.65-.93-3.2-1.34-4.63Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "82.31px 61.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.27,50.9c-.48-1.66-.93-3.22-1.35-4.65l-4.46,1.32,1.38,4.62Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "125.365px 49.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84.2,58.82l1.38,4.62,4.61-1.36c-.48-1.64-.92-3.18-1.34-4.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "87.195px 60.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.12,47.33c-.37-1.29-.72-2.48-1-3.56l-4.34,1.29,1.06,3.52Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "119.45px 46.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M145.66,109.13c.14.46.26.89.37,1.28l1.55-.43-.37-1.31Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "146.62px 109.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.43,71.91l1.32,4.46,4.41-1.3c-.45-1.52-.88-3-1.31-4.46Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "96.295px 73.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M114.28,55,113,50.39l-4.3,1.27c.42,1.42.88,2.94,1.36,4.57Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "111.49px 53.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M119,53.6c-.47-1.64-.92-3.18-1.33-4.6l-4.45,1.31c.42,1.42.88,3,1.37,4.58Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "116.11px 51.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M123.55,52.27c-.48-1.65-.93-3.19-1.34-4.62l-4.3,1.27c.43,1.42.89,3,1.37,4.6Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "120.73px 50.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M76,66.56c.42,1.43.87,2.93,1.33,4.49l4.48-1.34c-.46-1.55-.89-3-1.3-4.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "78.905px 68.155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M112.36,119l.26.92,4.88-1.38c-.1-.3-.2-.63-.3-1Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "114.93px 118.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125.34,57.23c.43,1.46.89,3,1.35,4.54l4.38-1.28-1.34-4.57Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "128.205px 58.845px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M123.94,52.5c.41,1.4.85,2.88,1.31,4.41l4.4-1.28-1.29-4.44Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "126.795px 54.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M119.38,53.85c.42,1.4.86,2.86,1.31,4.39L124.93,57c-.45-1.53-.88-3-1.28-4.41Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "122.155px 55.415px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M130,55.54l2-.59-1.27-4.47-2.07.62Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "130.33px 53.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.79,58.58l1.34,4.52,4.22-1.23c-.46-1.57-.9-3.09-1.33-4.55Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "123.57px 60.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M129.24,45.26l-1-3.61-1.82.54a3.12,3.12,0,0,1-.29.45c.3,1,.63,2.07,1,3.24Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "127.685px 43.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m128.56 50.81 2.08-0.6-1.32-4.68-2.15 0.64c0.43 1.44 0.9 2.99 1.39 4.64z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "128.905px 48.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M114.68,55.24c.42,1.4.85,2.85,1.3,4.38l4.39-1.29c-.44-1.53-.87-3-1.28-4.39Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "117.525px 56.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m100.42 62.38a7.25 7.25 0 0 1-3-2.06l-2.09 0.61c0.41 1.39 0.85 2.85 1.3 4.37l4.68-1.38c-0.14-0.48-0.28-1-0.41-1.42-0.15-0.04-0.32-0.07-0.48-0.12z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "98.32px 62.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M96,58.61h-.18a3,3,0,0,1-1.12,0c.19.63.39,1.28.58,1.94L97.17,60a2.09,2.09,0,0,0-.14-.17A4.7,4.7,0,0,1,96,58.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "95.935px 59.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M80.8,65.17c.43,1.42.87,2.9,1.33,4.44l4.54-1.35-1.29-4.42Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "83.735px 66.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.28,62.59c.12.41.25.82.37,1.24L106,62.55c-.09-.33-.19-.66-.28-1A6.18,6.18,0,0,1,101.28,62.59Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "103.64px 62.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m131.41 60.39 2-0.56-1.31-4.6-2 0.6c0.39 1.46 0.84 2.99 1.31 4.56z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "131.755px 57.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M110.12,56.59c.41,1.39.85,2.85,1.3,4.36l4.24-1.24c-.44-1.52-.87-3-1.27-4.38Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "112.89px 58.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m122.37 47.25 4.47-1.3c-0.32-1.1-0.62-2.13-0.89-3.09a3.61 3.61 0 0 1-1.77 1.14 3.67 3.67 0 0 1-2.77-0.32h-0.11c0.32 1.1 0.7 2.32 1.07 3.57z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "124.07px 45.055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M108.16,57.17a5.5,5.5,0,0,1-2.17,4.2c.11.36.22.72.32,1.09l.19-.06,4.6-1.35c-.44-1.52-.87-3-1.27-4.37Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "108.545px 59.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m96.22 46.21-0.81 0.23a3.61 3.61 0 0 1 1 1.64 3.56 3.56 0 0 1-0.28 2.67l1.28-0.38c-0.49-1.67-0.88-3.06-1.19-4.16z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "96.41px 48.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97.82,123.2c.08.28.15.55.23.81l4.73-1.34c-.08-.27-.16-.55-.25-.84Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "100.3px 122.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M80.27,81c.43,1.48.88,3,1.34,4.54L86,84.16l-1.32-4.5Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "83.135px 82.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.59,120.35c.09.31.17.61.25.88l4.64-1.31-.28-.92Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "110.035px 120.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134.24,70l1.85-.54-1.28-4.52-1.89.57Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "134.505px 67.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M123.65,68.24,125,72.68l4.19-1.22c-.44-1.52-.88-3-1.31-4.47Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "126.42px 69.835px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m77.08 71.38-5.26 1.51 1.34 4.71c1.45-0.45 3.22-1 5.27-1.59-0.43-1.6-0.91-3.14-1.35-4.63z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "75.125px 74.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m73.31 58.37a3.56 3.56 0 0 1-1.69-0.1l-3.64 1 1.02 3.73 5.17-1.56c-0.29-1.07-0.59-2.11-0.86-3.07z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "71.075px 60.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M135.57,74.49c0,.12.07.25.11.37l1.8-.52-1.31-4.62-1.84.55C134.74,71.65,135.15,73.06,135.57,74.49Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "135.905px 72.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M78.84,76.15l1.35,4.56,4.45-1.33c-.46-1.54-.9-3.06-1.33-4.53Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "81.74px 77.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M119,69.63c.43,1.45.86,2.92,1.31,4.43l4.35-1.27c-.45-1.51-.88-3-1.31-4.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "121.83px 71.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.2,66.89c.44,1.46.88,3,1.32,4.46l4.36-1.27c-.45-1.52-.89-3-1.32-4.49Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "131.04px 68.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m88.47 110-5.66 1.63 1.25 4.39c1.55-0.47 3.46-1 5.69-1.71-0.4-1.31-0.83-2.76-1.28-4.31z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "86.28px 113.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m87 105-5.6 1.6 1.39 4.9c1.5-0.46 3.4-1 5.63-1.7-0.42-1.53-0.95-3.13-1.42-4.8z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "84.91px 108.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89.94,78.14c.44,1.46.87,3,1.32,4.47l4.54-1.35c-.44-1.51-.88-3-1.31-4.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "92.87px 79.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93,124.59c.08.27.15.53.22.78l4.67-1.32-.25-.81Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "95.445px 124.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.85,76.71c.43,1.45.87,2.94,1.31,4.45l4.4-1.31c-.44-1.5-.87-3-1.3-4.43Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "97.705px 78.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M85.07,79.56c.44,1.47.88,3,1.33,4.49l4.5-1.33c-.44-1.52-.88-3-1.31-4.47Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "87.985px 81.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87,126.32l.22.77,5.91-1.67c-.08-.25-.16-.51-.24-.79Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "90.065px 125.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m89.83 114.59-5.72 1.64 1.4 5 5.78-1.74c-0.45-1.49-0.94-3.14-1.46-4.9z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "87.7px 117.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134,70.38l-4.35,1.29,1.25,4.25.09.32L135.32,75c0-.13-.08-.25-.11-.38C134.79,73.17,134.37,71.76,134,70.38Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "132.485px 73.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M104.62,73.85c.43,1.44.86,2.92,1.31,4.42l4.3-1.27c-.44-1.5-.88-3-1.3-4.42Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "107.425px 75.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M114.39,71c.43,1.44.86,2.92,1.3,4.42l4.21-1.23c-.45-1.51-.88-3-1.3-4.44Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "117.145px 72.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m82.41 89.55-1.09-3.71-5.39 1.54 1.34 4.73 5.41-1.63z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "79.305px 88.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m82.75 90.72-5.43 1.56 1.29 4.55 5.46-1.65c-0.43-1.46-0.87-2.95-1.32-4.46z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "80.695px 93.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.62,75.32c.42,1.45.86,2.92,1.3,4.43l4.65-1.37c-.45-1.51-.88-3-1.3-4.43Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "102.595px 76.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m78.5 76.24c-2 0.6-3.83 1.11-5.29 1.52l1.31 4.66 5.32-1.61c-0.46-1.56-0.9-3.08-1.34-4.57z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "76.525px 79.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M109.45,72.43l-.17,0c.43,1.44.87,2.92,1.31,4.42l4.74-1.4c-.44-1.5-.87-3-1.29-4.42Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "112.305px 73.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.52,73.34c.43,1.46.88,3,1.33,4.49l4.55-1.35c-.45-1.53-.89-3-1.31-4.47Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "91.46px 74.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m129.26 71.78-4.19 1.22c0.39 1.35 0.8 2.71 1.2 4.1l0.13 0.45 4.2-1.23-0.09-0.31c-0.43-1.42-0.84-2.84-1.25-4.23z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "127.835px 74.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m79.91 81.05-5.34 1.53 1.31 4.63 5.37-1.61c-0.46-1.55-0.9-3.06-1.34-4.55z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "77.91px 84.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.65,74.75c.44,1.47.88,3,1.34,4.52l4.51-1.34-1.32-4.49Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "86.575px 76.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m75.7 66.65-5.22 1.5 1.3 4.57 5.22-1.58c-0.44-1.56-0.88-3.06-1.3-4.49z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "73.74px 69.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M102.69,121.78c.08.3.16.58.24.85l4.77-1.36c-.09-.27-.18-.57-.27-.87Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "105.195px 121.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m84.14 95.42-5.48 1.58 1.34 4.81 5.52-1.66c-0.44-1.54-0.9-3.15-1.38-4.73z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "82.09px 98.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m85.61 100.38-5.55 1.62 1.27 4.48 5.57-1.68z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "83.48px 103.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m74.27 61.71-5.19 1.48 1.35 4.81 5.2-1.57c-0.48-1.69-0.94-3.27-1.36-4.72z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "72.355px 64.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.68,85.73l-.36.11,1.09,3.71.27.93.37-.11c-.1-.31-.19-.61-.28-.92Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "82.185px 88.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89.83,114.59c.52,1.76,1,3.39,1.46,4.87l.23-.07-1.41-4.88Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "90.675px 116.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M74.27,61.71c.42,1.45.88,3,1.36,4.7l.3-.09c-.5-1.67-1-3.24-1.41-4.69Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "75.1px 64.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M79.91,81.05c.44,1.49.88,3,1.34,4.55l.36-.11C81.15,84,80.7,82.43,80.27,81Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "80.76px 83.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M75.7,66.65c.42,1.43.86,2.93,1.31,4.49l.32-.09c-.46-1.56-.91-3.06-1.33-4.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "76.515px 68.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M85.61,100.38l1.29,4.39.34-.1c-.42-1.42-.85-2.89-1.28-4.39Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "86.425px 102.525px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87,105c.49,1.66,1,3.26,1.42,4.8l.31-.1c-.45-1.53-.91-3.14-1.4-4.8Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "87.865px 107.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.36,119.7c.54,1.82,1,3.39,1.42,4.7l.16-.05c-.37-1.31-.83-2.89-1.35-4.72Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "92.15px 122.015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84.14,95.42c.48,1.61.94,3.19,1.4,4.73l.34-.11L84.5,95.32Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "85.01px 97.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93,124.59l-.16,0c.08.28.16.54.24.79l.14,0C93.16,125.12,93.09,124.86,93,124.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "93.03px 124.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M78.5,76.24c.44,1.49.88,3,1.34,4.57l.35-.1-1.35-4.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "79.345px 78.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M82.75,90.72c.45,1.51.89,3,1.32,4.46l.36-.1-1.31-4.47Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "83.59px 92.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.47,110c.45,1.51.88,2.95,1.28,4.31l.28-.09c-.39-1.36-.81-2.8-1.25-4.31Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "89.25px 112.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M77.08,71.38c.44,1.49.89,3,1.35,4.63l.34-.11c-.47-1.59-.92-3.13-1.37-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "77.925px 73.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M74.45,61.39c-.32-1.09-.63-2.11-.92-3.06l-.22,0c.27,1,.57,2,.89,3.1Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "73.88px 59.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.89,70c.43,1.48.88,3,1.34,4.58l.34-.1L82.21,69.9Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "82.73px 72.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M79.08,60.31c.41,1.45.87,3,1.35,4.67l.29-.09c-.49-1.65-1-3.21-1.39-4.65Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "79.9px 62.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89,94l1.38,4.68.35-.1q-.68-2.3-1.37-4.68Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "89.865px 96.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.78,103.62c.49,1.64,1,3.23,1.41,4.75l.32-.09q-.67-2.28-1.39-4.76Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "92.645px 105.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m77.88 56.16 0.21-0.07c-0.54-1.76-1-3.23-1.33-4.37h-0.14c0.38 1.19 0.75 2.67 1.26 4.44z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "77.355px 53.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.31,74.85c.43,1.47.87,3,1.33,4.53l.35-.11c-.46-1.54-.9-3-1.34-4.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "84.15px 77.065px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M90.41,99c.44,1.49.87,2.94,1.29,4.34l.33-.1c-.41-1.4-.83-2.85-1.27-4.34Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "91.22px 101.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M86.48,84.34l-.36.11c.37,1.23.73,2.48,1.1,3.74l.26.86.36-.11c-.08-.29-.17-.57-.25-.86C87.22,86.82,86.85,85.57,86.48,84.34Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "86.98px 86.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M78,56.44,79,60l.26-.07-1.08-3.58Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "78.63px 58.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84.72,79.66,86,84.16l.36-.11c-.45-1.52-.89-3-1.33-4.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "85.54px 81.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.63,113.2,96.08,118l.23-.07q-.63-2.22-1.4-4.84Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "95.47px 115.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.56,89.33c.44,1.49.88,3,1.3,4.42l.36-.11c-.42-1.45-.86-2.92-1.3-4.42Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "88.39px 91.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M96.16,118.31Q97,121,97.57,123l.17,0c-.38-1.3-.82-2.87-1.34-4.67Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "96.95px 120.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m97.82 123.2h-0.17l0.25 0.81h0.15c-0.05-0.26-0.15-0.53-0.23-0.81z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "97.85px 123.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.28,108.65c.44,1.49.87,2.92,1.27,4.26l.28-.08-1.24-4.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "94.055px 110.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M80.51,65.26c.41,1.42.84,2.9,1.3,4.45l.32-.1c-.46-1.54-.9-3-1.33-4.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "81.32px 67.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M105.94,115.46c.53,1.77,1,3.31,1.39,4.6l.17,0-1.33-4.62Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "106.72px 117.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M90.29,62.41c.4,1.4.83,2.87,1.28,4.4l.32-.1c-.46-1.52-.89-3-1.31-4.38Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "91.09px 64.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.49,76.81c.43,1.46.87,2.94,1.31,4.45l.36-.1c-.44-1.51-.88-3-1.31-4.45Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "95.325px 78.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97.34,86.48c.43,1.48.86,2.94,1.28,4.37l.36-.11L97.7,86.38Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "98.16px 88.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.67,67.14q.63,2.19,1.32,4.53l.34-.1L92,67.05Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "92.5px 69.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M103.05,105.81l1.26,4.2.28-.08-1.23-4.21Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "103.82px 107.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.85,57.47c.42,1.43.86,3,1.34,4.61l.29-.09c-.49-1.64-1-3.17-1.37-4.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "89.665px 59.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M104.41,110.35q.77,2.59,1.43,4.78l.23-.07-1.38-4.79Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "105.24px 112.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M96.26,81.49l-.36.11c.37,1.25.74,2.53,1.12,3.81.07.25.15.49.22.74L97.6,86c-.07-.25-.14-.49-.22-.73C97,84,96.63,82.75,96.26,81.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "96.75px 83.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.59,120.35l-.16.05c.09.3.18.6.27.87l.14,0C107.76,121,107.68,120.66,107.59,120.35Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "107.635px 120.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.56,100.77c.48,1.63,1,3.2,1.39,4.7l.32-.09-1.38-4.71Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.415px 103.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.19,96.15c.43,1.46.86,2.89,1.27,4.28l.33-.1c-.4-1.39-.82-2.82-1.25-4.29Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "100.99px 98.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.64,53.25l.2-.06c-.51-1.7-.94-3.13-1.29-4.24l-.13,0Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "87.13px 51.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.09,72c.42,1.45.86,2.94,1.31,4.47l.35-.11-1.32-4.46Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "93.92px 74.185px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.73,53.59c.31,1.08.66,2.26,1,3.54l.25-.07c-.39-1.28-.74-2.46-1.06-3.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "88.355px 55.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M98.72,91.19c.47,1.57.92,3.11,1.37,4.62l.35-.1q-.66-2.26-1.36-4.63Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "99.58px 93.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.71,112.6l1.38,4.58.17-.05c-.37-1.3-.81-2.84-1.32-4.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "116.485px 114.855px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m97.4 50.37 0.21-0.06c-0.5-1.66-0.92-3.05-1.26-4.14h-0.13c0.31 1.14 0.7 2.53 1.18 4.2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "96.915px 48.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M108.49,88.32c.47,1.57.92,3.11,1.36,4.61l.35-.11-1.35-4.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "109.345px 90.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M112.83,103c.43,1.46.85,2.85,1.24,4.18l.29-.08c-.39-1.33-.8-2.73-1.22-4.2Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "113.595px 105.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.11,83.62c.43,1.47.86,2.92,1.28,4.34l.36-.1-1.28-4.35Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "107.93px 85.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M104.27,74c.42,1.45.85,2.92,1.3,4.43l.36-.11c-.45-1.5-.88-3-1.31-4.42Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "105.1px 76.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.44,64.28l1.31,4.51.34-.1-1.33-4.5Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.265px 66.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M111.33,97.91q.72,2.43,1.39,4.68l.31-.1c-.44-1.5-.89-3.06-1.37-4.68Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "112.18px 100.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M114.18,107.49c.51,1.71,1,3.3,1.42,4.75l.24-.07-1.38-4.76Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "115.01px 109.825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.92,62.5c.13.47.27.94.41,1.42l.32-.09c-.12-.42-.25-.83-.37-1.24Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "101.285px 63.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97.72,50.67l-.21.06L97.88,52l.21-.11Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "97.8px 51.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M110,93.28l1.26,4.27.34-.1c-.41-1.38-.82-2.81-1.25-4.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "110.8px 95.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106,78.63l-.36.11,1.15,3.9.18.62.36-.11-.18-.62Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "106.485px 80.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m117.37 117.49-0.17 0.05c0.1 0.33 0.2 0.66 0.3 1h0.14c-0.09-0.39-0.18-0.71-0.27-1.05z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "117.42px 118.015px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M102.86,69.15l1.3,4.44.35-.1c-.44-1.52-.88-3-1.31-4.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "103.685px 71.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M109.83,56.68c.4,1.39.83,2.85,1.27,4.37l.32-.1c-.45-1.51-.89-3-1.3-4.36Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "110.625px 58.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.59,100.07c.44,1.46.85,2.86,1.25,4.19l.28-.09c-.38-1.33-.79-2.73-1.22-4.19Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "123.355px 102.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M111.21,61.41l1.31,4.5.34-.1-1.33-4.5Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "112.035px 63.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m127.13 114.61h-0.16c0.11 0.38 0.22 0.73 0.32 1.06h0.15c-0.1-0.32-0.2-0.67-0.31-1.06z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "127.205px 115.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.17,47.49l.21-.06c-.49-1.61-.9-3-1.23-4l-.14,0Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "106.695px 45.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M112.63,66.27c.42,1.45.85,2.93,1.3,4.45l.35-.1c-.45-1.52-.89-3-1.31-4.45Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "113.455px 68.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M119.73,90.41,121,94.68l.34-.1c-.41-1.39-.82-2.81-1.25-4.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "120.535px 92.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M114,71.08c.42,1.45.85,2.92,1.29,4.42l.36-.1c-.44-1.5-.87-3-1.3-4.42Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "114.825px 73.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.48,47.79l-.2.07c.3,1.07.64,2.24,1,3.51l.25-.07C108.16,50,107.81,48.86,107.48,47.79Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "107.905px 49.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121.1,95q.72,2.43,1.39,4.68l.31-.09c-.44-1.5-.89-3.06-1.37-4.68Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "121.95px 97.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M110,56.23c-.48-1.63-.94-3.15-1.36-4.57l-.26.07c.41,1.42.86,3,1.33,4.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "109.19px 53.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118.26,85.45c.47,1.57.92,3.1,1.36,4.6L120,90l-1.35-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "119.13px 87.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125.48,109.73c.52,1.74,1,3.28,1.38,4.57l.17,0c-.37-1.29-.81-2.84-1.32-4.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "126.255px 112.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124,104.61c.51,1.72,1,3.3,1.42,4.76l.24-.07-1.38-4.77Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "124.83px 106.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.8,75.76l-.36.1,1.18,4,.15.53.36-.11-.15-.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "116.285px 78.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.88,80.75c.43,1.47.86,2.92,1.28,4.34l.36-.1-1.28-4.35Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "117.7px 82.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134.74,107l1.39,4.6.17,0c-.37-1.31-.81-2.86-1.32-4.62Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "135.52px 109.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.86,97.33c.44,1.47.85,2.88,1.25,4.21l.29-.08-1.23-4.22Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "132.63px 99.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M123.3,68.34c.43,1.46.86,2.94,1.31,4.45l.36-.11-1.32-4.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "124.135px 70.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125.07,73l-.37.11c.4,1.34.8,2.71,1.21,4.1,0,.15.09.29.13.44l.36-.1-.13-.45C125.87,75.73,125.46,74.37,125.07,73Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "125.55px 75.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.47,58.67q.65,2.19,1.32,4.53l.34-.1-1.34-4.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "121.3px 60.89px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m136.4 111.88-0.17 0.05 0.36 1.16h0.14c-0.1-0.4-0.21-0.8-0.33-1.21z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "136.48px 112.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M119.09,53.94c.41,1.4.84,2.86,1.28,4.39l.32-.09c-.45-1.53-.89-3-1.31-4.39Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "119.89px 56.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126.14,78c.44,1.48.87,2.93,1.29,4.37l.36-.11c-.42-1.43-.85-2.89-1.29-4.37Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "126.965px 80.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.53,82.71c.46,1.58.92,3.12,1.36,4.63l.35-.11-1.35-4.62Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "128.385px 84.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.75,45.06l-.21.06,1,3.54.25-.08Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "117.165px 46.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.65,44.72l-.09-.28c0,.1-.08.21-.12.31v0Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "116.545px 44.595px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M133.21,101.88c.52,1.72,1,3.31,1.43,4.77l.24-.07q-.63-2.19-1.39-4.79Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "134.045px 104.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M119.28,53.52c-.48-1.64-.94-3.18-1.37-4.6l-.25.08c.41,1.42.86,3,1.33,4.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "118.47px 51.26px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M130.36,92.3c.49,1.62.95,3.19,1.4,4.7l.31-.1q-.66-2.25-1.37-4.7Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "131.215px 94.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M129,87.67c.44,1.47.86,2.9,1.27,4.29l.34-.1-1.26-4.29Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "129.805px 89.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121.89,63.53c.43,1.46.86,3,1.31,4.47l.35-.1-1.32-4.47Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "122.72px 65.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M136.79,80l1.38,4.67.35-.1c-.45-1.52-.9-3.08-1.37-4.67Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "137.655px 82.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M135.4,75.26c.44,1.49.88,3,1.3,4.41l.36-.1c-.42-1.45-.85-2.92-1.29-4.42Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "136.23px 77.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.15,60.78c.43,1.47.87,3,1.33,4.52l.35-.1c-.46-1.55-.9-3.05-1.34-4.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "131.99px 62.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M144,104.24c.53,1.77,1,3.33,1.4,4.64l.17,0-1.34-4.66Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.785px 106.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.09,45.88c-.35-1.17-.68-2.25-1-3.24,0,.07-.1.15-.16.22.27,1,.57,2,.89,3.09Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "126.51px 44.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M145.66,109.13l-.16.05c.13.46.26.88.38,1.27l.15,0C145.92,110,145.8,109.59,145.66,109.13Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "145.765px 109.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.26,84.92c.43,1.49.86,2.93,1.28,4.34l.34-.1c-.42-1.41-.84-2.86-1.27-4.34Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "139.07px 87.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M142.47,99.13l1.45,4.82.24-.07c-.43-1.48-.9-3.1-1.4-4.84Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "143.315px 101.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M132.56,65.59c.43,1.47.87,3,1.32,4.49l.36-.1-1.32-4.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "133.4px 67.785px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M141.12,94.58c.44,1.49.87,2.91,1.27,4.26l.28-.08c-.39-1.36-.8-2.78-1.24-4.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "141.895px 96.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139.63,89.55q.72,2.46,1.4,4.74l.32-.09c-.45-1.52-.91-3.11-1.39-4.75Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "140.49px 91.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.56,50.81c-.49-1.65-1-3.2-1.39-4.64l-.25.08c.42,1.43.87,3,1.35,4.65Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "127.74px 48.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.36,51.19l1.29,4.44.32-.09-1.32-4.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "129.165px 53.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M129.73,55.92l1.34,4.57.34-.1c-.47-1.57-.92-3.1-1.36-4.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "130.57px 58.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134.33,70.27l-.36.11c.4,1.38.82,2.79,1.24,4.21,0,.13.07.25.11.38l.36-.11c0-.12-.07-.25-.11-.37C135.15,73.06,134.74,71.65,134.33,70.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "134.825px 72.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84,58.9c.41,1.43.86,3,1.34,4.63l.29-.09L84.2,58.82Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "84.815px 61.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101,116.89l1.4,4.63.17,0c-.37-1.3-.82-2.85-1.33-4.65Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "101.785px 119.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M98.15,107.24l1.26,4.23.28-.09-1.23-4.23Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "98.92px 109.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.82,92.62c.47,1.58.92,3.13,1.37,4.64l.35-.1c-.44-1.52-.9-3.06-1.36-4.65Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "94.68px 94.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M86.76,68.57c.43,1.47.87,3,1.33,4.55l.34-.1c-.46-1.56-.91-3.08-1.35-4.54Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "87.595px 70.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M96.65,102.2l1.41,4.72.31-.09L97,102.1Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "97.51px 104.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M85.38,63.84l1.29,4.42.32-.09c-.46-1.54-.9-3-1.31-4.41Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "86.185px 66.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m102.69 121.78h-0.16c0.09 0.29 0.17 0.57 0.25 0.84h0.15c-0.08-0.26-0.16-0.54-0.24-0.84z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.73px 122.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.36,82.92,91,83l1.09,3.68c.08.3.17.59.26.89l.36-.11-.26-.89C92.07,85.36,91.71,84.13,91.36,82.92Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "91.855px 85.245px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M95.28,97.58c.44,1.47.87,2.91,1.28,4.31l.33-.1c-.4-1.4-.83-2.84-1.26-4.31Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "96.085px 99.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89.59,78.25c.43,1.46.87,3,1.31,4.47l.36-.11c-.45-1.52-.88-3-1.32-4.47Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "90.425px 80.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M92.43,87.91c.44,1.49.87,3,1.3,4.39l.35-.1c-.42-1.44-.85-2.91-1.29-4.39Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "93.255px 90.055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.18,73.44l1.32,4.49.35-.1c-.45-1.53-.9-3-1.33-4.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "89.015px 75.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84.11,58.51c-.32-1-.62-2-.89-3l-.23,0,.87,3Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "83.55px 57.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.5,111.78l1.44,4.8.23-.07c-.42-1.46-.88-3.07-1.39-4.81Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "100.335px 114.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97.85,70.61c.43,1.45.86,2.94,1.31,4.46l.35-.1-1.32-4.46Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "98.68px 72.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106.33,99.38q.72,2.43,1.39,4.68L108,104c-.44-1.5-.9-3.07-1.37-4.69Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "107.165px 101.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M109.18,109c.51,1.72,1,3.31,1.42,4.76l.24-.07q-.63-2.19-1.39-4.78Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "110.01px 111.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M112.36,119l-.16,0,.28.92.14,0Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "112.41px 119.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M95.05,61c.41,1.39.83,2.85,1.28,4.38l.32-.1c-.45-1.52-.89-3-1.3-4.37Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "95.85px 63.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M103.49,89.79c.46,1.57.92,3.11,1.36,4.61l.35-.1-1.35-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "104.345px 92.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M102.1,85.09q.66,2.2,1.29,4.35l.36-.11L102.47,85Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.925px 87.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M96.43,65.75c.43,1.45.87,3,1.32,4.51l.34-.1-1.34-4.5Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "97.26px 67.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M110.71,114.07c.53,1.77,1,3.3,1.38,4.58l.17-.05-1.32-4.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "111.485px 116.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101,80.1l-.36.1c.35,1.21.71,2.43,1.07,3.66.09.29.17.58.26.88l.36-.11c-.08-.29-.17-.58-.26-.88Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "101.485px 82.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M105,94.75,106.22,99l.34-.09-1.26-4.28Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "105.78px 96.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.22,53.82c-.11-.38-.23-.75-.33-1.12h-.25c.13.43.26.87.39,1.33Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "92.93px 53.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.26,75.42c.43,1.45.86,2.93,1.3,4.43l.36-.1c-.44-1.51-.88-3-1.3-4.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "100.09px 77.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.82,104.41c.44,1.47.86,2.87,1.25,4.19l.28-.08c-.38-1.33-.79-2.73-1.22-4.2Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "108.585px 106.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.34,58.57l.61,2.1.29-.09c-.19-.66-.39-1.31-.58-1.94Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "94.79px 59.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m122 116.12h-0.16c0.11 0.36 0.21 0.7 0.31 1h0.13c-0.06-0.3-0.15-0.64-0.28-1z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "122.06px 116.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M114.62,91.91c.44,1.46.86,2.89,1.27,4.27l.07,0,.26-.07c-.4-1.38-.82-2.81-1.25-4.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "115.42px 94.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.52,67.78c.42,1.44.86,2.92,1.3,4.44l.36-.1-1.32-4.45Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "108.35px 69.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M111.77,82.25c.43,1.47.86,2.92,1.28,4.34l.19,0,.17-.05c-.42-1.43-.84-2.88-1.28-4.35Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "112.59px 84.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M105.71,61.56c.09.33.19.66.28,1l.32-.09c-.1-.37-.21-.73-.32-1.09Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "106.01px 61.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M108.93,72.58c.42,1.45.86,2.92,1.3,4.42l.28-.08.08,0c-.44-1.5-.88-3-1.31-4.42Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "109.76px 74.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M102.88,51c-.11-.38-.23-.76-.34-1.13l-.25-.06.34,1.18Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.585px 50.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106.1,62.91q.63,2.18,1.32,4.5l.34-.1-1.34-4.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "106.93px 65.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M113.34,86.9l-.18,0c.46,1.57.91,3.1,1.36,4.6l.35-.1-1.35-4.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "114.015px 89.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.07,96.52l-.08,0c.48,1.62,1,3.18,1.39,4.67l.31-.09c-.43-1.5-.89-3.06-1.36-4.68Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "116.84px 98.805px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M110.7,77.26l-.08,0-.29.09c.36,1.2.72,2.41,1.08,3.64.08.3.17.59.26.88l.36-.11c-.09-.29-.17-.58-.26-.87Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "111.18px 79.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.38,111.23c.53,1.76,1,3.29,1.38,4.57l.16,0c-.36-1.28-.8-2.82-1.31-4.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "121.15px 113.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118.84,106.12c.52,1.71,1,3.3,1.43,4.75l.23-.07L119.12,106Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "119.67px 108.435px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M117.49,101.57c.44,1.46.85,2.86,1.25,4.19l.28-.09c-.39-1.32-.79-2.72-1.22-4.19Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "118.255px 103.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.36,74.41l-.36.11,1.07,3.65.26.88.37-.11c-.09-.29-.18-.58-.26-.88C121.07,76.83,120.72,75.61,120.36,74.41Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "120.85px 76.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M114.39,55.33c.4,1.4.83,2.86,1.27,4.38l.32-.09c-.45-1.53-.88-3-1.3-4.38Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "115.185px 57.475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.77,60.06c.42,1.46.86,3,1.31,4.51l.34-.1L116.09,60Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "116.595px 62.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.82,84.1c.47,1.58.92,3.11,1.37,4.61l.35-.1c-.45-1.5-.9-3-1.36-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "123.68px 86.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121.44,79.4l1.28,4.35.36-.1c-.42-1.43-.85-2.88-1.28-4.36Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "122.26px 81.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125.66,93.69l1.39,4.68.31-.09c-.44-1.5-.89-3.07-1.37-4.69Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "126.51px 95.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M117.19,64.93c.42,1.44.86,2.93,1.3,4.45l.36-.1-1.32-4.45Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "118.02px 67.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m131.69 113.27h-0.16c0.13 0.4 0.24 0.76 0.34 1.11h0.14c-0.1-0.38-0.2-0.71-0.32-1.11z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "131.77px 113.825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M130,108.38c.53,1.77,1,3.3,1.39,4.58l.16,0-1.32-4.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "130.775px 110.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.16,98.73c.43,1.46.85,2.86,1.25,4.19l.28-.08-1.23-4.21Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "127.925px 100.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118.6,69.73c.42,1.45.85,2.93,1.3,4.44l.36-.11c-.45-1.51-.88-3-1.31-4.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "119.43px 71.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.29,89.07c.43,1.46.86,2.88,1.27,4.27l.33-.1c-.41-1.39-.82-2.82-1.25-4.28Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "125.09px 91.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M114.58,54.89c-.49-1.62-1-3.16-1.37-4.58l-.26.08L114.28,55Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "113.765px 52.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M113.1,50c-.33-1.1-.64-2.14-.93-3.09l-.25-.07c.28,1,.6,2.08.93,3.23Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "112.51px 48.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.51,103.27q.77,2.58,1.43,4.76l.23-.07-1.38-4.77Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "129.34px 105.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139.29,105.64c.53,1.76,1,3.31,1.4,4.62l.17-.05c-.37-1.32-.82-2.88-1.33-4.64Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "140.075px 107.915px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M130.69,76.66c.44,1.48.87,3,1.3,4.39l.36-.11c-.43-1.44-.86-2.9-1.29-4.39Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "131.52px 78.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m121.06 43.43h-0.08v0.07z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "121.02px 43.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M137.76,100.53l1.44,4.79.24-.07c-.43-1.47-.89-3.08-1.39-4.81Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "138.6px 102.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M125,57.32c.43,1.46.87,3,1.33,4.55l.34-.1c-.46-1.57-.92-3.08-1.35-4.54Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "125.835px 59.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M123.65,52.59c.4,1.4.83,2.88,1.28,4.41l.32-.09c-.46-1.53-.9-3-1.31-4.41Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "124.45px 54.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M129.62,71.67l-.36.11c.41,1.39.82,2.81,1.25,4.25l.09.31.36-.1-.09-.32Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "130.11px 74.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134.91,91q.74,2.44,1.4,4.72l.32-.1c-.44-1.51-.9-3.09-1.38-4.72Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "135.77px 93.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126.44,62.19l1.32,4.48.35-.1c-.45-1.53-.9-3-1.33-4.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "127.275px 64.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.85,67c.43,1.46.87,3,1.31,4.47l.36-.11c-.44-1.51-.88-3-1.32-4.46Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "128.685px 69.185px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M133.55,86.33c.43,1.47.86,2.9,1.27,4.3l.34-.1c-.41-1.4-.83-2.83-1.27-4.31Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "134.355px 88.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.78,110.58c.14.43.26.84.37,1.22l.15,0c-.11-.38-.22-.78-.35-1.22Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "141.04px 111.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M123.84,52.19l-1.38-4.62-.25.08c.41,1.43.86,3,1.34,4.62Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "123.025px 49.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.37,47.25c-.39-1.28-.75-2.47-1.07-3.54l-.21.06c.31,1.08.66,2.27,1,3.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "121.73px 45.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M132.08,81.36c.47,1.58.92,3.13,1.37,4.65l.35-.11c-.44-1.51-.9-3.06-1.36-4.64Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "132.94px 83.635px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M136.41,96l1.26,4.22.28-.08-1.23-4.24Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "137.18px 98.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.59,119.63l4.57-1.32.24-.07,4.63-1.35.24-.07,4.67-1.36.23-.07,4.54-1.32.23-.07,4.77-1.4.23-.07,4.44-1.3.23-.07.22-.06,4.65-1.37.23-.07,4.33-1.28.23-.07,4.47-1.32.24-.07,4.31-1.28.24-.07,4.48-1.33.23-.07,1.56-.47-.08-.28-1.56.46-.24.07-4.48,1.3-.24.07-4.32,1.26-.24.07L130.17,108l-.23.07-4.33,1.27-.24.07-4.65,1.36-.22.07-.23.07-4.43,1.3-.24.07-4.76,1.41-.24.07-4.53,1.34-.23.07-4.67,1.38-.23.07L96.31,118l-.23.07-4.56,1.36-.23.07-5.78,1.74,0,.16,5.8-1.66Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "115.655px 112.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M92.85,124.63l.16,0,4.64-1.35.17,0,4.71-1.37.16,0,4.74-1.38.16-.05L112.2,119l.16,0,4.84-1.42.17-.05,4.5-1.33.16,0,.61-.18,4.33-1.28.16,0,4.4-1.29.16,0,4.54-1.34.17-.05,4.38-1.3.17,0,4.55-1.35.16-.05,1.55-.46-.08-.29-1.55.45-.17,0-4.55,1.33-.17.05-4.39,1.28-.17,0-4.54,1.33-.16,0-4.4,1.29-.17,0-4.33,1.28-.61.17-.16,0-4.5,1.33-.17.05-4.83,1.42-.17.05L107.5,120l-.17,0-4.73,1.41-.17,0-4.69,1.39-.17,0-4.63,1.39-.16.05c-2.36.71-4.34,1.3-5.86,1.77l0,.15Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "117.065px 117.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.78,110l4.5-1.3.31-.09,4.56-1.32.31-.09,4.59-1.34.31-.09,4.46-1.31.31-.09,4.7-1.37.31-.1,4.35-1.28.31-.09.18,0,4.61-1.36.31-.09,4.26-1.25.3-.1,4.4-1.3.31-.09L136.41,96l.31-.1,4.4-1.31.31-.09,1.62-.48-.08-.28-1.62.47-.32.09-4.4,1.28-.32.1-4.24,1.23-.31.1-4.4,1.28-.31.09-4.25,1.25-.31.09-4.61,1.36-.19.05-.31.09L113,102.49l-.31.1L108,104l-.31.09-4.45,1.32-.32.09-4.58,1.36-.31.09-4.55,1.36-.32.09-4.48,1.34-.31.1c-2.23.66-4.13,1.24-5.63,1.7l0,.16L88.47,110Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "112.895px 102.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M86,100.28,90.41,99l.35-.1,4.52-1.31.35-.1,4.56-1.33.35-.11L105,94.75l.34-.1L110,93.28l.35-.1,4.31-1.27.35-.1.17,0,4.59-1.35.35-.1,4.21-1.24.35-.11L129,87.67l.35-.1,4.21-1.24.34-.11,4.37-1.3.35-.1,1.7-.51-.08-.28-1.71.5-.35.1L133.8,85.9l-.35.11-4.21,1.22-.35.11-4.35,1.27-.35.1L120,90l-.35.1L115,91.4l-.16,0-.35.1-4.32,1.27-.35.11L105.2,94.3l-.35.1-4.41,1.31-.35.1-4.55,1.35-.35.1-4.51,1.35-.35.1L85.88,100l-.34.11L80,101.81l0,.16,5.55-1.59Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "110.16px 93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.12,90.61l4.44-1.28.36-.11,4.51-1.31.36-.1,4.55-1.33.36-.1,4.4-1.29.37-.11,4.64-1.36.36-.11,4.3-1.26.36-.11.17,0,4.58-1.35.36-.11,4.2-1.24.36-.11L126.14,78l.36-.11,4.19-1.24.37-.11,4.34-1.29.37-.11,1.79-.53-.08-.28-1.8.52-.36.11L131,76.24l-.36.1-4.2,1.23-.36.1-4.34,1.27-.37.11-4.2,1.23-.36.11-4.58,1.34-.16,0-.36.11-4.31,1.26-.36.11-4.64,1.37-.36.11L97.6,86l-.36.11L92.7,87.49l-.36.11-4.5,1.34-.36.11-4.43,1.32-.37.11-5.41,1.63,0,.17,5.43-1.56Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "107.415px 83.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M80.27,81l4.45-1.29.35-.1,4.52-1.31.35-.11,4.55-1.33.36-.1,4.41-1.29.36-.1L104.27,74l.35-.1,4.31-1.27.35-.1.17,0L114,71.08l.35-.1,4.21-1.25.35-.1,4.35-1.29.35-.1,4.2-1.25.35-.1,4.36-1.3.36-.1,1.89-.57-.08-.27-1.9.55-.35.1-4.37,1.27-.35.1-4.21,1.23-.35.1-4.35,1.28-.36.1-4.21,1.24-.35.1-4.58,1.35-.17.05-.36.1-4.31,1.27-.35.1L99.51,75l-.35.1-4.41,1.3-.35.11-4.55,1.35-.35.1L85,79.27l-.35.11-4.45,1.33-.35.1-5.32,1.61,0,.16,5.34-1.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "104.65px 73.615px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M77.4,71.29,81.89,70l.32-.09,4.55-1.33.32-.09,4.59-1.34.32-.09,4.44-1.3.32-.09,4.69-1.38.32-.09,4.34-1.28.32-.09.19-.06,4.6-1.35.32-.1,4.24-1.25.32-.09,4.38-1.3.32-.09L125,57.32l.32-.09,4.39-1.31.32-.09,2-.6L132,55l-2,.59-.32.09-4.4,1.28-.32.09-4.24,1.24-.32.09L116,59.62l-.32.09L111.42,61l-.32.1-4.6,1.35-.19.06-.32.09-4.34,1.28-.32.09L96.65,65.3l-.32.1-4.44,1.31-.32.1L87,68.17l-.32.09-4.54,1.35-.32.1-4.48,1.34-.32.09-5.23,1.58,0,.17,5.26-1.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "101.91px 63.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M74.52,61.63l4.56-1.32.25-.07L84,58.9l.25-.08,4.65-1.35.26-.08,3.29-1a1.49,1.49,0,0,1-.05-.36l-3.34,1-.25.07-4.65,1.38-.25.08L79.25,60,79,60l-4.54,1.36-.25.08L69,63l0,.16,5.19-1.48Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "80.725px 59.595px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126.84,46l-4.47,1.3-.25.08-4.31,1.25-.25.08L113.1,50l-.25.07-4.31,1.27-.25.07-2.44.72a3.26,3.26,0,0,1,.36.29l2.18-.65.26-.07,4.3-1.27.26-.08L117.66,49l.25-.08,4.3-1.27.25-.08,4.46-1.32.25-.08,2.15-.64-.08-.27-2.15.62Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "117.585px 48.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m71.28 58.13-3.35 1v0.17l3.64-1z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "69.75px 58.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.14,41.37l-1.58.46a3.92,3.92,0,0,1-.16.36l1.82-.54Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "127.31px 41.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M78.17,56.38l3.44-1-.45-.2-3.07.91-.21.07-2.15.64a2.8,2.8,0,0,1-.25.35L78,56.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "78.545px 56.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88,53.53l3.64-1.07a2.5,2.5,0,0,1-.5-.23l-3.25,1-.2.06-1.69.5a3.52,3.52,0,0,1-.3.45l2.08-.61Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "88.67px 53.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97.72,50.67l3.83-1.13a3.23,3.23,0,0,1-.49-.25l-3.45,1-.21.06-1.28.38a3.38,3.38,0,0,1-.3.47l1.69-.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "98.685px 50.245px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.48,47.79l4-1.18a3.14,3.14,0,0,1-.44-.25l-3.67,1.07-.21.06-.89.27a4.39,4.39,0,0,1-.27.47l1.27-.37Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "108.74px 47.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.75,45.06l4.34-1.29.21-.06.11,0a2.22,2.22,0,0,1-.35-.25l-.06,0-4.35,1.27-.21.06h0a4.25,4.25,0,0,1-.21.43l.33-.1Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "118.82px 44.34px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M76,66.56l4.51-1.3.29-.09,4.58-1.33.3-.08,4.61-1.35.29-.08L95.05,61l.3-.09,2.09-.61L97.17,60l-1.93.57-.29.09L90.48,62l-.29.09-4.61,1.36-.29.09-4.57,1.36-.29.09-4.5,1.34-.3.09L70.43,68l0,.17,5.22-1.5Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "83.935px 64.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M128.27,50.9l-4.43,1.29-.29.08-4.27,1.25-.29.08-4.41,1.29-.3.09L110,56.23l-.29.09-1.55.45c0,.14,0,.27,0,.4l1.67-.49.29-.09,4.27-1.26.29-.09,4.41-1.3.29-.09,4.27-1.26.29-.09,4.42-1.31.29-.09,2.07-.62-.08-.27-2.08.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "119.44px 53.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M78.84,76.15l4.47-1.3.34-.1,4.53-1.31.34-.1L93.09,72l.34-.1,4.42-1.3.34-.1,4.67-1.36.34-.1,4.32-1.27.34-.11h0l4.74-1.4.34-.1,4.22-1.24.34-.1,4.36-1.3.34-.1,4.21-1.24.34-.11,4.37-1.3.34-.1,2-.58-.08-.27-2,.56-.34.1-4.38,1.28-.34.1-4.22,1.23-.34.1-4.37,1.27-.34.1-4.22,1.24-.34.1-4.73,1.39h0l-.34.1-4.33,1.28-.34.1-4.66,1.37-.34.1-4.42,1.31-.34.1L88.43,73l-.34.1-4.52,1.35-.34.1L78.77,75.9l-.34.11c-2.05.61-3.82,1.14-5.27,1.59l0,.16c1.46-.41,3.24-.92,5.29-1.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "103.31px 68.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.68,85.73l4.44-1.28.36-.11L91,83l.37-.11L95.9,81.6l.36-.11,4.41-1.29.36-.1,4.64-1.36.36-.11,4.3-1.26.29-.09.08,0,4.74-1.4.36-.1,4.2-1.24.36-.11,4.34-1.28.37-.11,4.19-1.24.36-.11L134,70.38l.36-.11,1.84-.55-.08-.28-1.85.54-.36.1-4.36,1.27-.36.11L125,72.68l-.36.11-4.35,1.27-.36.11-4.21,1.23-.36.1-4.74,1.4-.08,0-.28.08-4.3,1.27-.36.11-4.65,1.37-.36.1-4.4,1.31-.36.1-4.54,1.35-.36.11-4.5,1.33-.36.11-4.43,1.33-.36.11-5.37,1.61.05.17,5.39-1.54Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "106.055px 78.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84.5,95.32,89,94l.36-.1,4.51-1.31.36-.11,4.54-1.32.36-.11,4.41-1.29.36-.1,4.64-1.37.36-.1L113.16,87l.18,0,.18-.05,4.74-1.4.36-.11,4.2-1.24.36-.1,4.35-1.29.36-.1,4.19-1.25.36-.1,4.35-1.3.36-.1,1.75-.53-.08-.27-1.76.51-.36.1-4.35,1.27-.36.11-4.2,1.22-.36.11-4.35,1.27-.36.1L118.52,85l-.36.1-4.75,1.4-.17.05-.19,0-4.3,1.27-.36.1-4.64,1.37-.36.11L99,90.74l-.36.11L94.08,92.2l-.35.1-4.51,1.34-.36.11-4.43,1.33-.36.1-5.46,1.65,0,.17,5.48-1.58Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "108.755px 88.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.31,104.91l4.47-1.29.34-.1,4.53-1.32.34-.1,4.57-1.33.33-.1,4.44-1.29.33-.1,4.67-1.37.33-.1L116,96.54l.08,0,.26-.08L121.1,95l.33-.09,4.23-1.25.33-.1,4.37-1.29.34-.1L134.91,91l.34-.1,4.38-1.3.33-.1,1.66-.5-.08-.27-1.66.48-.34.1-4.38,1.27-.34.1-4.22,1.23-.34.1-4.37,1.28-.33.1-4.23,1.24-.34.1-4.77,1.4-.26.07-.07,0-4.33,1.27-.34.1-4.66,1.38-.34.09-4.43,1.31-.33.1-4.57,1.36-.33.1L92,103.23l-.33.1-4.46,1.34-.34.1-5.57,1.68,0,.16L87,105Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "111.46px 97.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M90.11,114.51l4.52-1.31.28-.08,4.59-1.34.28-.08,4.63-1.35.28-.08,4.49-1.31.27-.09,4.73-1.38.28-.08,4.33-1.28h0l.28-.08,4.83-1.43.28-.08,4.28-1.26.28-.08,4.42-1.31.28-.09,4.27-1.26.29-.09,4.42-1.31.29-.09,1.59-.47-.08-.28-1.6.47-.28.08L138,100.13l-.28.08-4.27,1.25-.29.08-4.42,1.3-.28.08-4.29,1.25-.28.09L119,105.67l-.28.09h0l-4.33,1.28-.29.08-4.72,1.39-.28.08-4.48,1.33-.28.08-4.62,1.37-.28.09-4.58,1.36-.28.08L90,114.26l-.28.09c-2.23.66-4.14,1.24-5.69,1.71l0,.17,5.72-1.64Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "114.165px 107.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.42,62.38c.16,0,.33.08.5.12l.36.09a6.18,6.18,0,0,0,4.43-1l.28-.19a5.5,5.5,0,0,0,2.17-4.2c0-.13,0-.26,0-.4a5.92,5.92,0,0,0-1.47-3.92,4.34,4.34,0,0,0-.49-.47,3.26,3.26,0,0,0-.36-.29,6.11,6.11,0,0,0-3-1.13h-.25a5.86,5.86,0,0,0-3,.57A4.7,4.7,0,1,1,97,59.84a2.09,2.09,0,0,1,.14.17l.27.31A7.25,7.25,0,0,0,100.42,62.38Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.58px 56.8183px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97,53.57a3.34,3.34,0,0,0,1.36-.37c.79-.43,1.11-1.15,1.21-1.1s0,.22-.12.52a2.28,2.28,0,0,1-.9.91,2.21,2.21,0,0,1-1.22.27,2.91,2.91,0,0,1,1,2.33,2.75,2.75,0,0,1-1.36,2.17,2.82,2.82,0,0,1,1.21.31,2.58,2.58,0,0,1,1.1,1.07c.19.35.21.6.17.61s-.47-.84-1.44-1.35a3.67,3.67,0,0,0-1.72-.37,1.11,1.11,0,0,1-.29,0,4.69,4.69,0,1,0,3.7-7.09,5.13,5.13,0,0,0-1.19.24l-.38.15-.21.11a4.56,4.56,0,0,0-1.55,1.26A1.7,1.7,0,0,1,97,53.57Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "100.356px 56.1589px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.34,58.57l.32.07a3,3,0,0,0,1.12,0s-.07,0-.06,0a8.7,8.7,0,0,0,1-.44,2.73,2.73,0,0,0,1.24-2A2.92,2.92,0,0,0,97,53.89a9.25,9.25,0,0,0-.87-.62s0,0,0,0a2.84,2.84,0,0,0-1.93,0,2.88,2.88,0,0,0-1,.61L93,54a2.8,2.8,0,0,0-.68,2,1.49,1.49,0,0,0,.05.36,2.33,2.33,0,0,0,.08.36A2.82,2.82,0,0,0,94.34,58.57Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "95.1393px 55.8969px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97,53.89a2.92,2.92,0,0,1,.92,2.21,2.73,2.73,0,0,1-1.24,2,8.7,8.7,0,0,1-1,.44s0,0,.06,0H96a1.11,1.11,0,0,0,.29,0c-.13,0-.21,0-.21,0s.2-.16.59-.21l.3,0a2.75,2.75,0,0,0,1.36-2.17,2.91,2.91,0,0,0-1-2.33h0c-.33,0-.52-.13-.5-.17s.08-.05.21-.06a1.7,1.7,0,0,0-.65-.29.41.41,0,0,0-.17,0s0,0,0,0A9.25,9.25,0,0,1,97,53.89Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "97.0065px 55.9253px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M98.53,53.53a2.28,2.28,0,0,0,.9-.91c.15-.3.17-.51.12-.52s-.42.67-1.21,1.1a3.34,3.34,0,0,1-1.36.37c-.13,0-.21,0-.21.06s.17.14.5.17h0A2.21,2.21,0,0,0,98.53,53.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "98.1723px 52.9539px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.41,60.29s0-.26-.17-.61a2.58,2.58,0,0,0-1.1-1.07,2.82,2.82,0,0,0-1.21-.31l-.3,0c-.39,0-.61.17-.59.21s.08,0,.21,0a3.67,3.67,0,0,1,1.72.37C98.94,59.45,99.31,60.34,99.41,60.29Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "97.7244px 59.296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M55.74,299.21l.46,3.91a3.34,3.34,0,0,1,2.08-1.07,3.4,3.4,0,0,1,.79,6.76,3.32,3.32,0,0,1-2.26-.55l.46,3.91a3.28,3.28,0,0,1,2.07-1.06,3.4,3.4,0,0,1,.8,6.75,3.31,3.31,0,0,1-2.27-.55l.46,3.92a3.34,3.34,0,0,1,2.08-1.07,3.4,3.4,0,0,1,.79,6.76,3.32,3.32,0,0,1-2.26-.55l.46,3.91a3.3,3.3,0,0,1,2.07-1.06,3.4,3.4,0,1,1-1.47,6.2l.47,3.92a3.29,3.29,0,0,1,2.07-1.07,3.4,3.4,0,0,1,.8,6.76,3.3,3.3,0,0,1-2.27-.56l.46,3.92a3.33,3.33,0,0,1,2.08-1.06,3.4,3.4,0,0,1,.79,6.75,3.32,3.32,0,0,1-2.26-.55l.28,2.43,104.27-12.28L160,286.94Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "111.215px 321.45px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m161.33 298.17c0 0.1-23.32 2.93-52.11 6.32s-52.14 6.05-52.16 5.95 23.32-2.93 52.12-6.32 52.14-6.05 52.15-5.95z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "109.195px 304.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m162.4 307.25c0 0.1-23.32 2.93-52.11 6.31s-52.15 6.06-52.16 6 23.32-2.93 52.12-6.32 52.14-6.1 52.15-5.99z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "110.265px 313.404px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m163.47 316.32c0 0.1-23.33 2.93-52.11 6.32s-52.15 6.06-52.16 6 23.32-2.93 52.11-6.32 52.14-6.1 52.16-6z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "111.335px 322.479px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m164.53 325.4c0 0.1-23.32 2.93-52.1 6.32s-52.15 6.06-52.16 6 23.32-2.93 52.11-6.32 52.14-6.1 52.15-6z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "112.4px 331.559px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m165.6 334.48c0 0.1-23.32 2.93-52.1 6.32s-52.15 6.06-52.16 6 23.31-2.93 52.11-6.32 52.14-6.1 52.15-6z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "113.47px 340.639px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "76.74 354.27 70.06 297.53 70.41 297.49 77.09 354.23",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "73.575px 325.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m86.36 353.14c-0.1 0-1.67-12.68-3.52-28.35s-3.26-28.38-3.16-28.4 1.68 12.68 3.53 28.36 3.26 28.38 3.15 28.39z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "83.0205px 324.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.8 355.33c-0.1 0-1.68-12.69-3.52-28.36s-3.28-28.38-3.16-28.39 1.68 12.68 3.53 28.35 3.25 28.38 3.15 28.4z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "64.459px 326.955px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m96.53 351.94c-0.1 0-1.68-12.68-3.52-28.35s-3.26-28.38-3.16-28.39 1.68 12.68 3.52 28.35 3.26 28.38 3.16 28.39z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "93.19px 323.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m106.7 350.75c-0.11 0-1.68-12.69-3.53-28.35s-3.26-28.4-3.17-28.4 1.68 12.68 3.53 28.35 3.27 28.38 3.17 28.4z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "103.35px 322.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m116.86 349.55c-0.1 0-1.68-12.68-3.52-28.35s-3.26-28.38-3.16-28.4 1.68 12.68 3.52 28.36 3.3 28.38 3.16 28.39z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "113.522px 321.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m127 348.35c-0.1 0-1.68-12.68-3.53-28.35s-3.26-28.38-3.15-28.39 1.68 12.68 3.55 28.39 3.26 28.34 3.13 28.35z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "123.661px 319.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m137.19 347.16c-0.1 0-1.68-12.69-3.52-28.35s-3.26-28.39-3.16-28.4 1.68 12.68 3.52 28.35 3.26 28.38 3.16 28.4z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "133.85px 318.785px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M147.36,346c-.1,0-1.68-12.68-3.53-28.35s-3.25-28.38-3.15-28.4,1.67,12.68,3.52,28.36S147.46,346,147.36,346Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.02px 317.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m157.52 344.76c-0.1 0-1.68-12.68-3.52-28.35s-3.26-28.41-3.16-28.41 1.68 12.68 3.53 28.35 3.25 28.4 3.15 28.41z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "154.18px 316.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.83 304.44a9.21 9.21 0 0 0 3.72 5.65 6 6 0 1 0 1.51-10.92",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "74.2415px 304.955px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.58 304.44a4.77 4.77 0 1 0 4.18-5.3 4.77 4.77 0 0 0-4.18 5.3z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "72.3167px 303.877px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m64.73 302.85a2.86 2.86 0 1 0 2.51-3.18 2.87 2.87 0 0 0-2.51 3.18z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "67.5704px 302.511px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M67.56,305.32a6.82,6.82,0,0,0,1.06-.23,2.72,2.72,0,0,0,1.67-1.75,3,3,0,0,0-.45-2.41c-.37-.54-.76-.74-.72-.8a1.61,1.61,0,0,1,.93.65,3,3,0,0,1,.59,2.66,2.83,2.83,0,0,1-1.94,1.9A1.52,1.52,0,0,1,67.56,305.32Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "69.1478px 302.786px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m69.67 300.63a6.62 6.62 0 0 0 1.66-0.08 6.17 6.17 0 0 0 1.43-0.85s0 0.23-0.24 0.49a2.28 2.28 0 0 1-1.09 0.71 2.19 2.19 0 0 1-1.3 0c-0.32-0.1-0.48-0.23-0.46-0.27z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "71.2142px 300.349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m70.86 307.81a5.46 5.46 0 0 0-1.13-1.65 5.71 5.71 0 0 0-1.84-0.82s0.24-0.11 0.64-0.08a2.72 2.72 0 0 1 1.43 0.61 2.67 2.67 0 0 1 0.86 1.3c0.12 0.39 0.09 0.64 0.04 0.64z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "69.3969px 306.532px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m148 296a9.13 9.13 0 0 0 3.72 5.65 6 6 0 1 0 1.51-10.93",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "154.406px 296.508px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m157.15 294.07a4.61 4.61 0 1 1-5.11-4 4.61 4.61 0 0 1 5.11 4z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "152.576px 294.649px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m159.47 291.94a2.76 2.76 0 1 1-3.07-2.42 2.76 2.76 0 0 1 3.07 2.42z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "156.729px 292.26px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M157.37,294.9a1.47,1.47,0,0,1-1.06.28,2.73,2.73,0,0,1-2.26-1.36,2.85,2.85,0,0,1,0-2.64c.31-.62.72-.84.73-.81s-.27.32-.5.92a2.84,2.84,0,0,0,.13,2.35,2.64,2.64,0,0,0,2,1.28A9.18,9.18,0,0,0,157.37,294.9Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "155.548px 292.779px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M154.34,291s-.09.2-.37.37a2.28,2.28,0,0,1-1.23.29,2.2,2.2,0,0,1-1.19-.43c-.26-.19-.36-.37-.33-.4s.66.42,1.54.46A6.8,6.8,0,0,0,154.34,291Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "152.777px 291.246px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M154.83,298c-.05,0-.13-.22-.12-.61a2.7,2.7,0,0,1,.52-1.42,2.62,2.62,0,0,1,1.21-.89c.37-.13.62-.11.62-.07s-.89.32-1.53,1.18A5.32,5.32,0,0,0,154.83,298Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "155.885px 296.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m39.81 181.29-9.39 33c2.86 3.36 5.91 6.55 11.11 8.06l25.07 6.33 8.85-38.92z",
    fill: "#fafafa",
    style: {
      transformOrigin: "52.935px 204.985px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "38.51 179.12 29.12 212.09 40.23 220.15 65.31 226.47 75.58 189.25",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "52.35px 202.795px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m34 210.65-4.87 1.44a14.77 14.77 0 0 0 3.89 4.6 21.47 21.47 0 0 0 7.22 3.46 14.19 14.19 0 0 1-6.24-9.5z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "34.685px 215.4px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "34.13 186.02 51.88 181.91 51.04 178.18 33.02 182.01",
    fill: "#ebebeb",
    style: {
      transformOrigin: "42.45px 182.1px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "77.92 198.5 67.71 183.4 64.53 185.53 74.57 200.98",
    fill: "#ebebeb",
    style: {
      transformOrigin: "71.225px 192.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m68.23 199.89c0 0.07-6.34-1.6-14.12-3.72s-14.08-3.9-14.06-4 6.34 1.61 14.12 3.73 14.08 3.93 14.06 3.99z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "54.14px 196.029px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m66.72 204.94c0 0.07-6.34-1.6-14.13-3.72s-14.07-3.9-14.05-4 6.34 1.6 14.12 3.73 14.08 3.93 14.06 3.99z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "52.63px 201.079px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m65.65 209.49c0 0.07-6.35-1.6-14.13-3.72s-14.07-3.9-14.06-4 6.35 1.6 14.13 3.73 14.07 3.92 14.06 3.99z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "51.555px 205.629px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m64.43 213.82c0 0.07-6.34-1.6-14.12-3.72s-14.08-3.9-14.06-4 6.34 1.6 14.13 3.73 14.07 3.92 14.05 3.99z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "50.34px 209.959px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m414.22 338.12a4.76 4.76 0 1 1 4.76 4.77 4.76 4.76 0 0 1-4.76-4.77z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "418.98px 338.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m428.62 312.77a3 3 0 1 1 3 3 3 3 0 0 1-3-3z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "431.62px 312.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m415.92 291.79a2.72 2.72 0 1 1 3.44 1.7 2.71 2.71 0 0 1-3.44-1.7z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "418.494px 290.913px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 399.53,
    cy: 386.54,
    r: 4.43,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "399.53px 386.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m403.77 421.13a3.18 3.18 0 1 1-3.18-3.17 3.18 3.18 0 0 1 3.18 3.17z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "400.59px 421.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m399.36 457.59a2.26 2.26 0 1 1-2.26-2.26 2.26 2.26 0 0 1 2.26 2.26z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "397.1px 457.59px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 412.7,
    cy: 386.54,
    r: 4.43,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "412.7px 386.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m431.73 418a3.18 3.18 0 1 1-3.18-3.18 3.17 3.17 0 0 1 3.18 3.18z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "428.55px 418px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m419.27 453.22a2.26 2.26 0 1 1-1.7-2.7 2.25 2.25 0 0 1 1.7 2.7z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "417.066px 452.723px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 404.47,
    cy: 360.21,
    r: 7.32,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "404.47px 360.21px",
      transform: "rotate(-45deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m409.29 329a4.77 4.77 0 1 1-4.76-4.76 4.76 4.76 0 0 1 4.76 4.76z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "404.52px 329.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m393.29 338.12a4.77 4.77 0 1 1-4.77-4.76 4.78 4.78 0 0 1 4.77 4.76z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "388.52px 338.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m378.89 363.48a3 3 0 1 1-3-3 3 3 0 0 1 3 3z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "375.89px 363.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m391.59 384.46a2.72 2.72 0 1 1-3.45-1.71 2.71 2.71 0 0 1 3.45 1.71z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "389.012px 385.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m434.23 316s-7.59 17.1-10.67 20.76a17.06 17.06 0 0 1-5.57-3.33s9.08-17.37 10.64-20.3z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "426.11px 324.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433.62,309.19c-.11-.36-12-18.37-12-18.37l-5.22,3.59,11.37,18.76Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "425.01px 301.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m421.16 289.67s7.69-8.66 2.31-11.62-6.83 7.24-6.34 10.18l4.25 1.6",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "421.211px 283.674px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M425.41,473.42H388a11.86,11.86,0,0,1,11.86-11.86h13.74a11.86,11.86,0,0,1,11.86,11.86Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "406.73px 467.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M405.12,365.74c.11,0,.21,21.53.21,48.09s-.1,48.08-.21,48.08-.21-21.52-.21-48.08S405,365.74,405.12,365.74Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "405.12px 413.825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m396.65 362.71s-4.39 7.11-3.18 21.18h23s1.43-16.73-4-21.57z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "404.95px 373.105px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "394.4 390.25 404.95 390.25 403.96 420.01 396.74 420.01",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "399.675px 405.13px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "396.58 422.05 394.4 456.2 399.68 457.2 404.4 423.05",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "399.4px 439.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.1,461.56s.06-4.2,4.31-4.36,4.72,4.36,4.72,4.36Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "396.615px 459.378px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "409.79 391.4 419.38 387.01 430.86 414.48 424.3 417.49",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "420.325px 402.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "424.48 417.96 414.75 450.77 419.67 452.92 431.87 420.67",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "423.31px 435.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M412.43,455.82c.27.46,13,5.21,13,5.21s3-2.68-6.49-7l-2-.94a3,3,0,0,0-4.09,1.73Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "419.155px 456.921px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m392.75 331.63c-0.35 0.08 0.29 18.82 4.4 25.77 0 0 14.77-0.48 15.13 0s5.14-16.3 4.71-25.32c0.01 0-10.38-3.72-24.24-0.45z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "404.843px 343.847px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M402.5,302.54s-9.44.2-7.69,12.2,3.68,12,3.74,12.31,11.85-.82,11.85-.82S416.86,302,402.5,302.54Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "403.221px 314.817px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m373.28 360.21s7.59-17.1 10.67-20.76a16.86 16.86 0 0 1 5.57 3.33s-9.08 17.36-10.64 20.3z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "381.4px 351.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M373.88,367.06c.12.36,12,18.37,12,18.37l5.22-3.59-11.37-18.76Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "382.49px 374.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m386.1 387.18s-7.7 8.66-2.31 11.61 6.82-7.24 6.34-10.18l-4.26-1.6",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "386.046px 393.165px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "250px 473.42px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M486.28,473.42c0,.14-105.8.26-236.27.26s-236.29-.12-236.29-.26,105.77-.26,236.29-.26S486.28,473.27,486.28,473.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "250px 473.42px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "257.602px 302.363px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.49,
    y: 375.2,
    width: 155.55,
    height: 98.83,
    fill: "#455a64",
    style: {
      transformOrigin: "246.265px 424.615px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 147.62,
    y: 372.37,
    width: 189.95,
    height: 34.69,
    rx: 17,
    fill: "#455a64",
    style: {
      transformOrigin: "242.595px 389.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M324.25,406.59c0,.13-36.34.24-81.15.24s-81.16-.11-81.16-.24,36.33-.24,81.16-.24S324.25,406.45,324.25,406.59Z",
    fill: "#263238",
    style: {
      transformOrigin: "243.095px 406.59px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M189.27,474.82c-.14,0-.25-15.07-.25-33.65s.11-33.65.25-33.65.24,15.07.24,33.65S189.4,474.82,189.27,474.82Z",
    fill: "#263238",
    style: {
      transformOrigin: "189.265px 441.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m287.59 393.06a21.17 21.17 0 0 1-0.61-2.55 34.24 34.24 0 0 0-2-6 35.47 35.47 0 0 0-3.07-5.5 21.9 21.9 0 0 1-1.49-2.17 10.57 10.57 0 0 1 1.77 2 28 28 0 0 1 5.13 11.59 10.35 10.35 0 0 1 0.27 2.63z",
    fill: "#263238",
    style: {
      transformOrigin: "284.007px 384.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M295.94,387.88c-.08,0-.42-1-1.25-2.49a19.14,19.14,0,0,0-9.89-8.59c-1.61-.62-2.66-.81-2.65-.9a2.3,2.3,0,0,1,.76.07,12.74,12.74,0,0,1,2,.5A17.48,17.48,0,0,1,295,385.23a12.2,12.2,0,0,1,.78,1.91A2.38,2.38,0,0,1,295.94,387.88Z",
    fill: "#263238",
    style: {
      transformOrigin: "289.045px 381.887px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "248.69px 422.4px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M203.22,373.09c6.21,34.28,17,69.65,32.25,101h7c2.86-4,1.91-9.48.12-14s-4.32-9-4.29-13.89c0-3,1-5.93,1.39-8.92,1.43-11.55-6.5-22.11-8.34-33.6-.66-4.15-.28-8.95,2.87-11.74,2.76-2.45,6.8-2.64,10.49-2.55,9.64.23,19.43,1.44,28.84-.68s18.66-8.56,20.61-18Z",
    style: {
      transformOrigin: "248.69px 422.4px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m294.53 265.5 30.47-8.23s-6.52-19.34-11.6-33.27c-4.49-12.32-12-17.45-15.94-20.24a12 12 0 0 0-5.35-2.12c-7.22-1-26.94-3.55-36.73-4.37-12.11-1-37.39 5.65-37.39 5.65s-22.17 12.3-29.65 17.27a10.39 10.39 0 0 0-4 5c-1.38 3.72-3.14 10.11-5.24 18.37-1.35 5.26-5.78 22.65-5.78 22.65l26-0.8c5.24 15.91 10.1 30.2 10.1 30.2l-4.71 29.26s35.54 14.21 44.62 13.2 50.23-16.9 50.23-16.9-4.71-46.42-4.71-47.76c0-0.52-0.14-3.89-0.32-7.91z",
    fill: "#f90",
    style: {
      transformOrigin: "249.16px 267.644px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "236.889px 268.278px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m264.55 234.55a9.4 9.4 0 0 0-8.32-3.12 18.8 18.8 0 0 0-8.47 3.49c-7.89 5.35-13.48 13.42-18.43 21.55a260 260 0 0 0-21.66 44.74l0.2 4c6.47-0.81 10.68-6.27 13.49-12.15s4-12.39 6.49-18.42a47.51 47.51 0 0 1 25.58-25.64 12.25 12.25 0 0 0 10.51-3.78c2.52-2.91 3-7.63 0.61-10.67z",
    style: {
      transformOrigin: "236.889px 268.278px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m294.83 270.55c-0.15 0-1-8.44-1.93-18.86s-1.55-18.89-1.41-18.91 1 8.43 1.93 18.86 1.58 18.89 1.41 18.91z",
    fill: "#263238",
    style: {
      transformOrigin: "293.164px 251.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M192.4,232.78a7.52,7.52,0,0,1,.38,1.31c.23,1,.51,2.17.85,3.62.7,3,1.64,7.28,2.63,12s1.88,8.92,2.48,12c.28,1.46.51,2.69.7,3.65a6.37,6.37,0,0,1,.18,1.35,7.16,7.16,0,0,1-.38-1.31c-.23-.95-.51-2.16-.86-3.61-.7-3.06-1.63-7.29-2.63-12s-1.87-8.92-2.48-12c-.27-1.46-.51-2.68-.69-3.64A6.42,6.42,0,0,1,192.4,232.78Z",
    fill: "#263238",
    style: {
      transformOrigin: "196.01px 249.745px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M290.18,202c.15,0-.73,3.42-1.33,7.67s-.73,7.75-.89,7.75a8.66,8.66,0,0,1-.1-2.3,48.74,48.74,0,0,1,.47-5.52,47.63,47.63,0,0,1,1.11-5.43A8.42,8.42,0,0,1,290.18,202Z",
    fill: "#263238",
    style: {
      transformOrigin: "289.011px 209.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M294.53,265.5c-.27.08,7.75,27.64,7.75,27.64l-23.57-1.92L267.46,305l40.17,14.8s24.9-11.1,24.9-12.11-9-50-9-50Z",
    fill: "#886962",
    style: {
      transformOrigin: "299.995px 288.745px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M277.19,268.69a1.68,1.68,0,0,0,1.21-.57,2,2,0,0,0,.51-1.51,1.94,1.94,0,0,0-1.37-1.59,2.63,2.63,0,0,0-2.62.48,3.84,3.84,0,0,0-1,1.25,4.25,4.25,0,0,0-.3.8c-.07.28-.16.59,0,.77a.66.66,0,0,0,.69.17,1.29,1.29,0,0,0,.7-.48,2,2,0,0,0,.28-1.79,2.6,2.6,0,0,0-3.53-1.17,4.71,4.71,0,0,0-1.79,1.42,2,2,0,0,0-.45,1,.65.65,0,0,0,.49.73,1.17,1.17,0,0,0,1-.34,1.61,1.61,0,0,0,.46-1,2.42,2.42,0,0,0-1.05-2.12,3.08,3.08,0,0,0-2.51-.32,2.92,2.92,0,0,0-2,1.61,1.48,1.48,0,0,0-.06,1.23,1,1,0,0,0,1,.56,1.36,1.36,0,0,0,1.22-1.87,2.14,2.14,0,0,0-2.21-1.39,4.28,4.28,0,0,0-2.68,1.26,6.72,6.72,0,0,0-1.05,1.16,1.48,1.48,0,0,0-.29,1.3.77.77,0,0,0,1.07.27,1.2,1.2,0,0,0,.61-1.16,3.22,3.22,0,0,0-1.57-2.56,3.4,3.4,0,0,0-4.36.68,1.87,1.87,0,0,0-.46,1.41c.1,1,1.76,1.21,2.3.37a2,2,0,0,0-.69-2.71,3.57,3.57,0,0,0-3.14-.17,8.13,8.13,0,0,0-1.5.76,3.65,3.65,0,0,0-1.18,1.05,1.3,1.3,0,0,0-.1,1.35.74.74,0,0,0,1.06.35,1.17,1.17,0,0,0,.54-1.18,2.63,2.63,0,0,0-.61-1.36,3.06,3.06,0,0,0-2.67-1.1,3,3,0,0,0-2.36,1.57,1.54,1.54,0,0,0-.08,1.3.92.92,0,0,0,1,.49,1.27,1.27,0,0,0,1-.72,1.61,1.61,0,0,0,0-1.29,2.71,2.71,0,0,0-2.12-1.54,5.63,5.63,0,0,0-2.74.07,2.37,2.37,0,0,0-1.76,1.68,1.76,1.76,0,0,0,1,2,1.45,1.45,0,0,0,1.69-1.13,2.39,2.39,0,0,0-.62-2.13,3.75,3.75,0,0,0-1.92-1.15,4.43,4.43,0,0,0-4,1,3.23,3.23,0,0,0-1,1.65,1.58,1.58,0,0,0,.51,1.59,1.08,1.08,0,0,0,1.45-.05,1.53,1.53,0,0,0,.49-1.38A3,3,0,0,0,240,264a3.22,3.22,0,0,0-2.18-.33,3.46,3.46,0,0,0-1.49.72,4.25,4.25,0,0,0-.88,1.07,1.69,1.69,0,0,1,.14-.33,3.2,3.2,0,0,1,.67-.82,3.46,3.46,0,0,1,1.52-.8,3.42,3.42,0,0,1,2.32.3,3.23,3.23,0,0,1,1.77,2.32,1.84,1.84,0,0,1-.56,1.63,1.38,1.38,0,0,1-1.83.07,1.9,1.9,0,0,1-.64-1.89,3.54,3.54,0,0,1,1-1.84,4.74,4.74,0,0,1,4.32-1.11,4.11,4.11,0,0,1,2.14,1.26,2.8,2.8,0,0,1,.72,2.5,2.24,2.24,0,0,1-.79,1.17,1.63,1.63,0,0,1-1.44.27,1.78,1.78,0,0,1-1.08-1,2.46,2.46,0,0,1-.21-1.47,2.81,2.81,0,0,1,2.07-2,6.13,6.13,0,0,1,3-.11,3.26,3.26,0,0,1,2.48,1.83,2.15,2.15,0,0,1,0,1.67,1.78,1.78,0,0,1-1.38,1,1.44,1.44,0,0,1-1.57-.76,2.05,2.05,0,0,1,.08-1.75,3.56,3.56,0,0,1,5.9-.58,3,3,0,0,1,.73,1.64,1.7,1.7,0,0,1-.8,1.69,1.23,1.23,0,0,1-1,.13,1.37,1.37,0,0,1-.77-.68,1.85,1.85,0,0,1,.11-1.9,4.12,4.12,0,0,1,1.35-1.22,8.29,8.29,0,0,1,1.6-.81,4.09,4.09,0,0,1,3.62.22,2.51,2.51,0,0,1,.84,3.49,1.91,1.91,0,0,1-1.83.74,1.82,1.82,0,0,1-1-.42,1.59,1.59,0,0,1-.5-.92,2.39,2.39,0,0,1,.57-1.84,3.94,3.94,0,0,1,5.08-.8,3.76,3.76,0,0,1,1.82,3,1.77,1.77,0,0,1-.91,1.64,1.53,1.53,0,0,1-1,.12,1.15,1.15,0,0,1-.8-.65,2,2,0,0,1,.33-1.81,6.91,6.91,0,0,1,1.14-1.26,4.74,4.74,0,0,1,3-1.38,3,3,0,0,1,1.66.4,2.51,2.51,0,0,1,1.05,1.35,2,2,0,0,1-.19,1.69,1.91,1.91,0,0,1-1.48.82,1.52,1.52,0,0,1-1.46-.84,1.93,1.93,0,0,1,.06-1.63,3.39,3.39,0,0,1,2.34-1.87,3.55,3.55,0,0,1,2.88.39,2.85,2.85,0,0,1,1.23,2.53,1.79,1.79,0,0,1-2,1.76,1.08,1.08,0,0,1-.82-1.18,2.48,2.48,0,0,1,.55-1.23,5.28,5.28,0,0,1,1.95-1.51,3,3,0,0,1,4,1.41,2.27,2.27,0,0,1-.35,2.1,1.6,1.6,0,0,1-.89.59.93.93,0,0,1-1-.32,1.3,1.3,0,0,1,0-1,4.47,4.47,0,0,1,.34-.84,4.17,4.17,0,0,1,1.07-1.34,2.88,2.88,0,0,1,2.85-.47,2.12,2.12,0,0,1,1.46,1.78,2.15,2.15,0,0,1-.59,1.6A1.38,1.38,0,0,1,277.19,268.69Z",
    fill: "#263238",
    style: {
      transformOrigin: "257.184px 265.996px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "235.26 265.81 221.5 317.81 265.25 319.19 279.01 267.83",
    fill: "#455a64",
    style: {
      transformOrigin: "250.255px 292.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "235.26 265.81 233.51 265.97 219.63 314 221.74 316.9",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "227.445px 291.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M264.22,279.06h14.21a3.37,3.37,0,0,1,3.15,2.05,9.71,9.71,0,0,1,.82,4.1,5.17,5.17,0,0,1,1,2.87,70.79,70.79,0,0,1,0,7.79c-.13.41-1.64.82-1.64.82s1,2.19.14,3.82a4,4,0,0,1-2.05,2.05s-1.91,4.38-3.83,4.92-3.68,0-4.64,0-16.4-7.92-16.4-7.92v-1.78s-5.46.55-5.6-2.46,3.55-2.82,3.55-2.82h8.34s-9.16.36-10-1-1.92-4.65.88-5.19,15.44-.55,15.44-.55l6.9,1.14h1.09l-.85-3s-7.24,0-8.32-.15-3.12-.41-3.12-2.32S264.22,279.06,264.22,279.06Z",
    fill: "#886962",
    style: {
      transformOrigin: "266.442px 293.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M272.21,293.34a12.3,12.3,0,0,1-2.65.18c-1.64,0-3.91,0-6.41-.18s-4.76-.42-6.38-.65a12.12,12.12,0,0,1-2.61-.52,14.22,14.22,0,0,1,2.65.13c1.63.14,3.88.33,6.37.49s4.75.26,6.38.34A13.33,13.33,0,0,1,272.21,293.34Z",
    fill: "#654742",
    style: {
      transformOrigin: "263.185px 292.843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M270.92,301a8.89,8.89,0,0,1-2.37-.07c-1.45-.13-3.45-.36-5.65-.72s-4.17-.76-5.59-1.11a10.15,10.15,0,0,1-2.27-.67,10.31,10.31,0,0,1,2.35.29l5.6.95,5.61.88A11.42,11.42,0,0,1,270.92,301Z",
    fill: "#654742",
    style: {
      transformOrigin: "262.98px 299.739px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M282.82,290.26s.2.06.5.31a3.3,3.3,0,0,1,.92,1.35,3.39,3.39,0,0,1-.05,2.52,3.64,3.64,0,0,1-2.45,2.07l.16-.39a4.49,4.49,0,0,1-2.06,6.38l.16-.18a8.75,8.75,0,0,1-3.07,4.67,7.73,7.73,0,0,1-1.38.85,1.47,1.47,0,0,1-.55.19c0-.07.71-.4,1.72-1.29a9,9,0,0,0,2.78-4.54l0-.13.12-.05a4,4,0,0,0,1.81-5.62l-.2-.31.36-.09a3.19,3.19,0,0,0,2.16-1.74,3.11,3.11,0,0,0,.16-2.24A4.87,4.87,0,0,0,282.82,290.26Z",
    fill: "#654742",
    style: {
      transformOrigin: "279.729px 299.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M249.33,222.66,258.1,205l-2.72-7.74s13.16-6.83,8.66-20.77c-2.17-6.73-7.77-20.23-13-32.39A27.28,27.28,0,0,0,217.27,129l-1.34.45c-14.16,5.7-17.23,20.91-11.14,34.91l17.81,52Z",
    fill: "#886962",
    style: {
      transformOrigin: "233.399px 175.118px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M255.39,197.22a34.09,34.09,0,0,1-19.83.94s7.64,8.55,21.08,2.64Z",
    fill: "#654742",
    style: {
      transformOrigin: "246.1px 200.051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m251.53 155.06a2.09 2.09 0 0 1-1.24 2.64 2 2 0 0 1-2.65-1.1 2.09 2.09 0 0 1 1.24-2.64 2 2 0 0 1 2.65 1.1z",
    fill: "#263238",
    style: {
      transformOrigin: "249.585px 155.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M250.32,151.06c-.16.34-2-.26-4.16.46s-3.34,2.32-3.66,2.13c-.15-.07-.06-.63.46-1.35a5.69,5.69,0,0,1,2.81-2,5.56,5.56,0,0,1,3.43,0C250,150.51,250.4,150.91,250.32,151.06Z",
    fill: "#263238",
    style: {
      transformOrigin: "246.382px 151.847px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m231.9 161.57a2.1 2.1 0 0 1-1.24 2.65 2 2 0 0 1-2.65-1.1 2.1 2.1 0 0 1 1.24-2.65 2 2 0 0 1 2.65 1.1z",
    fill: "#263238",
    style: {
      transformOrigin: "229.955px 162.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m229.6 157.38c-0.13 0.36-2.06 0-4.1 0.91s-3.06 2.66-3.4 2.52c-0.16-0.06-0.13-0.62 0.31-1.4a5.67 5.67 0 0 1 2.58-2.32 5.48 5.48 0 0 1 3.4-0.41c0.85 0.19 1.27 0.54 1.21 0.7z",
    fill: "#263238",
    style: {
      transformOrigin: "225.808px 158.696px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M242.59,172.53a14.41,14.41,0,0,1,3.25-1.79c.53-.24,1-.52,1-.92s-.43-.95-.9-1.5l-3-3.6c-4.22-5.16-7.48-9.47-7.27-9.64s3.8,3.88,8,9l2.94,3.65a3.34,3.34,0,0,1,1,2.05,1.47,1.47,0,0,1-.63,1.1,3.91,3.91,0,0,1-.88.43A14.59,14.59,0,0,1,242.59,172.53Z",
    fill: "#263238",
    style: {
      transformOrigin: "241.635px 163.802px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m226.7 150c0 0.65-2.24 1.09-4.64 2.23s-4.2 2.51-4.71 2.1c-0.23-0.2-0.06-0.86 0.57-1.7a9 9 0 0 1 7.12-3.3c1.04 0.01 1.66 0.31 1.66 0.67z",
    fill: "#263238",
    style: {
      transformOrigin: "221.976px 151.866px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M247.78,145.32c-.21.62-1.85.61-3.63,1.18s-3.15,1.42-3.67,1c-.23-.2-.16-.76.34-1.44a5.54,5.54,0,0,1,5.88-1.78C247.49,144.6,247.87,145,247.78,145.32Z",
    fill: "#263238",
    style: {
      transformOrigin: "244.074px 145.828px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m209.38 174.21c-0.27 0-10.49 0.38-7 9.77s12.2 4 12.12 3.67-5.12-13.44-5.12-13.44z",
    fill: "#886962",
    style: {
      transformOrigin: "208.078px 181.849px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.31,185.16c-.05,0-.12.18-.35.41a1.75,1.75,0,0,1-1.21.48c-1.13,0-2.55-1.26-3.22-2.94a5.66,5.66,0,0,1-.42-2.51,2,2,0,0,1,.77-1.71A.89.89,0,0,1,207,179c.22.21.23.42.29.42s.14-.23-.08-.59a1.13,1.13,0,0,0-.59-.45,1.34,1.34,0,0,0-1,.09,2.46,2.46,0,0,0-1.17,2.1,5.89,5.89,0,0,0,.41,2.82c.76,1.87,2.39,3.29,3.89,3.17a1.88,1.88,0,0,0,1.41-.8C210.38,185.4,210.35,185.17,210.31,185.16Z",
    fill: "#654742",
    style: {
      transformOrigin: "207.379px 182.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M236.8,176.12c.34-.14,1.13,2.18,3.66,3.15s4.92-.1,5,.21c.08.14-.4.64-1.43,1a6.05,6.05,0,0,1-4.16-.05,5.3,5.3,0,0,1-2.92-2.69C236.57,176.82,236.64,176.16,236.8,176.12Z",
    fill: "#263238",
    style: {
      transformOrigin: "241.07px 178.469px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M254.46,123.54a5.8,5.8,0,0,0-4.52-3.17,8.71,8.71,0,0,0-.7-1.51,7.41,7.41,0,0,0-8.74-3.24,7.22,7.22,0,0,0-12.75.63,8.62,8.62,0,0,0-9.16,1.76,2.18,2.18,0,0,0-.67,1,1,1,0,0,0,.16.78,5.43,5.43,0,0,0-4.92-1,5.23,5.23,0,0,0-1.58.8,6.13,6.13,0,0,0-3.22,3.29,8.7,8.7,0,0,0-8.52,7.79,8.28,8.28,0,0,0-5.09,7.7,6,6,0,0,0-1.23,10.39s-6.14,3.74-2.42,9.09c1.9,2.74,5.8.84,5.8.84l11.54,17.47c-.05.12,2,1.93,3,1.06s1.23-2.26,1.54-3.54a14.27,14.27,0,0,0,.73-4.42,3.48,3.48,0,0,0-2.56-3.29,5.2,5.2,0,0,0,1.69-4.92,15.42,15.42,0,0,0-2-5.05l-3.87-7.07a10,10,0,0,0,6.38-8.14,5.72,5.72,0,0,0,7.23-4.57,7.47,7.47,0,0,0,10.08,1.48c.28,2.09,4.42,2.73,6.53,2.6s4.07-2.31,4.07-2.31a12,12,0,0,0,4.3.09h0l.21-.05c2.77-.64,4.57-4,5.08-6.75a5.14,5.14,0,0,0,2-.91A5.75,5.75,0,0,0,254.46,123.54Z",
    fill: "#263238",
    style: {
      transformOrigin: "222.437px 144.771px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M176.47,266.1s-6.09,22-7.43,27.42-1.33,17.89,1.69,21.59,13.12,6.05,13.12,6.05,19.77-9.65,26.49-21.42,25.13-43.8,25.13-43.8l-5.83-16L199,269.2l.31-3.8Z",
    fill: "#886962",
    style: {
      transformOrigin: "201.828px 280.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m240.46 189.52a2.15 2.15 0 0 1 2.89 0.95l17.65 35.11-4.52 2-17-35.23a2.15 2.15 0 0 1 0.98-2.83z",
    fill: "#455a64",
    style: {
      transformOrigin: "250.139px 208.434px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M228.66,241l16.48-17h15.8l10.12,13.36s-4.79.89-6.51-1.68l-2.23-3.18s2.23,4.89,1,7.3c0,0-2.37,5.58-2.75,6.18-.72,1.12-1.27,1.84-3.33,1.5s-5.26-2-4.91-3.22a2,2,0,0,1,1.54-1.37l-4.81-.69s-4.84,8.77-7.76,10.83a22.92,22.92,0,0,1-5.86,2.95Z",
    fill: "#886962",
    style: {
      transformOrigin: "249.86px 239.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M199.62,268.69c0,.08-1.33.72-3.43,1.94a48.56,48.56,0,0,0-7.65,5.56,47.63,47.63,0,0,0-6.39,7c-1.46,1.94-2.25,3.23-2.32,3.18a4.7,4.7,0,0,1,.47-.95c.33-.6.85-1.44,1.55-2.45A41.16,41.16,0,0,1,196,270.31c1.08-.58,2-1,2.61-1.26A4.62,4.62,0,0,1,199.62,268.69Z",
    fill: "#654742",
    style: {
      transformOrigin: "189.725px 277.531px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M248.77,228.9a10.26,10.26,0,0,1,2.31-.39c1.44-.18,3.43-.38,5.62-.58a6.67,6.67,0,0,1,1.67,0,3.42,3.42,0,0,1,1.48.59,5.21,5.21,0,0,1,1.67,2,6.4,6.4,0,0,1,.74,2.24c-.08,0-.38-.82-1.06-2.07a5.26,5.26,0,0,0-1.61-1.79,3.36,3.36,0,0,0-1.29-.49,6.74,6.74,0,0,0-1.55,0c-2.2.19-4.19.34-5.64.42A11,11,0,0,1,248.77,228.9Z",
    fill: "#654742",
    style: {
      transformOrigin: "255.515px 230.319px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M261.35,245.08c-.08,0,.07-1.2,0-3.11a20.53,20.53,0,0,0-.45-3.32c-.27-1.2-.66-2.64-1.86-3.34a7,7,0,0,0-1.95-.69l-1.94-.44a24.38,24.38,0,0,0-3.32-.51,25.47,25.47,0,0,0-3.09.08,2,2,0,0,1,.81-.26,10.47,10.47,0,0,1,2.3-.19,19.91,19.91,0,0,1,3.39.41c.63.12,1.29.26,2,.42a7,7,0,0,1,2.09.73,3.66,3.66,0,0,1,1.48,1.72,8.73,8.73,0,0,1,.58,2,17.92,17.92,0,0,1,.36,3.41,15,15,0,0,1-.14,2.3A2.61,2.61,0,0,1,261.35,245.08Z",
    fill: "#654742",
    style: {
      transformOrigin: "255.246px 239.188px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M255.63,239.37a10.8,10.8,0,0,1,.25,3.17v.31l-.31-.06a3.07,3.07,0,0,0-.53,0,3.14,3.14,0,0,0-2.18,1c-.45.47-.59.87-.67.84s0-.48.39-1.07a3.12,3.12,0,0,1,2.46-1.25,3.3,3.3,0,0,1,.64.07l-.31.25A10.88,10.88,0,0,1,255.63,239.37Z",
    fill: "#654742",
    style: {
      transformOrigin: "254.034px 242.001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m255.65 239.9a18 18 0 0 1-3.2-0.15 18.92 18.92 0 0 1-3.21-0.19 7 7 0 0 1 3.23-0.33 7.08 7.08 0 0 1 3.18 0.67z",
    fill: "#654742",
    style: {
      transformOrigin: "252.445px 239.542px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m249.5 239.08a6.45 6.45 0 0 1-0.71 3.3 6.55 6.55 0 0 1-1.86 2.83c-0.12-0.09 0.68-1.34 1.38-3s1.04-3.16 1.19-3.13z",
    fill: "#654742",
    style: {
      transformOrigin: "248.213px 242.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m312.66 431.31-1.42 45.27 56.31 2.06c-0.13-5.39-28.87-17.26-28.87-17.26l2.11-29z",
    fill: "#f90",
    style: {
      transformOrigin: "339.395px 454.975px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.6,
    style: {
      transformOrigin: "321.823px 460.434px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m321.36 458.3a2.31 2.31 0 0 0-1.69 2.57 2.21 2.21 0 0 0 2.53 1.69 2.41 2.41 0 0 0 1.77-2.72 2.29 2.29 0 0 0-2.82-1.47",
    fill: "#fff",
    style: {
      transformOrigin: "321.823px 460.434px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.6,
    style: {
      transformOrigin: "339.412px 475.33px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M311.24,476.58l.32-4.56,53.87,3.68s2.47,1.19,2.12,2.94Z",
    fill: "#fff",
    style: {
      transformOrigin: "339.412px 475.33px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m339.61 461.13c0 0.27-1.4 0.35-2.79 1.18s-2.15 2-2.4 1.85 0.22-1.69 1.92-2.67 3.33-0.61 3.27-0.36z",
    fill: "#263238",
    style: {
      transformOrigin: "336.984px 462.511px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m345.42 463.79c0.06 0.27-1.15 0.69-2.13 1.82s-1.29 2.35-1.56 2.33-0.39-1.59 0.85-3 2.85-1.41 2.84-1.15z",
    fill: "#263238",
    style: {
      transformOrigin: "343.488px 465.799px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M348.52,471c-.25,0-.59-1.34.18-2.82s2.06-2,2.17-1.8-.72,1-1.32,2.24S348.79,471,348.52,471Z",
    fill: "#263238",
    style: {
      transformOrigin: "349.553px 468.669px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M339.35,454.47c-.12.25-1.37-.18-2.93-.13s-2.79.5-2.92.26,1.07-1.18,2.9-1.21S339.5,454.26,339.35,454.47Z",
    fill: "#263238",
    style: {
      transformOrigin: "336.426px 454.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M338.26,447.74c0,.12-1.1.25-2.82-.12a12.73,12.73,0,0,1-2.92-1,13,13,0,0,1-1.59-.92,3.47,3.47,0,0,1-.83-.69,1.21,1.21,0,0,1-.07-1.47,1.51,1.51,0,0,1,1.23-.58,3.53,3.53,0,0,1,1.05.18,9.14,9.14,0,0,1,1.73.67,9.8,9.8,0,0,1,2.54,1.8c1.26,1.26,1.67,2.3,1.58,2.35s-.74-.8-2-1.85a11.69,11.69,0,0,0-2.46-1.51,11.15,11.15,0,0,0-1.6-.55c-.6-.18-1.1-.21-1.27,0-.05.1-.06.14.06.32a2.69,2.69,0,0,0,.6.51c.49.34,1,.64,1.46.91a15.57,15.57,0,0,0,2.69,1.14A19.64,19.64,0,0,1,338.26,447.74Z",
    fill: "#263238",
    style: {
      transformOrigin: "334.037px 445.461px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M337.88,448.12c-.1,0-.6-1-.64-2.75a9.21,9.21,0,0,1,1.28-4.76,2.35,2.35,0,0,1,1.85-1.36,1.34,1.34,0,0,1,1.15.83,3.78,3.78,0,0,1,.25,1.05,6.31,6.31,0,0,1-.07,1.9,6.53,6.53,0,0,1-1.31,2.87c-1.15,1.42-2.31,1.7-2.33,1.61s.89-.64,1.78-2a6.41,6.41,0,0,0,1-2.62,5.56,5.56,0,0,0,0-1.63c-.07-.6-.27-1.09-.5-1s-.77.42-1,.89a8.4,8.4,0,0,0-.75,1.5,10.25,10.25,0,0,0-.65,2.8C337.78,447.05,338,448.09,337.88,448.12Z",
    fill: "#263238",
    style: {
      transformOrigin: "339.525px 443.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m228.19 431.64 14.26 43-53.4 18c-1.41-5.2 22.76-24.76 22.76-24.76l-10.26-27.17z",
    fill: "#f90",
    style: {
      transformOrigin: "215.72px 462.14px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.6,
    style: {
      transformOrigin: "227.682px 462.175px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m227.54 460a2.31 2.31 0 0 1 2.35 2 2.22 2.22 0 0 1-1.94 2.35 2.44 2.44 0 0 1-2.48-2.11c0-1.13 1.18-2.41 2.29-2.22",
    fill: "#fff",
    style: {
      transformOrigin: "227.682px 462.175px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.6,
    style: {
      transformOrigin: "215.656px 481.495px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m242.45 474.63-1.61-4.28-50.59 18.87s-2 1.84-1.2 3.42z",
    fill: "#fff",
    style: {
      transformOrigin: "215.656px 481.495px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m210.86 467.9c0.09 0.25 1.44-0.07 3 0.34s2.62 1.27 2.83 1.08-0.7-1.55-2.6-2-3.37 0.36-3.23 0.58z",
    fill: "#263238",
    style: {
      transformOrigin: "213.785px 468.267px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M206,472.1c0,.27,1.3.34,2.56,1.14s1.91,1.89,2.16,1.79-.07-1.63-1.66-2.6S206,471.85,206,472.1Z",
    fill: "#263238",
    style: {
      transformOrigin: "208.398px 473.422px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m205.12 479.88c0.25 0 0.18-1.45-1-2.65s-2.57-1.36-2.6-1.11 1 0.77 1.9 1.77 1.43 2.05 1.7 1.99z",
    fill: "#263238",
    style: {
      transformOrigin: "203.378px 477.951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M209.2,461.44c.19.21,1.27-.56,2.77-1s2.82-.32,2.88-.58-1.36-.83-3.13-.34S209,461.28,209.2,461.44Z",
    fill: "#263238",
    style: {
      transformOrigin: "212.013px 460.402px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M208.34,454.68c0,.11,1.12-.08,2.67-.92a12.35,12.35,0,0,0,2.5-1.8,14.72,14.72,0,0,0,1.27-1.33,3.42,3.42,0,0,0,.59-.9,1.19,1.19,0,0,0-.35-1.43,1.5,1.5,0,0,0-1.34-.21,3.74,3.74,0,0,0-1,.48,10.58,10.58,0,0,0-1.47,1.13,9.92,9.92,0,0,0-1.92,2.45,4.78,4.78,0,0,0-.84,2.7c.15,0,.48-1,1.42-2.35a11.57,11.57,0,0,1,1.93-2.15,10.6,10.6,0,0,1,1.38-1c.51-.34,1-.5,1.22-.3s.11.11,0,.32a2.89,2.89,0,0,1-.44.66,13,13,0,0,1-1.14,1.28,15.2,15.2,0,0,1-2.25,1.87C209.27,454.13,208.28,454.54,208.34,454.68Z",
    fill: "#263238",
    style: {
      transformOrigin: "211.907px 451.433px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M208.8,454.94c.11,0,.31-1.1-.16-2.82a9.25,9.25,0,0,0-2.58-4.2,2.35,2.35,0,0,0-2.17-.77,1.3,1.3,0,0,0-.86,1.12,3.68,3.68,0,0,0,.05,1.07,6.54,6.54,0,0,0,2.68,4.18c1.52,1,2.71,1,2.7.88a22.34,22.34,0,0,1-2.28-1.42,6.5,6.5,0,0,1-1.7-2.22,6.1,6.1,0,0,1-.47-1.57c-.11-.59,0-1.12.18-1.14a1.63,1.63,0,0,1,1.23.57,9.46,9.46,0,0,1,1.16,1.22,10,10,0,0,1,1.41,2.5C208.6,453.88,208.65,455,208.8,454.94Z",
    fill: "#263238",
    style: {
      transformOrigin: "205.975px 451.029px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M215.33,329.51s-20.92-18.55-30.1-18.39-39.29-1.85-26.66,39.87c12.73,42.07,35.53,106.4,36.15,104.09L234,437.84,218,378s53.47.6,63.8-.75,29.65-15,29.65-15l-3.08,75.61,41-2.28s5.76-90.83,7.42-109.49c1.44-16.25-16.82-34.49-35.45-30.38-12.16,2.69-55.65,33.39-55.65,33.39Z",
    fill: "#263238",
    style: {
      transformOrigin: "256.196px 375.132px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M312.86,322.09a10.67,10.67,0,0,1,0,2c-.07,1.4-.17,3.2-.28,5.38-.21,4.55-.36,10.83-.47,17.78s-.24,13.24-.48,17.79c-.11,2.28-.25,4.12-.37,5.39a10.11,10.11,0,0,1-.26,2,12.52,12.52,0,0,1,0-2c0-1.4.08-3.21.14-5.38.08-4.68.18-10.91.29-17.8s.33-13.24.66-17.79c.17-2.27.34-4.11.5-5.38A12.33,12.33,0,0,1,312.86,322.09Z",
    fill: "#455a64",
    style: {
      transformOrigin: "311.933px 347.26px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m311.2 357.49a8.74 8.74 0 0 1-1.81-2.18 24.47 24.47 0 0 1-4-12.95 8.26 8.26 0 0 1 0.25-2.82c0.23 0-0.09 4.35 1.51 9.38s4.24 8.45 4.05 8.57z",
    fill: "#455a64",
    style: {
      transformOrigin: "308.285px 348.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M255.41,372.81c-.07,0-.15-1-.47-2.88a37.35,37.35,0,0,0-2.15-7.62,38.68,38.68,0,0,0-5.93-10.06,37.16,37.16,0,0,0-11-9.11C227,338,219.17,332.94,213.71,329c-2.73-2-4.88-3.66-6.3-4.9-.72-.6-1.25-1.11-1.61-1.45a3.36,3.36,0,0,1-.52-.55s.82.63,2.3,1.79,3.65,2.8,6.41,4.71c5.52,3.84,13.37,8.81,22.25,14a37.21,37.21,0,0,1,11.12,9.31,37.87,37.87,0,0,1,5.88,10.29,33.7,33.7,0,0,1,2,7.75,18.9,18.9,0,0,1,.19,2.16A3.37,3.37,0,0,1,255.41,372.81Z",
    fill: "#455a64",
    style: {
      transformOrigin: "230.36px 347.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M269.88,328.51a9.73,9.73,0,0,1-.68,1.75c-.49,1.11-1.15,2.72-1.91,4.74A84.91,84.91,0,0,0,261.86,368c.07,2.15.18,3.89.29,5.09a9.21,9.21,0,0,1,.08,1.88,10.38,10.38,0,0,1-.35-1.85c-.19-1.19-.37-2.94-.5-5.1a76.19,76.19,0,0,1,5.46-33.15c.82-2,1.55-3.6,2.12-4.67A9.72,9.72,0,0,1,269.88,328.51Z",
    fill: "#455a64",
    style: {
      transformOrigin: "265.564px 351.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M191.22,323.07a4.31,4.31,0,0,1,.57.37l1.57,1.15c.35.25.72.53,1.13.84s.8.71,1.25,1.11a30.67,30.67,0,0,1,2.91,2.85l1.59,1.77c.51.65,1,1.34,1.55,2l.82,1.09c.26.38.5.78.75,1.18.5.81,1,1.62,1.54,2.49a75.82,75.82,0,0,1,5.26,11.87c1.55,4.34,2.72,8.58,3.77,12.42l2.72,10.23c.8,2.91,1.44,5.26,1.93,6.87.22.78.39,1.4.53,1.87a5.32,5.32,0,0,1,.15.66,3.07,3.07,0,0,1-.25-.63c-.15-.47-.36-1.08-.61-1.84-.54-1.6-1.24-3.94-2.08-6.84l-2.82-10.2c-1.08-3.84-2.26-8.06-3.8-12.38a77.92,77.92,0,0,0-5.19-11.81c-.49-.87-1-1.68-1.51-2.48-.25-.4-.48-.8-.74-1.18l-.79-1.08c-.53-.71-1-1.41-1.52-2.05l-1.55-1.78a32.47,32.47,0,0,0-2.84-2.88c-.44-.41-.82-.81-1.22-1.14l-1.09-.86-1.52-1.22A3.26,3.26,0,0,1,191.22,323.07Z",
    fill: "#455a64",
    style: {
      transformOrigin: "205.24px 352.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M214.9,329.14c7.46,4.92,15.68,6.08,24.47,7.76,5.07,1,10.37,1.85,15.32.39,10.61-3.13,20.86-15.21,27.67-19.51L253.91,325Z",
    fill: "#f90",
    style: {
      transformOrigin: "248.63px 327.926px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "116.7px 145.61px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 116.7,
    cy: 145.61,
    r: 43.32,
    fill: "#fafafa",
    style: {
      transformOrigin: "116.7px 145.61px",
      transform: "rotate(-23.14deg)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 116.67,
    cy: 145.61,
    r: 43.46,
    fill: "#fff",
    style: {
      transformOrigin: "116.67px 145.61px",
      transform: "rotate(-76.96deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M161.49,167.31s-.46.13-1.18.54A5.69,5.69,0,0,0,158,170.4a5.35,5.35,0,0,0-.53,2.32,4.81,4.81,0,0,0,.8,2.57,5.19,5.19,0,0,0,9.56-1.77,4.78,4.78,0,0,0-.18-2.69,5.5,5.5,0,0,0-1.32-2,5.79,5.79,0,0,0-3.08-1.55c-.82-.12-1.29,0-1.3-.08l.34-.07a2.37,2.37,0,0,1,.41,0,3.89,3.89,0,0,1,.57,0,5.8,5.8,0,0,1,4.69,3.56,5,5,0,0,1,.23,2.89,5.91,5.91,0,0,1-1.47,2.83,5.21,5.21,0,0,1-6.37,1.18,6,6,0,0,1-2.4-2.12,5,5,0,0,1-.81-2.77,5.57,5.57,0,0,1,.6-2.45,5.68,5.68,0,0,1,2.5-2.56,3.63,3.63,0,0,1,.52-.23,2.4,2.4,0,0,1,.4-.12C161.37,167.31,161.49,167.29,161.49,167.31Z",
    fill: "#263238",
    style: {
      transformOrigin: "162.722px 172.659px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M160.19,143.57s0-.24-.09-.7-.13-1.17-.22-2.06c0-.46-.1-1-.16-1.52s-.23-1.16-.35-1.81-.28-1.36-.43-2.11a9.59,9.59,0,0,0-.3-1.14c-.13-.39-.25-.79-.38-1.21a41.65,41.65,0,0,0-5.34-11.34,43.38,43.38,0,0,0-11.6-11.81l-1.94-1.32c-.68-.4-1.39-.76-2.1-1.15l-1.07-.59a8.63,8.63,0,0,0-1.1-.54l-2.3-1c-.39-.16-.78-.34-1.17-.49l-1.23-.38-2.48-.78c-.84-.24-1.72-.38-2.58-.57L124,102.8c-.22,0-.44-.1-.66-.13l-.68-.07a39.93,39.93,0,0,0-5.51-.39c-.94,0-1.88,0-2.83,0l-2.86.28c-.48.06-1,.08-1.45.16l-1.43.29c-1,.2-1.94.36-2.9.61a43.14,43.14,0,0,0-5.7,2l-1.42.59-.71.3-.68.37-2.73,1.48c-.9.54-1.75,1.16-2.63,1.74-.43.3-.89.56-1.3.9l-1.23,1a48.91,48.91,0,0,0-4.73,4.4l-2.09,2.53-.53.64c-.16.22-.31.45-.47.68l-.93,1.37-.93,1.38-.81,1.47L78,125.87l-.4.74c-.12.26-.22.52-.34.78-.44,1-.88,2.08-1.33,3.12s-.68,2.17-1,3.27a42.91,42.91,0,0,0,1.26,27.35l1.32,3.16c.54,1,1.08,2,1.61,3l.41.74.47.7.94,1.39.93,1.39,1.06,1.29L84,174.07l.52.64.59.58,2.31,2.33a49.11,49.11,0,0,0,5.11,3.95l1.32.9c.44.3.92.52,1.38.79.93.49,1.84,1,2.78,1.48l2.86,1.23.71.3c.24.09.49.16.73.24l1.47.46a45.46,45.46,0,0,0,5.86,1.43c1,.15,2,.22,2.93.34l1.46.15c.49,0,1,0,1.45,0l2.88,0c1,0,1.89-.17,2.82-.24a42,42,0,0,0,5.46-.89l.66-.13.65-.2,1.29-.39c.84-.27,1.7-.49,2.52-.8l2.4-1,1.18-.5,1.12-.59,2.21-1.19a7.83,7.83,0,0,0,1-.64l1-.68c.66-.46,1.34-.88,2-1.35l1.81-1.48A43.22,43.22,0,0,0,155,166c.3-.54.6-1.06.87-1.59l.69-1.6c.22-.52.44-1,.66-1.54.1-.25.22-.5.31-.75l.24-.76c.32-1,.62-2,.92-2.88s.4-1.82.6-2.66c.09-.43.17-.84.26-1.24a7.92,7.92,0,0,0,.19-1.17q.13-1.14.24-2.13c.06-.66.16-1.27.19-1.83s0-1.07,0-1.53c0-.9,0-1.6,0-2.07s0-.71,0-.71,0,.24,0,.71,0,1.17,0,2.07c0,.46,0,1,0,1.53s-.11,1.18-.17,1.84-.14,1.38-.22,2.14a6.17,6.17,0,0,1-.19,1.18c-.08.4-.16.81-.25,1.24-.19.84-.33,1.75-.59,2.68s-.58,1.88-.9,2.89c-.08.25-.15.51-.24.77s-.2.5-.3.75q-.33.76-.66,1.56c-.23.52-.45,1.06-.69,1.61s-.56,1.06-.86,1.6a43.45,43.45,0,0,1-10.48,12.94l-1.82,1.5c-.64.47-1.32.9-2,1.36l-1,.68a7.07,7.07,0,0,1-1.05.65l-2.21,1.2-1.13.61-1.19.5-2.42,1c-.82.32-1.69.54-2.54.82l-1.29.4-.65.19-.68.13a39.3,39.3,0,0,1-5.49.91c-.94.08-1.89.21-2.85.25h-2.9c-.48,0-1,0-1.46,0l-1.47-.15c-1-.12-2-.19-3-.34a44.75,44.75,0,0,1-5.92-1.44l-1.47-.46c-.25-.08-.5-.15-.74-.24l-.72-.3-2.89-1.23c-1-.46-1.86-1-2.8-1.5-.46-.27-1-.49-1.39-.79l-1.33-.91a47.64,47.64,0,0,1-5.16-4l-2.34-2.35L84.2,175l-.53-.64L82.6,173l-1.06-1.3-1-1.4-1-1.41-.47-.7-.41-.75-1.63-3c-.45-1.06-.89-2.12-1.34-3.19a43.31,43.31,0,0,1-1.26-27.6c.34-1.11.69-2.2,1-3.3l1.34-3.15c.11-.26.22-.53.34-.78l.41-.75.81-1.49.82-1.48.94-1.39.94-1.38c.16-.23.31-.47.48-.69l.53-.64,2.11-2.55a48.53,48.53,0,0,1,4.77-4.44l1.25-1c.41-.34.88-.61,1.31-.92.89-.58,1.75-1.2,2.65-1.75L97,106.45l.68-.37c.24-.11.48-.2.72-.3l1.42-.6a46.07,46.07,0,0,1,5.76-2c1-.24,1.95-.4,2.92-.6l1.45-.29c.48-.09,1-.11,1.45-.16l2.89-.28c1-.06,1.91,0,2.85,0a40.66,40.66,0,0,1,5.56.39l.68.08c.22,0,.44.09.67.13l1.32.28c.88.19,1.76.34,2.61.57l2.49.79,1.24.39,1.17.5,2.32,1a8.81,8.81,0,0,1,1.11.55l1.07.59c.71.4,1.43.77,2.11,1.17l1.95,1.33a43.51,43.51,0,0,1,11.63,11.92,41.48,41.48,0,0,1,5.3,11.43c.13.41.25.82.37,1.21a7.18,7.18,0,0,1,.29,1.15c.15.76.29,1.46.41,2.12s.27,1.25.34,1.81.1,1.07.14,1.53q.12,1.35.18,2.07C160.18,143.33,160.19,143.57,160.19,143.57Z",
    fill: "#263238",
    style: {
      transformOrigin: "116.473px 145.537px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M132.62,141.65A15.91,15.91,0,1,0,109.94,156v4h13.94s.08-2.25.11-4.26A15.9,15.9,0,0,0,132.62,141.65Z",
    fill: "#f90",
    style: {
      transformOrigin: "116.71px 142.846px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118.84,160s0-.07,0-.2,0-.33.07-.57c.06-.51.15-1.25.29-2.2s.33-2.12.63-3.46a22.9,22.9,0,0,1,1.45-4.42,14.32,14.32,0,0,1,1.3-2.38,3,3,0,0,1,1.09-1,1.65,1.65,0,0,1,1.51,0,1.06,1.06,0,0,1,.5.63,1.08,1.08,0,0,1-.06.81,2.25,2.25,0,0,1-1.23,1.06,4.34,4.34,0,0,1-3.31-.23,4.42,4.42,0,0,1-2.24-2.65,3.38,3.38,0,0,1-.1-1.84,1.42,1.42,0,0,1,1.45-1.1,1,1,0,0,1,.81.56,1.45,1.45,0,0,1,.13,1,3.2,3.2,0,0,1-1.12,1.58,4.71,4.71,0,0,1-3.71,1.07,4.12,4.12,0,0,1-3.07-2.29,2.4,2.4,0,0,1-.11-1.93,1.16,1.16,0,0,1,1.67-.61,1.64,1.64,0,0,1,.68.7,2.66,2.66,0,0,1,.24.92,4.78,4.78,0,0,1-.24,1.81,4.72,4.72,0,0,1-2.24,2.67,4.81,4.81,0,0,1-3.29.45,2.57,2.57,0,0,1-1.44-.76,1.22,1.22,0,0,1-.08-1.53,1.05,1.05,0,0,1,.71-.35,1.53,1.53,0,0,1,.76.15,2.27,2.27,0,0,1,1,1.09c.4.86.72,1.7,1,2.5,1.27,3.21,2.17,5.85,2.78,7.68.3.91.52,1.63.67,2.11.07.24.13.42.17.55s0,.19,0,.19a1.52,1.52,0,0,1-.07-.18c0-.13-.11-.31-.19-.55-.16-.49-.4-1.19-.71-2.1-.62-1.82-1.54-4.45-2.83-7.65-.33-.79-.66-1.64-1.05-2.48a2.16,2.16,0,0,0-.91-1,1,1,0,0,0-1.19,1.49,2.38,2.38,0,0,0,1.34.69,4.64,4.64,0,0,0,3.17-.44,4.54,4.54,0,0,0,2.15-2.57,4.45,4.45,0,0,0,.23-1.74,1.74,1.74,0,0,0-.81-1.46,1.05,1.05,0,0,0-.83-.08,1,1,0,0,0-.58.6,2.19,2.19,0,0,0,.1,1.77,3.94,3.94,0,0,0,2.93,2.18,4.57,4.57,0,0,0,3.55-1A3,3,0,0,0,121,144a1.3,1.3,0,0,0-.11-.85.82.82,0,0,0-.66-.46,1.09,1.09,0,0,0-.79.25,1.32,1.32,0,0,0-.45.71,3.09,3.09,0,0,0,.09,1.73,4.23,4.23,0,0,0,2.14,2.55,4.18,4.18,0,0,0,3.17.23,2.11,2.11,0,0,0,1.14-1,.93.93,0,0,0-.37-1.23,1.49,1.49,0,0,0-1.36-.05,2.81,2.81,0,0,0-1,.93,15.11,15.11,0,0,0-1.3,2.34,24.3,24.3,0,0,0-1.46,4.4c-.31,1.33-.51,2.49-.67,3.44s-.25,1.68-.32,2.19l-.09.57Z",
    fill: "#263238",
    style: {
      transformOrigin: "116.96px 150.842px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.8,162.62h-12a.89.89,0,0,1-.9-.89h0a.9.9,0,0,1,.9-.9h12a.9.9,0,0,1,.9.9h0A.89.89,0,0,1,122.8,162.62Z",
    fill: "#263238",
    style: {
      transformOrigin: "116.8px 161.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122.8,163.41h-12a.9.9,0,1,0,0,1.79h1.31l1.74,3.32a1.17,1.17,0,0,0,1,.62h4.27a1.16,1.16,0,0,0,1-.63l1.69-3.31h.89a.9.9,0,1,0,0-1.79Z",
    fill: "#263238",
    style: {
      transformOrigin: "116.75px 166.272px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.2,
    style: {
      transformOrigin: "107.875px 137.693px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106.5,131.51a11.74,11.74,0,0,1,3.18-2.11,8.46,8.46,0,0,1,2.46-.72c.6-.06.94,0,1,.13.07.29-1.14.71-2.76,1.8a13.06,13.06,0,0,0-6,12.84c.22,1.94.67,3.14.4,3.27-.11.06-.38-.16-.72-.66a8.58,8.58,0,0,1-1-2.34,11.72,11.72,0,0,1-.44-3.79,12.49,12.49,0,0,1,1.12-4.6",
    fill: "#fff",
    style: {
      transformOrigin: "107.875px 137.693px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.2,
    style: {
      transformOrigin: "116.939px 128.515px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M116.93,129.49c-1,0-1.89-.28-2-.82,0-.26.14-.54.51-.76a3,3,0,0,1,1.5-.37,2.93,2.93,0,0,1,1.5.38c.37.23.55.51.5.77",
    fill: "#fff",
    style: {
      transformOrigin: "116.939px 128.515px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120,168.79a6.44,6.44,0,0,1-.83-.25,6.41,6.41,0,0,0-2-.25,6.56,6.56,0,0,0-2,.37c-.5.17-.79.33-.8.3a2.09,2.09,0,0,1,.75-.43,5.83,5.83,0,0,1,4.14-.12A2.82,2.82,0,0,1,120,168.79Z",
    fill: "#455a64",
    style: {
      transformOrigin: "117.185px 168.526px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m121.94 165.25c0 0.05-2.17 0.09-4.83 0.09s-4.84 0-4.84-0.09 2.17-0.1 4.84-0.1 4.83 0.04 4.83 0.1z",
    fill: "#455a64",
    style: {
      transformOrigin: "117.105px 165.245px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121.19,166.66a5.8,5.8,0,0,1-1.18.12c-.73.05-1.74.09-2.85.11s-2.13,0-2.86,0a6.64,6.64,0,0,1-1.18-.09,7.2,7.2,0,0,1,1.18-.05l2.85,0,2.85,0A10.31,10.31,0,0,1,121.19,166.66Z",
    fill: "#455a64",
    style: {
      transformOrigin: "117.155px 166.779px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "350.89px 124.035px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M356.92,165.51l-1.36,0-4,0-15.39.06-56.3.08h-.2v-.19c0-23.48,0-51.79-.05-82.95v-.25h60.44l81.87,0h.24v.24c0,32.37-.05,60.72-.07,82.95v.17h-.17l-40.74-.08-10.9,0-2.81,0-1,0,1,0,2.81,0,10.9-.05,40.74-.08-.17.18c0-22.23,0-50.58-.07-82.95l.24.25H279.86l.25-.25c0,31.16,0,59.47-.06,82.95l-.19-.2,56.3.09,15.39,0,4,0Z",
    style: {
      transformOrigin: "350.895px 123.955px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "animable",
    points: "366.51 165.51 421.92 165.51 421.92 82.56 279.86 82.56 279.86 165.51 356.92 165.51",
    fill: "#fff",
    style: {
      transformOrigin: "350.89px 124.035px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "422.42 166.01 366.51 166.01 366.51 165.01 421.42 165.01 421.42 83.06 280.36 83.06 280.36 165.01 356.92 165.01 356.92 166.01 279.36 166.01 279.36 82.06 422.42 82.06",
    style: {
      transformOrigin: "350.89px 124.035px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 279.86,
    y: 82.56,
    width: 142.07,
    height: 6.13,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "350.895px 85.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M422.42,89.19H279.36V82.06H422.42Zm-142.06-1H421.42V83.06H280.36Z",
    style: {
      transformOrigin: "350.89px 85.625px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M284.18,85.74a.8.8,0,0,1-1.6,0,.8.8,0,0,1,1.6,0Z",
    fill: "#263238",
    style: {
      transformOrigin: "283.38px 85.74px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M283.38,87a1.3,1.3,0,1,1,1.3-1.29A1.3,1.3,0,0,1,283.38,87Zm0-1.59a.3.3,0,1,0,.3.3A.3.3,0,0,0,283.38,85.44Z",
    style: {
      transformOrigin: "283.38px 85.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M287.14,85.74a.79.79,0,0,1-.8.79.79.79,0,0,1-.79-.79.79.79,0,0,1,.79-.8A.8.8,0,0,1,287.14,85.74Z",
    fill: "#263238",
    style: {
      transformOrigin: "286.345px 85.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M286.34,87a1.3,1.3,0,1,1,1.3-1.29A1.29,1.29,0,0,1,286.34,87Zm0-1.59a.3.3,0,1,0,.3.3A.29.29,0,0,0,286.34,85.44Z",
    style: {
      transformOrigin: "286.34px 85.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M290.1,85.74a.79.79,0,0,1-.79.79.79.79,0,0,1-.8-.79.8.8,0,0,1,.8-.8A.79.79,0,0,1,290.1,85.74Z",
    fill: "#263238",
    style: {
      transformOrigin: "289.305px 85.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M289.31,87a1.3,1.3,0,1,1,1.29-1.29A1.3,1.3,0,0,1,289.31,87Zm0-1.59a.3.3,0,1,0,0,.59.3.3,0,0,0,0-.59Z",
    style: {
      transformOrigin: "289.3px 85.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M351.09,95.76s-2.81.09-6.27.09-6.26,0-6.26-.09,2.81-.08,6.26-.08S351.09,95.72,351.09,95.76Z",
    fill: "#263238",
    style: {
      transformOrigin: "344.825px 95.7648px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M344.82,96.35c-3.72,0-5.39,0-6.15-.1h0c-.6-.08-.6-.23-.6-.49s0-.4.6-.48h0c.76-.1,2.43-.1,6.15-.1s5.4,0,6.15.1h0c.6.08.6.22.6.48s0,.41-.6.49h0C350.22,96.35,348.55,96.35,344.82,96.35Z",
    style: {
      transformOrigin: "344.82px 95.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M367.75,95.76s-2.81.09-6.27.09-6.26,0-6.26-.09,2.8-.08,6.26-.08S367.75,95.72,367.75,95.76Z",
    fill: "#263238",
    style: {
      transformOrigin: "361.485px 95.7648px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M361.48,96.35c-3.72,0-5.39,0-6.15-.1h0c-.6-.08-.6-.23-.6-.49s0-.4.6-.48h0c.76-.1,2.43-.1,6.15-.1s5.4,0,6.15.1h0c.6.08.6.22.6.48s0,.41-.6.49h0C366.88,96.35,365.21,96.35,361.48,96.35Z",
    style: {
      transformOrigin: "361.48px 95.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M384.41,95.76s-2.81.09-6.27.09-6.26,0-6.26-.09,2.8-.08,6.26-.08S384.41,95.72,384.41,95.76Z",
    fill: "#263238",
    style: {
      transformOrigin: "378.145px 95.7648px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M378.14,96.35c-3.72,0-5.4,0-6.15-.1h0c-.6-.08-.6-.23-.6-.49s0-.4.6-.48h0c.75-.1,2.43-.1,6.15-.1s5.4,0,6.15.1h0c.59.08.59.22.59.48s0,.41-.59.49h0C383.54,96.35,381.87,96.35,378.14,96.35Z",
    style: {
      transformOrigin: "378.135px 95.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401.21,95.76s-2.8.09-6.26.09-6.26,0-6.26-.09,2.8-.08,6.26-.08S401.21,95.72,401.21,95.76Z",
    fill: "#263238",
    style: {
      transformOrigin: "394.95px 95.7648px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M395,96.35c-3.72,0-5.4,0-6.15-.1h0c-.59-.08-.59-.23-.59-.49s0-.4.59-.48h0c.75-.1,2.43-.1,6.15-.1s5.4,0,6.15.1h0c.59.08.59.22.59.48s0,.41-.59.49h0C400.35,96.35,398.68,96.35,395,96.35Z",
    style: {
      transformOrigin: "395px 95.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M409.39,139.29s-13.61.08-30.38.08-30.39,0-30.39-.08,13.6-.09,30.39-.09S409.39,139.24,409.39,139.29Z",
    fill: "#263238",
    style: {
      transformOrigin: "379.005px 139.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m379 139.87h-21.49-6.52-2.18-0.14c-0.56 0-0.56-0.18-0.56-0.47s0-0.43 0.56-0.48h0.13c0.43 0 1.1 0 2.19-0.05h6.52 21.49s16 0 21.48 0h6.51c1.1 0 1.77 0 2.19 0.05h0.14c0.56 0.05 0.56 0.18 0.56 0.48s0 0.42-0.56 0.47h-0.14-2.19-6.51c-5.48-0.01-13.08 0-21.48 0z",
    style: {
      transformOrigin: "378.995px 139.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M409.06,148.53c0,.05-13.6.09-30.38.09s-30.39,0-30.39-.09,13.6-.08,30.39-.08S409.06,148.49,409.06,148.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "378.675px 148.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m378.68 149.12h-21.49-6.51-2.19-0.14c-0.56-0.06-0.56-0.18-0.56-0.48s0-0.42 0.56-0.48h0.14 2.19 6.51 21.49 21.48 6.52 2.19 0.13c0.55 0.06 0.55 0.19 0.55 0.48s0 0.42-0.55 0.48h-0.13-2.19-6.52c-5.49-0.01-13.09 0-21.48 0z",
    style: {
      transformOrigin: "378.67px 148.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M409.06,151s-13.6.08-30.38.08-30.39,0-30.39-.08,13.6-.09,30.39-.09S409.06,150.93,409.06,151Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "378.675px 150.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m378.68 151.56h-21.49-6.51-2.19-0.14c-0.56 0-0.56-0.18-0.56-0.47s0-0.43 0.56-0.48h0.14c0.42 0 1.1 0 2.19-0.05h6.51 21.49s16 0 21.48 0h6.52c1.09 0 1.77 0 2.19 0.05h0.13c0.55 0.05 0.55 0.18 0.55 0.48s0 0.42-0.55 0.47h-0.13-2.19-6.52c-5.49-0.01-13.09 0-21.48 0z",
    style: {
      transformOrigin: "378.67px 151.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M379.4,142.49s-6.89.09-15.39.09-15.39,0-15.39-.09,6.89-.08,15.39-.08S379.4,142.45,379.4,142.49Z",
    fill: "#263238",
    style: {
      transformOrigin: "364.01px 142.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m364 143.08h-10.89c-2.3 0-3.55 0-4.22-0.07h-0.21c-0.57-0.07-0.57-0.21-0.57-0.47s0-0.39 0.57-0.46h0.21c0.67-0.06 1.92-0.06 4.22-0.07h10.89s8.1 0 10.88 0c2.31 0 3.55 0 4.22 0.07h0.21c0.57 0.07 0.57 0.21 0.57 0.46s0 0.39-0.57 0.47h-0.21c-0.67 0.05-1.91 0.06-4.22 0.07-2.77-0.01-6.62 0-10.88 0z",
    style: {
      transformOrigin: "363.995px 142.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.81,97.75a2.9,2.9,0,0,0,.3,0,1.33,1.33,0,0,0,.72-.44,1.39,1.39,0,0,0,.29-.54,2.82,2.82,0,0,0,0-.73c0-.53.13-1.21-.35-1.71a1.36,1.36,0,0,0-.89-.44c-.36,0-.75,0-1.15,0h-8.39a1.32,1.32,0,0,0-1.17.72,1.48,1.48,0,0,0-.15.69V96a3.12,3.12,0,0,0,.05.7,1.21,1.21,0,0,0,.33.58,1.37,1.37,0,0,0,.55.34,2.39,2.39,0,0,0,.66.06h4.77l3.21,0,.88,0h.3s0,0-.08,0h-.22l-.88,0-3.21,0-4.77,0a2.4,2.4,0,0,1-.7-.06,1.46,1.46,0,0,1-.63-.38,1.56,1.56,0,0,1-.37-.65,2.32,2.32,0,0,1-.05-.38v-1.1a1.56,1.56,0,0,1,.16-.76,1.49,1.49,0,0,1,1.32-.81h9.55a1.47,1.47,0,0,1,1,.49,1.44,1.44,0,0,1,.36.92c0,.31,0,.6,0,.87a2.31,2.31,0,0,1-.06.75,1.32,1.32,0,0,1-.31.56,1.45,1.45,0,0,1-.76.44A1,1,0,0,1,415.81,97.75Z",
    fill: "#263238",
    style: {
      transformOrigin: "411.058px 95.6469px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M406.52,98.33a2.23,2.23,0,0,1-.72-.09,1.91,1.91,0,0,1-.83-.5,2,2,0,0,1-.5-.87,2.14,2.14,0,0,1-.07-.49V95.26a2,2,0,0,1,2-2.07H416a2,2,0,0,1,1.33.66,2,2,0,0,1,.48,1.24v1a2.53,2.53,0,0,1-.08.76,1.76,1.76,0,0,1-.42.75,1.83,1.83,0,0,1-.94.56v0h-.15a2.26,2.26,0,0,1-.33,0l-2,0-7.17,0Zm.06-1.15,9.23.07.19,0a.88.88,0,0,0,.45-.29.77.77,0,0,0,.18-.33,1.34,1.34,0,0,0,0-.46V96c0-.11,0-.25,0-.4,0-.45,0-.75-.21-1a.83.83,0,0,0-.57-.29c-.2,0-.43,0-.68,0h-8.83a.82.82,0,0,0-.71.44,1,1,0,0,0-.1.46v.92a1.51,1.51,0,0,0,0,.39.81.81,0,0,0,.21.37.75.75,0,0,0,.34.21A1.43,1.43,0,0,0,406.58,97.18Z",
    style: {
      transformOrigin: "411.106px 95.7609px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 293.76,
    y: 111.99,
    width: 40.58,
    height: 39.26,
    fill: "#455a64",
    style: {
      transformOrigin: "314.05px 131.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m334.84 151.75h-41.58v-40.26h41.58zm-40.58-1h39.58v-38.26h-39.58z",
    style: {
      transformOrigin: "314.05px 131.62px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "314.07px 137.57px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "296.9 147.89 308.13 127.69 317.31 140.6 322.89 133.74 331.19 147.89",
    style: {
      transformOrigin: "314.045px 137.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m332.07 148.39h-36l12-21.64 9.26 13 5.62-6.9zm-34.32-1h32.57l-7.5-12.77-5.54 6.8-9.1-12.8z",
    style: {
      transformOrigin: "314.07px 137.57px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "318.3px 123.76px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m321.22 123.76a2.92 2.92 0 1 1-2.92-2.92 2.92 2.92 0 0 1 2.92 2.92z",
    style: {
      transformOrigin: "318.3px 123.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318.3 127.18a3.42 3.42 0 1 1 3.42-3.42 3.43 3.43 0 0 1-3.42 3.42zm0-5.84a2.42 2.42 0 1 0 2.42 2.42 2.42 2.42 0 0 0-2.42-2.42z",
    style: {
      transformOrigin: "318.3px 123.76px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "313.865px 131.415px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m331.19 115.07h-34.28a2 2 0 0 0-0.2 0.19v8.81 8.46 15.48 0.17h0.17l24.9-0.09h7 1.82-1.85-7l-24.62-0.09v-15.31-8.46-4.37-4.26h33.93c0 9.73 0.06 17.83 0.08 23.54v6.66 1.77 0.46s0 0.16 0 0.16 0-0.05 0-0.14v-0.44-1.74-6.63c0-5.76 0.05-14 0.09-23.81v-0.17z",
    style: {
      transformOrigin: "313.97px 131.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296.23,148.67l0-33.12h-.39l.18-.21,0,0,.34-.36a1.94,1.94,0,0,1,.29-.28l.57-.54,0,.43,34.67,0,0,6.57-.14,26.68.07.07-.11.28a.54.54,0,0,1-.18.23l-.1.05-.34.14-.07-.09-3.68,0-5.48,0Zm1.34-1.34,33.11.15,0-1.86,0-6.67-.08-23-32.93,0Z",
    style: {
      transformOrigin: "313.865px 131.415px"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 291.2,
    cy: 95.76,
    r: 2.7,
    fill: "#455a64",
    style: {
      transformOrigin: "291.2px 95.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m291.2 99a3.21 3.21 0 1 1 3.21-3.21 3.21 3.21 0 0 1-3.21 3.21zm0-5.41a2.21 2.21 0 1 0 2.21 2.2 2.2 2.2 0 0 0-2.21-2.23z",
    style: {
      transformOrigin: "291.2px 95.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M380.4,124.4c0,.15-6.84.26-15.27.26s-15.27-.11-15.27-.26,6.84-.26,15.27-.26S380.4,124.26,380.4,124.4Z",
    style: {
      transformOrigin: "365.13px 124.4px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "144.709px 224.309px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m159.53 243.32-36.65-8.69a2.66 2.66 0 0 1-1.67-3.18l6-23.85a2.65 2.65 0 0 1 2.89-2.12l36.73 8.94c1.28 0.32 1.57 1.62 1.26 2.9l-6.34 24.68a1.83 1.83 0 0 1-2.22 1.32z",
    fill: "#fafafa",
    style: {
      transformOrigin: "144.663px 224.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M159.16,243.22a2.77,2.77,0,0,0,1.38-.14,2.48,2.48,0,0,0,1.22-1.12,3.7,3.7,0,0,0,.33-1c.1-.38.2-.79.3-1.22.86-3.46,2.08-8.43,3.6-14.56.38-1.54.78-3.14,1.2-4.82l.64-2.57a6.74,6.74,0,0,0,.27-1.29,2.26,2.26,0,0,0-.31-1.21,2.12,2.12,0,0,0-.95-.85,11,11,0,0,0-1.35-.35l-2.85-.67L156.69,212l-26.51-6.26a2.22,2.22,0,0,0-2.57,1.48c-.29,1.15-.59,2.29-.88,3.43-.57,2.28-1.14,4.53-1.7,6.73l-3.23,12.74c-.13.51-.25,1-.38,1.51a2.31,2.31,0,0,0,0,1.4,2.11,2.11,0,0,0,.81,1.09,3.86,3.86,0,0,0,1.34.46l5.61,1.34,10.07,2.42,14.57,3.54,4,1,1,.27.34.1a1.56,1.56,0,0,1-.35-.06l-1-.22-4-.9-14.61-3.39-10.08-2.36L123.48,235a4.13,4.13,0,0,1-1.47-.52,2.55,2.55,0,0,1-1-1.3,2.75,2.75,0,0,1,0-1.63c.12-.5.25-1,.38-1.52l3.2-12.74c.56-2.21,1.12-4.45,1.7-6.74.29-1.14.58-2.3.88-3.46a2.7,2.7,0,0,1,3.12-1.79l26.5,6.31,6,1.42,2.85.68a10,10,0,0,1,1.41.39,2.53,2.53,0,0,1,1.12,1,2.67,2.67,0,0,1,.36,1.43,7.89,7.89,0,0,1-.29,1.37c-.22.87-.44,1.72-.65,2.56-.43,1.67-.84,3.28-1.23,4.81-1.58,6.12-2.85,11.07-3.74,14.53-.12.42-.22.83-.32,1.21a4.2,4.2,0,0,1-.37,1.05,2.53,2.53,0,0,1-1.3,1.13,2.2,2.2,0,0,1-1.06.14A1.52,1.52,0,0,1,159.16,243.22Z",
    fill: "#455a64",
    style: {
      transformOrigin: "144.709px 224.293px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "146.82 222.24 151.03 226.39 145.31 228.14 139.59 229.9 141.1 224 142.62 218.09",
    fill: "#455a64",
    style: {
      transformOrigin: "145.31px 223.995px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "102.835px 274.305px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 80.51,
    y: 228.54,
    width: 44.65,
    height: 91.53,
    rx: 6.78,
    fill: "#263238",
    style: {
      transformOrigin: "102.835px 274.305px",
      transform: "rotate(-22.73deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M100.52,228.65,95,231a1.51,1.51,0,0,0-.76,2l.43,1a1.5,1.5,0,0,1-.76,2L83,240.49a1.51,1.51,0,0,1-2-.85l-.42-1a1.49,1.49,0,0,0-1.94-.84l-2,.81-4.87,2a4.76,4.76,0,0,0-2.54,6.22l29.43,70.19a4.76,4.76,0,0,0,6.21,2.54l28.63-12a4.76,4.76,0,0,0,2.55-6.22l-29.44-70.19A4.75,4.75,0,0,0,100.52,228.65Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "102.639px 274.121px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M104.43,235.56s-.71.34-1.6.73-1.61.67-1.62.65.7-.34,1.59-.72S104.42,235.54,104.43,235.56Z",
    fill: "#263238",
    style: {
      transformOrigin: "102.82px 236.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M104.78,236.38a17.48,17.48,0,0,1-1.59.73c-.89.38-1.62.67-1.63.66s.71-.35,1.6-.73S104.77,236.37,104.78,236.38Z",
    fill: "#263238",
    style: {
      transformOrigin: "103.17px 237.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M105.14,237.21s-.71.34-1.6.72-1.62.68-1.62.66.7-.34,1.59-.73S105.13,237.19,105.14,237.21Z",
    fill: "#263238",
    style: {
      transformOrigin: "103.53px 237.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M76.13,250.49s0,0,.07,0l.18-.08.69-.31v0l-.22-.5a1.58,1.58,0,0,1-.12-.29.29.29,0,0,1,.14-.31l.33-.14a.3.3,0,0,1,.34.18l.31.72,0,0,.86-.37,0,0-.46-1.08-.12-.28a.31.31,0,0,0-.21-.15l-.54-.22-.51-.21-.26-.1a.4.4,0,0,0-.23-.05.25.25,0,0,0-.19.12c0,.06-.06.15-.09.22l-.18.45c-.11.29-.24.56-.31.8s0,.23.09.34l.13.31.2.49.13.32a.48.48,0,0,1,0,.12.49.49,0,0,0,0-.11l-.14-.3c-.06-.14-.13-.31-.22-.5l-.13-.31-.08-.17a.64.64,0,0,1,0-.2c.08-.26.2-.52.31-.81l.18-.45a1.54,1.54,0,0,1,.1-.24.29.29,0,0,1,.23-.15.49.49,0,0,1,.27.06l.25.1.52.21.54.21.14.06a.45.45,0,0,1,.11.13l.12.28.46,1.08v0l0,0-.87.37h0v0l-.31-.73a.25.25,0,0,0-.27-.14l-.31.14a.22.22,0,0,0-.12.24c0,.09.08.19.11.28l.21.5v0h0l-.7.29-.18.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "77.2007px 248.859px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.17,249.13l.17-.09a2.62,2.62,0,0,0,.46-.31,2.41,2.41,0,0,0,.57-.69,2.45,2.45,0,0,0,.33-1.18,2.63,2.63,0,0,0-.09-.72,7.29,7.29,0,0,0-.29-.76,5.19,5.19,0,0,0-.38-.79,2.46,2.46,0,0,0-.64-.69,2.53,2.53,0,0,0-2-.43,7.2,7.2,0,0,0-1.08.41l-1.13.47C96.94,247,88.43,250.52,79,254.47a2.5,2.5,0,0,0-1.29,1.27,2.44,2.44,0,0,0-.1,1.78c.09.29.23.57.34.86a3.2,3.2,0,0,0,.44.79,2.54,2.54,0,0,0,1.48.89,2.37,2.37,0,0,0,.88,0,3.61,3.61,0,0,0,.82-.28l1.62-.68,3.13-1.31,10.83-4.53,7.3-3,2-.82.52-.21.18-.07-.17.08-.52.22-2,.84-7.29,3.08-10.82,4.56-3.12,1.31-1.62.68a3.55,3.55,0,0,1-.85.29,2.59,2.59,0,0,1-.92,0,2.63,2.63,0,0,1-1.56-.94,2.85,2.85,0,0,1-.45-.82c-.11-.28-.25-.56-.35-.86a2.62,2.62,0,0,1,1.47-3.2l24.08-10.09,1.13-.47a7.53,7.53,0,0,1,1.09-.4,2.63,2.63,0,0,1,2,.44,2.77,2.77,0,0,1,.66.71,6.4,6.4,0,0,1,.37.81,4.83,4.83,0,0,1,.29.77,2.7,2.7,0,0,1,.09.73,2.53,2.53,0,0,1-.35,1.2,2.6,2.6,0,0,1-.58.69,2.46,2.46,0,0,1-.48.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "93.0291px 251.829px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106.42,246s0-.08-.15-.21a1.12,1.12,0,0,0-.59-.38,1.08,1.08,0,0,0-1,.26,1,1,0,0,0,.76,1.79,1.08,1.08,0,0,0,.85-.51,1.06,1.06,0,0,0,.15-.68c0-.17-.06-.26,0-.27a.22.22,0,0,1,0,.07.85.85,0,0,1,.06.19,1.15,1.15,0,0,1-.12.73,1.14,1.14,0,0,1-.93.58,1.17,1.17,0,0,1-1.12-.7,1.14,1.14,0,0,1,1.35-1.54,1.1,1.1,0,0,1,.61.43.5.5,0,0,1,.09.18A.15.15,0,0,1,106.42,246Z",
    fill: "#263238",
    style: {
      transformOrigin: "105.379px 246.431px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m107.7 247.53a2.19 2.19 0 0 1-0.68-0.25 2.21 2.21 0 0 1-0.63-0.35 2.22 2.22 0 0 1 0.68 0.24c0.36 0.17 0.65 0.32 0.63 0.36z",
    fill: "#263238",
    style: {
      transformOrigin: "107.045px 247.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.72,255.89l-.55.23,0-.14,1.25-.53.06.14-.55.23.59,1.41-.16.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "81.845px 256.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.91,256l-1,.41a.47.47,0,0,0,.63.21.5.5,0,0,0,.29-.3l.13.06a.6.6,0,0,1-.37.38.63.63,0,0,1-.86-.34A.62.62,0,1,1,83.9,256,.43.43,0,0,1,83.91,256Zm-1,.29.83-.35a.44.44,0,0,0-.58-.21A.43.43,0,0,0,82.89,256.29Z",
    fill: "#263238",
    style: {
      transformOrigin: "83.3267px 256.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M85.17,256.1l-.58-.33-.16.64-.18.07.21-.79-.68-.38.18-.07.54.31.16-.61.17-.07-.2.75.72.4Z",
    fill: "#263238",
    style: {
      transformOrigin: "84.565px 255.675px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M86.19,255.59a.42.42,0,0,1-.21.18.33.33,0,0,1-.48-.19l-.3-.71L85,255l0-.13.21-.09-.11-.26.16-.06.1.25.36-.15,0,.14-.35.15.29.69a.2.2,0,0,0,.29.13.32.32,0,0,0,.15-.13Z",
    fill: "#263238",
    style: {
      transformOrigin: "85.595px 255.137px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 83.34,
    y: 263.34,
    width: 7.24,
    height: 7.24,
    fill: "#263238",
    style: {
      transformOrigin: "86.96px 266.96px",
      transform: "rotate(-22.76deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 83.34,
    y: 263.34,
    width: 7.24,
    height: 7.24,
    fill: "#f90",
    style: {
      transformOrigin: "86.96px 266.96px",
      transform: "rotate(-22.76deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m102 257.5s-2.21 1-5 2.15-5 2.07-5 2 2.21-1 5-2.15 5-2.03 5-2z",
    fill: "#263238",
    style: {
      transformOrigin: "97px 259.577px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m110.84 256.21s-4 1.74-8.94 3.82-9 3.74-9 3.7 4-1.74 8.94-3.81 8.99-3.74 9-3.71z",
    fill: "#263238",
    style: {
      transformOrigin: "101.87px 259.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m111.24 257.76s-3.94 1.72-8.83 3.78-8.87 3.69-8.88 3.66 3.94-1.72 8.83-3.78 8.87-3.69 8.88-3.66z",
    fill: "#263238",
    style: {
      transformOrigin: "102.385px 261.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m104.57 262.2s-2.32 1-5.2 2.25-5.25 2.17-5.26 2.14 2.32-1 5.21-2.25 5.24-2.17 5.25-2.14z",
    fill: "#263238",
    style: {
      transformOrigin: "99.34px 264.395px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 87.99,
    y: 274.42,
    width: 7.24,
    height: 7.24,
    fill: "#f90",
    style: {
      transformOrigin: "91.61px 278.04px",
      transform: "rotate(-22.76deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m106.7 268.63s-2.21 1-5 2.15-5 2.07-5 2 2.21-1 5-2.15 4.98-2.03 5-2z",
    fill: "#263238",
    style: {
      transformOrigin: "101.7px 270.707px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m115.51 267.34s-4 1.74-8.94 3.82-9 3.73-9 3.7 4-1.74 8.94-3.82 8.99-3.73 9-3.7z",
    fill: "#263238",
    style: {
      transformOrigin: "106.54px 271.1px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m115.91 268.89s-3.94 1.72-8.83 3.77-8.87 3.7-8.89 3.66 4-1.72 8.84-3.77 8.87-3.69 8.88-3.66z",
    fill: "#263238",
    style: {
      transformOrigin: "107.05px 272.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m109.24 273.33s-2.32 1-5.21 2.25-5.24 2.17-5.25 2.14 2.32-1 5.21-2.25 5.24-2.17 5.25-2.14z",
    fill: "#263238",
    style: {
      transformOrigin: "104.01px 275.525px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 92.66,
    y: 285.55,
    width: 7.24,
    height: 7.24,
    fill: "#f90",
    style: {
      transformOrigin: "96.28px 289.17px",
      transform: "rotate(-22.76deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m111.37 279.76s-2.21 1-5 2.15-5 2.06-5 2 2.21-1 5-2.15 4.98-2.04 5-2z",
    fill: "#263238",
    style: {
      transformOrigin: "106.37px 281.836px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m120.18 278.47s-4 1.74-8.94 3.81-9 3.74-9 3.71 4-1.74 8.94-3.82 8.99-3.74 9-3.7z",
    fill: "#263238",
    style: {
      transformOrigin: "111.21px 282.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m120.58 280s-3.94 1.72-8.83 3.77-8.87 3.69-8.89 3.66 3.94-1.72 8.84-3.77 8.87-3.66 8.88-3.66z",
    fill: "#263238",
    style: {
      transformOrigin: "111.72px 283.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m113.91 284.46s-2.32 1-5.21 2.25-5.24 2.17-5.25 2.14 2.32-1 5.21-2.26 5.24-2.17 5.25-2.13z",
    fill: "#263238",
    style: {
      transformOrigin: "108.68px 286.655px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 97.33,
    y: 296.67,
    width: 7.24,
    height: 7.24,
    fill: "#f90",
    style: {
      transformOrigin: "100.95px 300.29px",
      transform: "rotate(-22.76deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m116 290.88s-2.2 1-5 2.15-5 2.07-5 2 2.21-1 5-2.15 5-2.03 5-2z",
    fill: "#263238",
    style: {
      transformOrigin: "111px 292.957px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m124.85 289.59s-4 1.74-8.94 3.82-9 3.74-9 3.71 4-1.74 8.94-3.82 8.98-3.74 9-3.71z",
    fill: "#263238",
    style: {
      transformOrigin: "115.88px 293.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m125.25 291.14s-3.94 1.72-8.83 3.78-8.88 3.69-8.89 3.66 3.94-1.72 8.84-3.78 8.87-3.69 8.88-3.66z",
    fill: "#263238",
    style: {
      transformOrigin: "116.39px 294.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m118.58 295.58s-2.32 1-5.21 2.25-5.24 2.17-5.25 2.14 2.31-1 5.2-2.25 5.25-2.17 5.26-2.14z",
    fill: "#263238",
    style: {
      transformOrigin: "113.35px 297.775px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 101.99,
    y: 307.8,
    width: 7.24,
    height: 7.24,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "105.61px 311.42px",
      transform: "rotate(-22.76deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m120.7 302s-2.21 1-5 2.15-5 2.07-5 2 2.21-1 5-2.15 4.99-2 5-2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "115.7px 304.077px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m129.52 300.72s-4 1.74-8.94 3.82-9 3.73-9 3.7 4-1.74 8.94-3.82 8.98-3.73 9-3.7z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "120.55px 304.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m129.92 302.27s-3.92 1.73-8.84 3.73-8.87 3.7-8.88 3.67 3.94-1.73 8.84-3.78 8.87-3.65 8.88-3.62z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "121.06px 305.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m123.25 306.71s-2.32 1-5.21 2.25-5.24 2.17-5.25 2.14 2.31-1 5.2-2.25 5.24-2.17 5.26-2.14z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "118.02px 308.905px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "100.97px 300.35px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 97.35,
    y: 296.73,
    width: 7.24,
    height: 7.24,
    style: {
      transformOrigin: "100.97px 300.35px",
      transform: "rotate(-22.76deg)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "91.61px 278.04px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 87.99,
    y: 274.42,
    width: 7.24,
    height: 7.24,
    style: {
      transformOrigin: "91.61px 278.04px",
      transform: "rotate(-22.76deg)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "362.55px 225.865px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m346.52 198.52-12.25 39.78c3.38 4.15 7 8.11 13.28 10.07l30.28 8.33 11.75-47z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "361.925px 227.61px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "345 195.85 332.76 235.63 346.03 245.7 376.31 254.03 389.74 209.11",
    fill: "#f90",
    style: {
      transformOrigin: "361.25px 224.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m338.7 234-5.94 1.62a17.9 17.9 0 0 0 4.6 5.69 25.63 25.63 0 0 0 8.64 4.39 17.21 17.21 0 0 1-7.3-11.7z",
    fill: "#f90",
    style: {
      transformOrigin: "339.38px 239.85px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "339.38px 239.85px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m338.7 234c-2.36 1.28-5 2.88-5.94 1.62a17.9 17.9 0 0 0 4.6 5.69 25.63 25.63 0 0 0 8.64 4.39 17.21 17.21 0 0 1-7.3-11.7z",
    style: {
      transformOrigin: "339.38px 239.85px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "339.5 204.12 361.16 199.58 360.24 195.03 338.26 199.22",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "349.71px 199.575px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "392.34 220.4 380.34 201.8 376.42 204.3 388.21 223.31",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "384.38px 212.555px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m380.54 221.83c0 0.08-7.65-2.11-17-4.89s-17-5.09-17-5.17 7.65 2.12 17.05 4.9 16.97 5.09 16.95 5.16z",
    fill: "#263238",
    style: {
      transformOrigin: "363.54px 216.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m378.58 227.92c0 0.08-7.66-2.11-17.05-4.89s-17-5.09-17-5.17 7.66 2.12 17.05 4.9 17.02 5.09 17 5.16z",
    fill: "#263238",
    style: {
      transformOrigin: "361.555px 222.89px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m377.16 233.42c0 0.07-7.65-2.12-17.05-4.9s-17-5.09-17-5.16 7.65 2.12 17 4.89 17.07 5.09 17.05 5.17z",
    fill: "#263238",
    style: {
      transformOrigin: "360.135px 228.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m375.58 238.64c0 0.08-7.66-2.11-17.05-4.89s-17-5.09-17-5.17 7.65 2.12 17.05 4.9 17.02 5.09 17 5.16z",
    fill: "#263238",
    style: {
      transformOrigin: "358.555px 233.61px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "209.035px 73.82px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 219.69,
    y: 34.7,
    width: 31.97,
    height: 39.99,
    fill: "#ebebeb",
    style: {
      transformOrigin: "235.675px 54.695px",
      transform: "rotate(-88.91deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M256,39.1h-.76l-2.17,0-8.19-.13L216,38.44l.11-.1c-.18,9.51-.38,20.42-.6,32h0l-.11-.12,40,.79-.1.09c.21-9.62.37-17.6.49-23.18.07-2.79.12-5,.15-6.48,0-.75,0-1.32,0-1.71l0-.59v.57c0,.39,0,.95,0,1.69,0,1.5-.06,3.68-.1,6.46-.1,5.59-.23,13.59-.4,23.24v.1h-.09l-40-.74h-.11V70.3h0c.22-11.54.43-22.44.62-32v-.1H216l28.93.6,8.16.19,2.16,0,.55,0Z",
    fill: "#263238",
    style: {
      transformOrigin: "235.62px 54.7px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 221.68,
    y: 36.11,
    width: 27.95,
    height: 37.18,
    fill: "#f90",
    style: {
      transformOrigin: "235.655px 54.7px",
      transform: "rotate(-88.91deg)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "235.385px 60.105px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "216.8 68.31 230.12 51.19 237.95 62.21 243.52 56.51 253.97 69.02",
    style: {
      transformOrigin: "235.385px 60.105px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "238.681px 49.2094px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m241.61 49.28a2.93 2.93 0 1 1-2.87-3 2.93 2.93 0 0 1 2.87 3z",
    style: {
      transformOrigin: "238.681px 49.2094px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 168.08,
    y: 57.45,
    width: 60.43,
    height: 48.31,
    fill: "#ebebeb",
    style: {
      transformOrigin: "198.295px 81.605px",
      transform: "rotate(-7.15deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M225.27,53.87l-.29.05-.84.11-3.26.43L208.61,56l-43.28,5.51.13-.18c1.8,14.27,3.86,30.63,6,47.93h0l-.19-.15,60-7.5-.13.17c-1.78-14.44-3.25-26.41-4.28-34.78-.51-4.19-.91-7.47-1.18-9.72-.14-1.12-.24-2-.31-2.56s-.09-.9-.09-.9l.12.86c.08.58.19,1.43.33,2.53.29,2.24.72,5.51,1.26,9.68,1.07,8.39,2.6,20.38,4.44,34.85l0,.15h-.14l-60,7.55-.17,0,0-.17h0c-2.17-17.31-4.21-33.67-6-47.94l0-.15.16,0,43.4-5.37,12.25-1.49,3.23-.39.82-.09Z",
    fill: "#263238",
    style: {
      transformOrigin: "198.275px 81.63px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 170.16,
    y: 60.49,
    width: 56.18,
    height: 42.23,
    fill: "#f90",
    style: {
      transformOrigin: "198.25px 81.605px",
      transform: "rotate(-7.15deg)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "200.88px 91.805px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "173.01 106.05 189.21 77.56 203.32 92.35 210.41 82.61 228.75 99.06",
    style: {
      transformOrigin: "200.88px 91.805px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "201.614px 72.7652px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m206 72.22a4.42 4.42 0 1 1-4.94-3.84 4.42 4.42 0 0 1 4.94 3.84z",
    style: {
      transformOrigin: "201.614px 72.7652px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "172.83 54.69 162.07 68.73 164.58 72.57 177.22 56.43",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "169.645px 63.63px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "232.61 90.94 221.86 104.98 224.37 108.81 237 92.68",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "229.43px 99.875px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignInspirationAnimate);
export default __webpack_public_path__ + "static/media/design-inspiration-animate.13fa12ec95965fed42e6405b81be81fd.svg";
export { ForwardRef as ReactComponent };